import { toast } from "react-toastify";
import { baseURL } from "../components/BaseUrl";
import * as types from "./actionType";
import Swal from "sweetalert2";
import * as HeaderAuthentication from '../../src/components/HeaderAuthentication'
// import { ADDED_BY_ID, Company_Code, Company_ID } from "../components/Constants";
import moment from "moment";
import CryptoJS from "crypto-js";
import { ADDED_BY_ID, Company_Code, Company_ID } from "../Constants";
// import { signInDetails } from '../components/StoredSessionData'

const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
const storedEmail = signInDetails ? signInDetails[0]?.EmailID : null;
const storedSignInType = signInDetails ? signInDetails[0]?.SignInType : null;
const storedUserName = signInDetails ? signInDetails[0]?.UserName : null;

// Module Permissions
export const getRoleBasedModulePermissions = (modulePermissions) => ({
    type: types.get_Role_Based_Module_Permissions,
    payload: modulePermissions,
});
// Module Permissions

// SideMenu
export const getSidemenus = (sideMenus) => ({
    type: types.get_SideMenus,
    payload: sideMenus,
});
// SideMenu

// SignIn Page
const postSignInData = () => ({
    type: types.post_SignIn_Data,
})
const postResendOtpData = () => ({
    type: types.post_resendOtp_Data,
})
const setSignInDetails = (signInDetails) => ({
    type: types.SET_SIGNIN_DETAILS,
    payload: signInDetails,
});
// SignIn Page

// Verify Company
const postResendVerifyCompanyEmail = () => ({
    type: types.post_Resend_Verify_Email,
})
// Verify Company

// Forgot Password 
const postForgotPasswordEmail = () => ({
    type: types.post_Forgot_Password,
})
// Forgot Password 

// Reset Password
const postResetPasswordData = () => ({
    type: types.post_Reset_Password,
})
// Reset Password

// Total Data Count
export const getToataldataCount = (totalDataCount) => ({
    type: types.Get_Total_Data_Count,
    payload: totalDataCount,
});
// Total Data Count

// Switch To Client
export const postSwitchToClientData = () => ({
    type: types.post_Switch_To_Client
})
// Switch To Client

// SignIn generate token
export const getSignInToken = (signInToken) => ({
    type: types.get_SignIn_Token,
    payload: signInToken,
})
// SignIn generate token

// Switch To SuperAdmin
export const postSwitchToSuperAdminData = () => ({
    type: types.post_Switch_To_SuperAdmin
})
// Switch To SuperAdmin

// Profile Settings Set Password
export const postUpdateProfileSettingsDta = () => ({
    type: types.update_Profile_Data,
});
export const postProfileSettingsSetPassword = () => ({
    type: types.post_Profile_Settings_Set_Password,
});
const getProfileDetailsData = (getProfileDetails) => ({
    type: types.get_Profile_Details,
    payload: getProfileDetails,
});
const getTimeZoneDropdownData = (getTimeZoneDropdown) => ({
    type: types.get_TimeZone_Dropdown,
    payload: getTimeZoneDropdown,
});
const getProfilePasswordChangeOtp = (getProfilePasswordOtp) => ({
    type: types.get_Profile_Password_Otp,
    payload: getProfilePasswordOtp,
});
// Profile Settings Set Password

// Customer Management
const postCustomerManagementData = () => ({
    type: types.post_Customer_Data,
});
const postCustomFieldValuesForCompany = () => ({
    type: types.post_Custom_Fields_Value_For_Company,
});
const getAssignedModulesDropdownData = (assignedModulesDropdown) => ({
    type: types.get_Assigned_Modules,
    payload: assignedModulesDropdown,
});
const getCompanyData = (companyData) => ({
    type: types.get_Company_Data,
    payload: companyData,
});
const downloadCompanyData = (companyDataDownload) => ({
    type: types.download_Company_Data,
    payload: companyDataDownload,
});
const getSingleCompanyData = (singleCustomerData) => ({
    type: types.get_Single_Company_Data,
    payload: singleCustomerData,
});
const getCountryCodeDropdownData = (getCountryCodeDropdownData) => ({
    type: types.get_Country_Code,
    payload: getCountryCodeDropdownData,
});
const getCompanyDropdownData = (getCompanyDropdown) => ({
    type: types.get_Company_Dropdown,
    payload: getCompanyDropdown,
});
const getGeneratedCompanyCode = (getGeneratedCompanyCode) => ({
    type: types.get_generated_Company_Code,
    payload: getGeneratedCompanyCode,
});
const getCustomFieldsForCompany = (getCompanyCustomFields) => ({
    type: types.get_Custom_Fields_For_Company,
    payload: getCompanyCustomFields,
});
const getCustomerClassificationDropdownData = (getCustomerClassificationDropdown) => ({
    type: types.get_Customer_Classification_Dropdown,
    payload: getCustomerClassificationDropdown,
});
const getCustomerDashboardCardsData = (getCustomerDashboardCardData) => ({
    type: types.get_Customer_Dashboard_CardData,
    payload: getCustomerDashboardCardData,
});
const getCustomerDetailsChartData = (getCustomerDetailsChartData) => ({
    type: types.get_Customer_Details_ChartData,
    payload: getCustomerDetailsChartData,
});
const getCustomerDashboardRelationshipTypeChartData = (getCustomerDashboardRelationShipTypeData) => ({
    type: types.get_Customer_Dashboard_RelationShipType_Chart,
    payload: getCustomerDashboardRelationShipTypeData,
});
const getCustomerDashboardLicenceSplitUpChartData = (getCustomerDashboardLicenceSplitUpData) => ({
    type: types.get_Customer_Dashboard_LicenceSplitUp_Data,
    payload: getCustomerDashboardLicenceSplitUpData,
});
const getCustomerDashboardStatusChartData = (getCustomerDashboardStatusChartData) => ({
    type: types.get_Customer_Dashboard_Status_ChartData,
    payload: getCustomerDashboardStatusChartData,
});
const getCustomerDashboardAssignedModulesData = (getCustomerDashboardAssignedModulesData) => ({
    type: types.get_Customer_Dashborad_AssignedModules_Data,
    payload: getCustomerDashboardAssignedModulesData,
});
const getCustomerDashboardNoOfLicencesChartData = (getCustomerDashboardNoofLicenceChartData) => ({
    type: types.get_Customer_Dashboard_NoOfLicence_ChartData,
    payload: getCustomerDashboardNoofLicenceChartData,
});
const getCustomerModuleFieldNameData = (customerModuleFieldDropdownData) => ({
    type: types.get_Customer_ModuleField_Dropdown,
    payload: customerModuleFieldDropdownData,
});
const getCustomFieldsForCustomers = (customFieldsForCustomers) => ({
    type: types.get_Custom_Fields_For_Customers,
    payload: customFieldsForCustomers
})
const getCustomerCustomFieldData = (customerCustomFieldData) => ({
    type: types.get_Customer_CustomField_Data,
    payload: customerCustomFieldData
})
// Customer Management

// User Management
const getUserManagementData = (userData) => ({
    type: types.get_User_Data,
    payload: userData,
});
const getSingleUserManagementData = (singleUserData) => ({
    type: types.get_Single_User_Data,
    payload: singleUserData,
});
const getRoleDropdown = (rolesDropdown) => ({
    type: types.get_Role_Dropdown_Data,
    payload: rolesDropdown,
});
const getReportingToDropdown = (reportingToDropdown) => ({
    type: types.get_ReportingTo_Dropdown_Data,
    payload: reportingToDropdown,
});
const postUserManagementData = () => ({
    type: types.post_User_Data,
});
const postUserManagementSlocData = () => ({
    type: types.post_User_Sloc_Data,
});
const postUserManagementPlantData = () => ({
    type: types.post_User_Plant_Data,
});
const getSlocDropdown = (slocDropdown) => ({
    type: types.get_Sloc_Dropdown_Data,
    payload: slocDropdown,
});
const getBranchDropdown = (branchDropdown) => ({
    type: types.get_Branch_Dropdown_Data,
    payload: branchDropdown,
});
const getBusinessUnitDropdown = (businessUnitDropdown) => ({
    type: types.get_BusinessUnit_Dropdown_Data,
    payload: businessUnitDropdown,
});
const getCustomFieldsForUser = (getUserCustomFields) => ({
    type: types.get_Custom_Fields_For_Users,
    payload: getUserCustomFields,
});
const getUserDropdown = (getUserDropdown) => ({
    type: types.get_User_Dropdown,
    payload: getUserDropdown,
});
const getLicenceDashboardCardData = (getLicenceDashboardCardData) => ({
    type: types.get_Licence_Dashboard_CardData,
    payload: getLicenceDashboardCardData,
});
const getUsersModuleFieldNameData = (usersModuleFieldDropdownData) => ({
    type: types.get_Users_ModuleField_Dropdown,
    payload: usersModuleFieldDropdownData,
});
const getUsersCustomFieldData = (getUserCustomFieldData) => ({
    type: types.get_User_CustomField_Data,
    payload: getUserCustomFieldData,
});
const getLicenceDashboardLicenceStatusChartDataData = (getLicenseDashboardLicenceStatusData) => ({
    type: types.get_User_Dashboard_Licence_Status_Data,
    payload: getLicenseDashboardLicenceStatusData,
});
const getLicenceDashboardBarchartLicenceDetailsData = (getLicenceDashboardBarChartlicenceDetailsData) => ({
    type: types.get_Licence_Dashboard_BarChart_Licence_Details_Data,
    payload: getLicenceDashboardBarChartlicenceDetailsData,
});
const getLicenceDashboardBarchartLicenceSplitUpData = (getLicenceDashboardBarChartLicenceSplitUpData) => ({
    type: types.get_Licence_Dashboard_BarChart_Licence_Split_Up_Data,
    payload: getLicenceDashboardBarChartLicenceSplitUpData,
});
const postUserManagementBulkData = () => ({
    type: types.post_User_Management_Bulk_Upload_Data,
})
const getUserManagementBulkUploadTemplate = () => ({
    type: types.get_User_Management_Bulk_Upload_Template
})
// User Management

// Complaint/Escalation 
const getComplainEscalationData = (complainEscalationData) => ({
    type: types.get_Complaint_Data,
    payload: complainEscalationData,
});
const getSingleComplainEscalationData = (singleComplaintEscalationData) => ({
    type: types.get_Single_Complaint_Data,
    payload: singleComplaintEscalationData,
});
const getIssueTypeDropdownData = (issueTypeDropdownData) => ({
    type: types.get_IssueType_Dropdown_Data,
    payload: issueTypeDropdownData,
});
const postComplaintEscalationData = () => ({
    type: types.post_Complaint_Escalation_Data,
});
const postAssignComplaintEscalationData = () => ({
    type: types.post_Assign_Complaint_Data,
});
const postComplaintEscalationChangeStatusData = () => ({
    type: types.post_Complaint_Escalation_Status_Change,
});
const postUploadFile = () => ({
    type: types.upload_File,
});
const getComplaintEscalationsDashboardCardData = (complaintEscalationDashboardCardData) => ({
    type: types.get_Complaint_Escalation_Dashboard_CardData,
    payload: complaintEscalationDashboardCardData,
});
const getComplaintEscalationsBarChartTicketData = (complaintEscalationBarChartTicketData) => ({
    type: types.get_Complaint_Escalation_Ticket_Data,
    payload: complaintEscalationBarChartTicketData,
});
const getComplaintEscalationsPriorityStatusData = (complaintEscalationPriorityStatusData) => ({
    type: types.get_Complaint_Escalation_PriorityStatus_Data,
    payload: complaintEscalationPriorityStatusData,
});
const getComplaintEscalationsStatusData = (complaintEscalationStatusData) => ({
    type: types.get_Complaint_Escalation_Status_Data,
    payload: complaintEscalationStatusData,
});
const getComplaintEscalationsBranchStatusData = (complaintEscalationBranchStatusData) => ({
    type: types.get_Complaint_Escalation_BranchStatus_Data,
    payload: complaintEscalationBranchStatusData,
});
const getComplaintEscalationsIssueTypeData = (complaintEscalationIssueTypeData) => ({
    type: types.get_Complaint_Escalation_IssueType_Data,
    payload: complaintEscalationIssueTypeData,
});
const getComplaintEscalationModuleFieldNameData = (complaintEscalationModuleFieldDropdownData) => ({
    type: types.get_Complaint_Escalation_ModuleField_Dropdown,
    payload: complaintEscalationModuleFieldDropdownData,
});
const getComplaintEscalationStatusDropdownData = (complaintEscalationStatusDropdownData) => ({
    type: types.get_Complaint_Status_Dropdown,
    payload: complaintEscalationStatusDropdownData,
});
const getComplaintEscalationHistoryData = (complaintEscalationHistoryData) => ({
    type: types.get_Complaint_History_Data,
    payload: complaintEscalationHistoryData,
});
const getTechnicalData = (technicalData) => ({
    type: types.get_Technical_Data,
    payload: technicalData,
});
const getQAData = (QAData) => ({
    type: types.get_QA_Data,
    payload: QAData,
});
const getUserSlocsDropdownData = (userSlocsDropdown) => ({
    type: types.get_User_Slocs_Dropdown,
    payload: userSlocsDropdown
})
const getComplaintCustomFieldData = (getComplaintCustomFieldData) => ({
    type: types.get_Complaint_CustomField_Data,
    payload: getComplaintCustomFieldData
})
const postComplaintEscalationERTData = () => ({
    type: types.post_Complaint_Escalation_ERT_Data,
});
// Complaint/Escalation 

// Service Level Agreement
const getAssignedToServiceLevelAgreementData = (assignedToSlaData) => ({
    type: types.get_AssignedTo_SLA_Data,
    payload: assignedToSlaData,
});
const getSingleAssignedToServiceLevelAgreementData = (singleAssignedToSlaData) => ({
    type: types.get_Single_AssignedTo_SLA_Data,
    payload: singleAssignedToSlaData,
});
const getAssignedToServiceLevelAgreementDropdownData = (assignedToSlaTypeDropdownData) => ({
    type: types.get_AssignedTo_SLA_Type_Dropdown,
    payload: assignedToSlaTypeDropdownData,
});
const getServiceLevelAgreementCategoryDropdownData = (getSlaCategoryDropdown) => ({
    type: types.get_SLA_Category_Dropdown,
    payload: getSlaCategoryDropdown,
});
const postAssignedToServiceLevelAgreementData = () => ({
    type: types.post_AssignedTo_SLA_Data,
});
const getServiceLevelAgreementDashboardCardData = (getSlaDashboardCardData) => ({
    type: types.get_SLA_Dashboard_CardData,
    payload: getSlaDashboardCardData,
});
const getServiceLevelAgreementDashboardSlaTypeStatusData = (getSlaDashboardSlaTypeStatusChartData) => ({
    type: types.get_SLA_Dashboard_SLA_Type_Status_Chart_Data,
    payload: getSlaDashboardSlaTypeStatusChartData,
});
const getServiceLevelAgreementDashboardSlaTypesData = (getSlaDashboardSlaTypesChartData) => ({
    type: types.get_SLA_Dashboard_SLA_Types_Chart_Data,
    payload: getSlaDashboardSlaTypesChartData,
});
const getServiceLevelAgreementAssignedScoreData = (getSlaDashboardAssignedScoreData) => ({
    type: types.get_SLA_Dashboard_AssignedScore_Data,
    payload: getSlaDashboardAssignedScoreData,
});
const getServiceLevelAgreementTotalSlaChartData = (getSlaDashboardTotalSlaChartData) => ({
    type: types.get_SLA_Dashboard_Total_SLA_Chart_Data,
    payload: getSlaDashboardTotalSlaChartData,
});
const getServiceLevelAgreementDashboardChecklistStatusChartData = (getSlaDashboardChecklistStatusChartData) => ({
    type: types.get_SLA_Dashboard_Checklist_Status_Chart_Data,
    payload: getSlaDashboardChecklistStatusChartData,
});
const getAssignToSlaModuleFieldDropdownData = (assignToSlaModuleFieldDropdownData) => ({
    type: types.get_AssignTo_SLA_ModuleField_Dropdown,
    payload: assignToSlaModuleFieldDropdownData,
});
const getUpdateSlaData = (updateSlaData) => ({
    type: types.get_Update_SLA_Data,
    payload: updateSlaData,
});
const getComplaintsCustomFields = (customFieldsForComplaints) => ({
    type: types.get_Custom_Fields_For_Complaints,
    payload: customFieldsForComplaints,
});
const postUpdateSla = () => ({
    type: types.post_Update_SLA_Data,
})
// Service Level Agreement

// Workqueues
const getWorkqueuesData = (workqueuesData) => ({
    type: types.get_Workqueue_Data,
    payload: workqueuesData,
});
const getSingleWorkqueuesData = (singleWorkqueuesData) => ({
    type: types.get_Single_Workqueue_Data,
    payload: singleWorkqueuesData,
});
const updateWorkqueuesPriorityStatusData = () => ({
    type: types.update_Workqueue_Priority_Status,
})
const postSetAssignToData = () => ({
    type: types.post_Set_AssignTo_Data,
})
const getUserdropdownBasedOnDepartment = (userDropdownBasedDepartment) => ({
    type: types.get_User_Dropdown_Based_Department,
    payload: userDropdownBasedDepartment,
});
const getUserReportingDesignationDropdown = (getUserReportingDesignationDropdown) => ({
    type: types.get_User_Reporting_Designation_Dropdown,
    payload: getUserReportingDesignationDropdown,
});
const getWorkqueueModuleFieldNameData = (getWorkqueueModuleFieldDropdown) => ({
    type: types.get_Workqueue_ModuleField_Dropdown,
    payload: getWorkqueueModuleFieldDropdown,
});
const getViewAssignedWorkqueueData = (getViewAssignedWorkqueueData) => ({
    type: types.get_View_Assigned_Workqueue_Data,
    payload: getViewAssignedWorkqueueData,
});
// Workqueues

// Leave and Holiday
const getLeaveBalanceData = (leaveBalanceData) => ({
    type: types.get_Leave_Balance_Data,
    payload: leaveBalanceData,
})
const getSingleLeaveBalanceData = (singleLeaveBalanceData) => ({
    type: types.get_Single_Leave_Balance_Data,
    payload: singleLeaveBalanceData,
})
const getLeaveData = (leaveData) => ({
    type: types.get_Leave_Data,
    payload: leaveData,
})
const getPendingLeaveData = (pendingLeaveData) => ({
    type: types.get_Pending_Leave_Data,
    payload: pendingLeaveData,
})
const getApprovedLeaveData = (approvedLeaveData) => ({
    type: types.get_Approved_Leave_Data,
    payload: approvedLeaveData,
})
const getRejectedLeaveData = (rejectedLeaveData) => ({
    type: types.get_Rejected_Leave_Data,
    payload: rejectedLeaveData,
})
const postLeaveBalanceData = () => ({
    type: types.post_Leave_Balance_Data,
})
const postApplyLeaveData = () => ({
    type: types.post_Apply_Leave,
})
const postUpdateLeaveData = () => ({
    type: types.update_Leave_Status,
})
const getSingleLeaveData = (singleLeaveData) => ({
    type: types.get_Single_Leave_Data,
    payload: singleLeaveData,
})
const getLeavesCount = (leavesCount) => ({
    type: types.get_Leaves_Count,
    payload: leavesCount,
})
const getLeaveBalanceCount = (leaveBalanceCount) => ({
    type: types.get_Leave_Balance_Count,
    payload: leaveBalanceCount
})
const getLeaveDuration = (leaveDuration) => ({
    type: types.get_Leave_duration,
    payload: leaveDuration
})
// Leave and Holiday

// System Logging
const getModuleNameForSystemLogging = (getModuleNameForSystemLogging) => ({
    type: types.get_ModuleName_For_SystemLogging,
    payload: getModuleNameForSystemLogging,
})
// Exception Log
const getExceptionLoggingData = (getExceptionLoggingData) => ({
    type: types.get_Exception_Logging_Data,
    payload: getExceptionLoggingData,
})
const getSingleExceptionLoggingData = (getSingleExceptionLoggingData) => ({
    type: types.get_Single_Exception_Logging_Data,
    payload: getSingleExceptionLoggingData,
})
// Exception Log

// Audit Trial
const getAuditTrialData = (getAuditTrialData) => ({
    type: types.get_Audit_Trial_Data,
    payload: getAuditTrialData,
})
const downloadAuditTrialData = (downloadAuditTrialData) => ({
    type: types.download_Audit_Trial_Data,
    payload: downloadAuditTrialData,
})
// Audit Trial

// System Logging

// Settings Department
const postDepartmentData = () => ({
    type: types.post_Department_Data
})
const getDepartmentData = (departmentData) => ({
    type: types.get_Department_Data,
    payload: departmentData,
});
const getSingleDepartmentData = (singleDepartmentData) => ({
    type: types.get_Single_Department_Data,
    payload: singleDepartmentData,
})
const getDepartmentModuleFieldNameData = (departmentModulefieldDropdown) => ({
    type: types.get_Department_ModuleField_Dropdown,
    payload: departmentModulefieldDropdown,
})
const postDepartmentBulkUploadData = () => ({
    type: types.post_Department_Bulk_Upload_Data
})
// Settings Department

// Settings Customer Classification
const postCustomerClassificationData = () => ({
    type: types.post_Customer_Classification_Data
})

const getCustomerClassificationData = (customerClassificationData) => ({
    type: types.get_Customer_Classification_Data,
    payload: customerClassificationData,
})
const getSingleCustomerClassificationData = (singleCustomerClassificationData) => ({
    type: types.get_Single_Customer_Classification_Data,
    payload: singleCustomerClassificationData,
})
const getCustomerClassificationModuleFieldNameData = (customerClassificationModuleFieldDropdown) => ({
    type: types.get_Customer_Classification_ModuleField_Dropdown,
    payload: customerClassificationModuleFieldDropdown,
});
const postCustomerClassificationBulkData = () => ({
    type: types.post_Customer_Classification_Bulk_Upload_Data
});
// Settings Customer Classification

// Settings Designation
const getDesignationData = (designationData) => ({
    type: types.get_Designation_Data,
    payload: designationData
})
const postDesignationData = () => ({
    type: types.post_Designation_Data
})
const getDepartmentDropdownData = (departmentDropdown) => ({
    type: types.get_Department_Dropdown,
    payload: departmentDropdown,
});
const getReportingDesignationDropdownData = (reportingDesignationDropdown) => ({
    type: types.get_Reporting_Designation_Dropdown,
    payload: reportingDesignationDropdown,
});
const getSingleDesignationData = (singleDesignationData) => ({
    type: types.get_Single_Designation_Data,
    payload: singleDesignationData,
});
const getDesignationModuleFieldNameData = (designationModuleFieldDropdown) => ({
    type: types.get_Designation_ModuleField_Dropdown,
    payload: designationModuleFieldDropdown,
});
const postDesignationBulkData = () => ({
    type: types.post_Designation_Bulk_Upload_Data
});
// Settings Designation

// Settings Issue Types
const getIssueTypesData = (issueTypesData) => ({
    type: types.get_Issue_Type_Data,
    payload: issueTypesData,
});
const getSingleIssueTypesData = (singleIssueTypesData) => ({
    type: types.get_Single_Issue_Types_Data,
    payload: singleIssueTypesData,
});
const postIssueTypesData = () => ({
    type: types.post_Issue_Types_Data,
});
const getIssueTypeModuleFieldNameData = (issueTypeModuleFieldDropdown) => ({
    type: types.get_Issue_Type_ModuleField_Dropdown,
    payload: issueTypeModuleFieldDropdown,
})
const postIssueTypeBulkData = () => ({
    type: types.post_Issue_Type_Bulk_Upload_Data,
})
// Settings Issue Types

// Settings SLA
const getSettingsSlaData = (SettingSlaData) => ({
    type: types.get_Settings_SLA_Data,
    payload: SettingSlaData,
})
const getSingleSettingsSlaData = (SingleSettingSlaData) => ({
    type: types.get_Single_Settings_SLA_Data,
    payload: SingleSettingSlaData,
})
const postSettingsSlaData = () => ({
    type: types.post_Settings_SLA_Data,
})
const getSlaCategoriesModuleFieldNameData = (slaCategoriesModuleFieldDropdown) => ({
    type: types.get_Settings_SLA_ModuleField_Dropdown,
    payload: slaCategoriesModuleFieldDropdown,
})
const postSlaCategoriesBulkUploadData = () => ({
    type: types.post_Sla_Categories_Bulk_Upload_Data,
})
// Settings SLA

// Settings Module
const getModuleData = (moduleData) => ({
    type: types.get_Module_Data,
    payload: moduleData,
})
const getSingleModuleData = (singleModuleData) => ({
    type: types.get_Single_Module_Data,
    payload: singleModuleData,
})
const postModuleData = () => ({
    type: types.post_Modules_Data,
})
// Settings Module

// Settings Sub Module
const getSubModuleData = (subModuleData) => ({
    type: types.get_Sub_Module_Data,
    payload: subModuleData,
})
const getSingleSubModuleData = (singleSubModuleData) => ({
    type: types.get_Single_Sub_Module_Data,
    payload: singleSubModuleData,
})
const getSubModuleDropdown = (subModuleDropdown) => ({
    type: types.get_SubModule_Dropdown,
    payload: subModuleDropdown,
})
const postSubModuleData = () => ({
    type: types.post_Sub_Modules_Data,
})
// Settings Sub Module

// Settings System Numbering
const getSystemNumberingData = (systemNumberingData) => ({
    type: types.get_System_Numbering,
    payload: systemNumberingData,
})
const getSingleSystemNumberingData = (singleSystemNumberingData) => ({
    type: types.get_Singel_System_Numbering,
    payload: singleSystemNumberingData,
})
const postSystemNumberingData = () => ({
    type: types.post_System_Numbering,
})
const getSystemNumberingModuleFieldNameData = (systemNumberingModuleFieldDropdown) => ({
    type: types.get_System_Numbering_ModuleField_Dropdown,
    payload: systemNumberingModuleFieldDropdown,
})
const postSystemNumberingBulkData = () => ({
    type: types.post_System_Numbering_Bulk_Upload_Data,
})
// Settings System Numbering

// Settings Work Queues Rules
const postSettingsWorkQueueData = () => ({
    type: types.post_Settings_WorkQueues_Rule_Data,
})
const postSettingsRunWorkQueueData = () => ({
    type: types.post_Run_WorkQueue_Data,
})
const getSystemWorkQueuesRulesData = (settingsWorkQueuesRulesData) => ({
    type: types.get_Settings_WorkQueues_Rule,
    payload: settingsWorkQueuesRulesData,
})
const getSettingsSingleWorkQueuesRulesData = (settingsSingleWorkQueuesRulesData) => ({
    type: types.get_Settings_Single_WorkQueues_Rule,
    payload: settingsSingleWorkQueuesRulesData,
})
const getSettingsWorkQueuesRulesFieldNameData = (getSettingsWorkQuesRulesFieldNameData) => ({
    type: types.get_Settings_WorkQueues_FieldName_Rule,
    payload: getSettingsWorkQuesRulesFieldNameData,
})
const getSettingsWorkQueuesRulesModuleFieldNameDataForValueFilter = (settingsWorkQueueRuleModuleFieldDropdown) => ({
    type: types.get_WorkQueue_Rule_ModuleField_Dropdown,
    payload: settingsWorkQueueRuleModuleFieldDropdown,
})
// Settings Work Queues Rules

// Settings Role
const getRolesDatas = (getRolesData) => ({
    type: types.get_Roles_Data,
    payload: getRolesData,
})
const getSingleRolesDatas = (getSingleRolesData) => ({
    type: types.get_Single_Roles_Data,
    payload: getSingleRolesData,
})
const getRolesModulesSubmodulesDatas = (getModulesSubmodulesData) => ({
    type: types.get_Modules_SubModules_Data,
    payload: getModulesSubmodulesData,
})
const getRolesModuleFieldNameData = (getRolesModuleFieldDropdownData) => ({
    type: types.get_Roles_ModuleField_Dropdown,
    payload: getRolesModuleFieldDropdownData,
})
const postRolesData = () => ({
    type: types.post_Roles_Data,
})
const getRolesAdvanceFilterDatas = (getRolesAdvanceFilterData) => ({
    type: types.get_Roles_Advance_Filter_Data,
    payload: getRolesAdvanceFilterData,
})
const postRolesBulkData = () => ({
    type: types.post_Roles_Bulk_Data,
})
// Settings Role

// Settings Custom Fields
const getCustomFieldsData = (getCustomFields) => ({
    type: types.get_CustomFields_Data,
    payload: getCustomFields,
})
const getSingleCustomFieldsData = (getSingleCustomFields) => ({
    type: types.get_Single_CustomFields_Data,
    payload: getSingleCustomFields,
})
const postCustomFieldsData = () => ({
    type: types.post_CustomFields_Data,
})
const getCustomFieldsModuleFieldNameData = (CustomFieldsModuleFieldDropdown) => ({
    type: types.get_CustomFields_ModuleField_Dropdown,
    payload: CustomFieldsModuleFieldDropdown,
})
const postCustomFieldsBulkData = () => ({
    type: types.post_CustomFields_Bulk_Upload_Data
})
// Settings Custom Fields

// Settings Leave Policy
const postLeavePolicyData = () => ({
    type: types.post_Leave_Policy_Data,
})
const getSettingsLeavePolicyData = (getLeavePolicyData) => ({
    type: types.get_Leave_Policy_Data,
    payload: getLeavePolicyData,
})
const getSettingsSingleLeavePolicyData = (getSingleLeavePolicyData) => ({
    type: types.get_Single_Leave_Policy_Data,
    payload: getSingleLeavePolicyData,
})
const getLeaveTypeDropdownData = (getLeaveTypeDropdown) => ({
    type: types.get_Leave_Type_Dropdown,
    payload: getLeaveTypeDropdown,
})
const getSettingsLeavePolicyModuleFieldNameDropdown = (getLeavePolicyModuleFieldDropdown) => ({
    type: types.get_Leave_Policy_ModuleField_Dropdown,
    payload: getLeavePolicyModuleFieldDropdown,
})
const postLeavePolicyBulkData = () => ({
    type: types.post_Leave_Policy_BulkUpload_Data
})
// Settings Leave Policy

// Settings Holiday Policy
const getSettingsHolidayPolicyData = (getHolidayPolicyData) => ({
    type: types.get_Holiday_Policy_Data,
    payload: getHolidayPolicyData,
})
const getSettingsSingleHolidayPolicyData = (getSingleHolidayPolicyData) => ({
    type: types.get_SingleHoliday_Policy_Data,
    payload: getSingleHolidayPolicyData,
})
const postHolidayPolicyData = () => ({
    type: types.post_Holiday_Policy_Data,
})
const getCountryNameDropdown = (getCountryNameDropdown) => ({
    type: types.get_Country_Name_Dropdown,
    payload: getCountryNameDropdown,
})
const getHolidayNameDropdownData = (getHolidayNameDropdown) => ({
    type: types.get_Holiday_Name_Dropdown,
    payload: getHolidayNameDropdown,
})
const getSettingsHolidayPolicyModuleFieldNameDropdown = (getHolidayPolicyModuleFieldDropdown) => ({
    type: types.get_Holiday_Policy_ModuleField_Dropdown,
    payload: getHolidayPolicyModuleFieldDropdown,
})
const postHolidayPolicyBulkData = () => ({
    type: types.post_Holiday_Policy_BulkUpload_Data
})
// Settings Holiday Policy

// Settings Financial Approval
const getFinancialApprovalData = (financialApprovalData) => ({
    type: types.get_Financial_Approval_Data,
    payload: financialApprovalData,
})
const getSingleFinancialApprovalData = (singleFinancialApprovalData) => ({
    type: types.get_Single_Financial_Approval_Data,
    payload: singleFinancialApprovalData,
})
const postFinancialApprovalData = () => ({
    type: types.post_Financial_Approval_Data,
})
const getApprovalLevelDropdownData = (approvalLevelDropdown) => ({
    type: types.get_Approval_Level_Dropdown,
    payload: approvalLevelDropdown,
})
const getSettingsFinancialApprovalModuleFieldNameDropdown = (financialApprovalModuleFieldDropdown) => ({
    type: types.get_Financial_Approval_ModuleField_Dropdown,
    payload: financialApprovalModuleFieldDropdown,
})
// Settings Financial Approval

// Settings Functional Approval
const getFunctionalApprovalData = (functionalApprovalData) => ({
    type: types.get_Functional_Approval_Data,
    payload: functionalApprovalData,
})
const getSingleFunctionalApprovalData = (singleFunctionalApprovalData) => ({
    type: types.get_Single_Functional_Approval_Data,
    payload: singleFunctionalApprovalData,
})
const postFunctionalApprovalData = () => ({
    type: types.post_Functional_Approval_Data,
})
const getSettingsFunctionalApprovalModuleFieldNameDataForValueFilter = (functionalApprovalModuleFieldDropdown) => ({
    type: types.get_Functional_Approval_ModuleField_Dropdown,
    payload: functionalApprovalModuleFieldDropdown,
})
// Settings Functional Approval

// Settings Leave Approval
const getLeaveApprovalData = (leaveApprovalData) => ({
    type: types.get_Leave_Approval_Data,
    payload: leaveApprovalData,
})
const getSingleLeaveApprovalData = (singleLeaveApprovalData) => ({
    type: types.get_Single_Leave_Approval_Data,
    payload: singleLeaveApprovalData,
})
const postLeaveApprovalData = () => ({
    type: types.post_Leave_Approval_Data,
})
const getSettingsLeaveApprovalModuleFieldNameDataForValueFilter = (leaveApprovalModuleFieldDropdown) => ({
    type: types.get_Leave_Approval_ModuleField_Dropdown,
    payload: leaveApprovalModuleFieldDropdown
})
// Settings Leave Approval

// Settings Escalation Approval
const getEscalationApprovalData = (escalationApprovalData) => ({
    type: types.get_Escalation_Approval_Data,
    payload: escalationApprovalData,
})
const getSingleEscalationApprovalData = (singleEscalationApprovalData) => ({
    type: types.get_Single_Escalation_Approval_Data,
    payload: singleEscalationApprovalData,
})
const getSettingsEscalationApprovalModuleFieldNameDataForValueFilter = (escalationApprovalModuleFieldDropdown) => ({
    type: types.get_Escalation_Approval_ModuleField_Dropdown,
    payload: escalationApprovalModuleFieldDropdown,
})
const postEscalationApprovalData = () => ({
    type: types.post_Escalation_Approval_Data,
})
// Settings Escalation Approval

// Settings Complaints Approval
const getComplaintsApprovalData = (complaintsApprovalData) => ({
    type: types.get_Complaints_Approval_Data,
    payload: complaintsApprovalData,
})
const getSingleComplaintsApprovalData = (singleComplaintsApprovalData) => ({
    type: types.get_Single_Complaints_Approval_Data,
    payload: singleComplaintsApprovalData,
})
const postComplaintsApprovalData = () => ({
    type: types.post_Complaints_Approval_Data,
})
const getSettingsComplaintsApprovalModuleFieldNameDataForValueFilter = (complaintApprovalModuleFieldDropdown) => ({
    type: types.get_Complaints_Approval_ModuleField_Dropdown,
    payload: complaintApprovalModuleFieldDropdown,
})
// Settings Complaints Approval

// Settings Organization Chart
const getOraganizationChart = (getOrganizationChart) => ({
    type: types.get_Organization_Chart,
    payload: getOrganizationChart,
})
// Settings Organization Chart

// Settings Menubar Enable and Disable
const getModuleSubModules = (getModuleSubModules) => ({
    type: types.get_Module_SubModules,
    payload: getModuleSubModules,
})
const postModuleSubModules = () => ({
    type: types.post_Modules_SubModules,
})
const postCustomFieldLabelChange = () => ({
    type: types.post_CustomField_Label_Change,
})
const getModuleFieldNames = (getModuleFieldsNames) => ({
    type: types.get_Module_Field_Names,
    payload: getModuleFieldsNames
})
const postModuleFieldNames = () => ({
    type: types.post_Module_Field_Names,
})
// Settings Menubar Enable and Disable

// Settings Dynamic Dashboard
const postDynamicDashboardData = () => ({
    type: types.post_Dynamic_Dashboard_Data,
})
const postDefaultDashboardData = () => ({
    type: types.post_Default_Dashboard_Data,
})
const getDynamicDashboard = (getDynamicDashboardData) => ({
    type: types.get_Dynamic_Dashboard_Data,
    payload: getDynamicDashboardData,
})
const getDynamicDashboardCategoryDropdown = (getDynamicDashboardCategoryDropdownData) => ({
    type: types.get_Dynamic_Dashboard_Catogery_Dropdown,
    payload: getDynamicDashboardCategoryDropdownData,
})
const getSingleDynamicDashboardData = (getSingleDynamicDashboardData) => ({
    type: types.get_Single_Dynamic_Dashboard_Data,
    payload: getSingleDynamicDashboardData,
})
const postDynamicDashboardBulkData = () => ({
    type: types.post_Dynamic_Dashboard_Bulk_Data
});
// Settings Dynamic Dashboard

// Settings Module Fields
const getModuleFieldData = (getModuleFieldData) => ({
    type: types.get_Module_Fields_Data,
    payload: getModuleFieldData,
})
const getSingleModuleFieldData = (getSingleModuleFieldData) => ({
    type: types.get_Single_Module_Field_Data,
    payload: getSingleModuleFieldData,
})
const getModuleFieldModulesDropdownData = (getModuleFieldModuleDropdownData) => ({
    type: types.get_Module_Field_Modules,
    payload: getModuleFieldModuleDropdownData,
})
const getModuleFieldForeignKeyColumnData = (getColumnNameData) => ({
    type: types.get_Column_Name,
    payload: getColumnNameData,
})
const postModuleFieldData = () => ({
    type: types.post_Module_Fields_Data,
})
// Settings Module Fields

// Module-2 7/5/2025
// Location Master
// Zone Master
const getZoneMasterData = (getZoneMasterData) => ({
    type: types.get_Zone_Master_Data,
    payload: getZoneMasterData,
})
const postZoneMasterData = () => ({
    type: types.post_Zone_Master_Data,
})
const getZoneMasterClassDropdownData = (getZoneClassDropdownData) => ({
    type: types.get_Zone_Class_Dropdown_Data,
    payload: getZoneClassDropdownData,
})
const getZoneMasterCategoryDropdownData = (getZoneCategoryDropdownData) => ({
    type: types.get_Zone_Category_Dropdown_Data,
    payload: getZoneCategoryDropdownData,
})
const getZoneMasterParentCodeDropDownData = (getParentCodeDropdownData) => ({
    type: types.get_ParentCode_Dropdown_Data,
    payload: getParentCodeDropdownData,
})
const getSingleZoneMasterData = (getSingleZoneMasterData) => ({
    type: types.get_Single_Zone_Master_Data,
    payload: getSingleZoneMasterData,
})
// Zone Master
// Storage Type Master
const getStorageTypeMasterData = (getStorageTypeMasterData) => ({
    type: types.get_Storage_Type_Master_Data,
    payload: getStorageTypeMasterData
})
const getSingleStorgeTypeMasterData = (getSingleStorageTypeMasterData) => ({
    type: types.get_Single_Storage_Type_Master_Data,
    payload: getSingleStorageTypeMasterData
})
const postStorageTypeMasterData = () => ({
    type: types.post_Storage_Type_Master_Data
})
// Storage Type Master
// Bin Master
const getBinMasterDatas = (getBinMasterData) => ({
    type: types.get_Bin_Master_Data,
    payload: getBinMasterData
})
const getSingleBinMasterDatas = (getSinleBinMasterData) => ({
    type: types.get_Single_Bin_Master_Data,
    payload: getSinleBinMasterData
})
const getUomDropdownData = (uomDropdownData) => ({
    type: types.get_Uom_Dropdown_Data,
    payload: uomDropdownData
})
const getWeightUomDropdownData = (weightUomDropdownData) => ({
    type: types.get_Weight_Uom_Dropdown_Data,
    payload: weightUomDropdownData
})
const getStorageTypeDropdownData = (storageTypeDropdown) => ({
    type: types.get_Storage_Type_Dropdown_Data,
    payload: storageTypeDropdown
})
const getBinLevelDropdownData = (binLevelDropdown) => ({
    type: types.get_Bin_Level_Dropdown_Data,
    payload: binLevelDropdown
})
const postBinMasterData = () => ({
    type: types.post_Bin_Master_Data,
})
const downloadBinMaster = (downloadBinMasterData) => ({
    type: types.download_Bin_Master_Data,
    payload: downloadBinMasterData
})
// Bin Master
// Location Master

// Standards Master
// MRP Type
const getMrpTypeData = (mrpTypeData) => ({
    type: types.get_Mrp_Type_Data,
    payload: mrpTypeData
})
const getSingleMrpTypeData = (singleMrpTypeData) => ({
    type: types.get_Single_Mrp_Type_Data,
    payload: singleMrpTypeData
})
const postMrpTypeData = () => ({
    type: types.post_Mrp_Type_Data,
})
// MRP Type
// Unit of Measure
const getUnitOfMeasuredata = (unitOfMeasureData) => ({
    type: types.get_Unit_Of_Measure_Data,
    payload: unitOfMeasureData
})
const getSingleUomData = (singleUnitOfMeasure) => ({
    type: types.get_Single_Unit_Of_Measure_Data,
    payload: singleUnitOfMeasure
})
const postUomData = () => ({
    type: types.post_Unit_Of_Measure_Data
})
const getUomClassDropdownData = (unitOfMeasureClassDropdownData) => ({
    type: types.get_Unit_Of_Measure_Class_Dropdown_Data,
    payload: unitOfMeasureClassDropdownData
})
const getUomMeasureOfDropdownData = (unitOfMeasureMeasureOfDropdownData) => ({
    type: types.get_Unit_Of_Measure_MeasureOf_Dropdown_Data,
    payload: unitOfMeasureMeasureOfDropdownData
})
// Unit of Measure
// Material Group
const getMaterialGroupdata = (materialGroupData) => ({
    type: types.get_Material_Group_Data,
    payload: materialGroupData
});
const getMaterialGroupClassificationDropdownData = (materialGroupClassificationDropdownData) => ({
    type: types.get_Material_Group_Classification_Dropdown_Data,
    payload: materialGroupClassificationDropdownData
});
const postMaterialGroupData = () => ({
    type: types.post_Material_Group_Data
})
const getSingleMaterialGroupData = (singleMaterialGroupData) => ({
    type: types.get_Single_Material_Group_Data,
    payload: singleMaterialGroupData
})
// Material Group
// Material Type
const getMaterialTypedata = (materialTypeData) => ({
    type: types.get_Material_Type_Data,
    payload: materialTypeData
})
const getSingleMaterialTypeData = (singleMaterialTypeData) => ({
    type: types.get_Single_Material_Type_Data,
    payload: singleMaterialTypeData
})
const postMaterialTypeData = () => ({
    type: types.post_Material_Type_Data,
})
// Material Type
// Stock Condition
const getStockConditionData = (stockConditionData) => ({
    type: types.get_Stock_Condition_Data,
    payload: stockConditionData
})
const getSingleStockConditionData = (singleStockConditionData) => ({
    type: types.get_Single_Stock_Condition_Data,
    payload: singleStockConditionData
})
const postStockConditionData = () => ({
    type: types.post_Stock_Condition_Data,
})
// Stock Condition
// Lot Size
const getLotSizeData = (lotSizeData) => ({
    type: types.get_Lot_Size_Data,
    payload: lotSizeData
})
const getSingleLotSizeData = (singleLotSizeData) => ({
    type: types.get_Single_Lot_Size_Data,
    payload: singleLotSizeData
})
const postLotSizeData = () => ({
    type: types.post_Lot_Size_Data,
})
// Lot Size
// Standards Master

// Logistics Master
// Container Type
const getLogisticsContainerTypeDatas = (getLogisticsContainerTypeData) => ({
    type: types.get_Logistics_Container_Type_Data,
    payload: getLogisticsContainerTypeData
})
const downloadLogisticsContainerTypeData = (downloadLogisticsContainerTypeData) => ({
    type: types.download_Logistics_Container_Type_Data,
    payload: downloadLogisticsContainerTypeData
})
const getSingleLogisticContainerTypeData = (singleLogisticsContainerTypeData) => ({
    type: types.get_Single_Logistics_Container_Type_Data,
    payload: singleLogisticsContainerTypeData
})
const getContainerTypeRtmsCategoryDropdownData = (rtmsCategoryDropdownData) => ({
    type: types.get_Rtms_Category_Dropdown_Data,
    payload: rtmsCategoryDropdownData
})
const getContainerTypeProductCategoryDropdownData = (productCategoryDropdownData) => ({
    type: types.get_Product_Category_Dropdown_Data,
    payload: productCategoryDropdownData
})
const postLogisticsContainerTypeData = () => ({
    type: types.post_Logistics_Container_Type_Data
})
// Container Type
// Logistics Master

// Vendor Master
const getVendorMasterData = (vendorMasterData) => ({
    type: types.get_Vendor_Master_Data,
    payload: vendorMasterData
})
const getSingleVendorMasterData = (singleVendorMasterData) => ({
    type: types.get_Single_Vendor_Master_Data,
    payload: singleVendorMasterData
})
const postVendorMasterData = () => ({
    type: types.post_Vendor_Master_Data,
})
// Vendor Master

// Custom Dashboard
const getCustomDashboardOptions = (customDashboardOptions) => ({
    type: types.get_Custom_Dashboard_Options,
    payload: customDashboardOptions
})
const addCustomDashboardData = () => ({
    type: types.post_Custom_Dashboard_Data
})
const getCustomDashboards = (customDashboards) => ({
    type: types.get_Custom_Dashboards,
    payload: customDashboards
})
const getCustomViews = (customViews) => ({
    type: types.get_Custom_View,
    payload: customViews
})
// Custom Dashboard

// Notifications
const getNotifications = (notifications) => ({
    type: types.get_Notifications_Data,
    payload: notifications
})
const getSingleNotifications = (signleNotifications) => ({
    type: types.get_Single_Notification_Data,
    payload: signleNotifications
})
// Notifications

// Leave Management Dashboard
const getLeaveStatusChartData = (leaveStatusChart) => ({
    type: types.get_Leave_Status_Chart_Data,
    payload: leaveStatusChart
})
const getLeaveDashboardCardData = (leaveDashboardCardData) => ({
    type: types.get_Leave_Dashboard_Card_Data,
    payload: leaveDashboardCardData
})
const getLeaveDashboardLeaveTypeChartData = (leaveDashboardLeaveTypeChartData) => ({
    type: types.get_Leave_Dashboard_LeaveType_Chart_Data,
    payload: leaveDashboardLeaveTypeChartData
})
const getLeaveOverAllStatusChartData = (leaveOverAllStatusChart) => ({
    type: types.get_Leave_OverAll_Status_Chart_Data,
    payload: leaveOverAllStatusChart
})
// Leave Management Dashboard

// Dashboard Category
const getDashboardCategoryData = (dashboardCategoryData) => ({
    type: types.get_Dashboard_Category_Data,
    payload: dashboardCategoryData
})
const getSingleDashboardCategoryData = (singleDashboardCategoryData) => ({
    type: types.get_Single_Dashboard_Data,
    payload: singleDashboardCategoryData
})
const postDashboardCategoryData = () => ({
    type: types.post_Dashboard_Category_Data,
})
const postDashboardCategoryBulkData = () => ({
    type: types.post_Dashboard_Category_Bulk_Data
})
// Dashboard Category

// Bulk Upload Template
const getBulkUploadTemplate = () => ({
    type: types.get_Bulk_Upload_Template,
})
// Bulk Upload Template

// Module Permissions
// export const loadRoleBasedModulePermissionsData = (
// ) => {
//     return function (dispatch) {
//         let CustomerID = null;

//         // Check the SignInType and assign appropriate IDs and CompanyCode
//         if (signInDetails[0].SignInType === "SuperAdmin") {
//             CustomerID = signInDetails[0].SuperAdminID; // Assuming SuperAdminID is available in SignInDetails
//         } else if (signInDetails[0].SignInType === "ClientAdmin") {
//             CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
//         } else if (signInDetails[0].SignInType === "User") {
//             CustomerID = signInDetails[0].UserID; // Use UserID for User type
//         }

//         // Clear existing permissions before fetching new ones
//         sessionStorage.removeItem("modulePermissions");

//         fetch(`${baseURL}/accountservices/api/account/PostRoleModulesPermissions`, {
//             method: "POST",
//             mode: "cors",
//             headers: HeaderAuthentication.postExcomatixAuth,
//             body: JSON.stringify({
//                 "SigninType": storedSignInType,
//                 "SigninID": CustomerID
//             })
//         })
//             .then((resp) => resp.json())
//             .then((resp) => {
//                 dispatch(getRoleBasedModulePermissions(resp.Modules));
//                 // Store the response in sessionStorage
//                 sessionStorage.setItem("modulePermissions", JSON.stringify(resp.Modules));
//             })
//             .catch((err) => { console.log(err) });
//     };
// };

export const loadRoleBasedModulePermissionsData = () => {
    return function (dispatch) {
        // Fetch updated session storage values
        const updatedSignInDetails = JSON.parse(sessionStorage.getItem("SignInDetails")) || [];
        let updatedStoredSignInType = updatedSignInDetails[0]?.SignInType || null;

        let CustomerID = null;

        // Check the updated SignInType and assign appropriate IDs
        if (updatedStoredSignInType === "SuperAdmin") {
            CustomerID = updatedSignInDetails[0]?.SuperAdminID; // Assuming SuperAdminID is available in SignInDetails
        } else if (updatedStoredSignInType === "ClientAdmin") {
            CustomerID = updatedSignInDetails[0]?.CompanyID; // Use CompanyID for ClientAdmin
        } else if (updatedStoredSignInType === "User") {
            CustomerID = updatedSignInDetails[0]?.UserID; // Use UserID for User type
        }

        // Clear existing permissions before fetching new ones
        sessionStorage.removeItem("modulePermissions");

        const cached = sessionStorage.getItem("modulePermissions");

        if (cached) {
            dispatch(getRoleBasedModulePermissions(JSON.parse(cached)));
            return; // ✅ Skip the API call
        }

        // fetch(`${baseURL}/accountservices/api/account/PostRoleModulesPermissions`, {
        fetch(`${baseURL}/masterservices/api/menu/getmenu`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                SigninType: updatedStoredSignInType,
                SigninID: CustomerID
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                // dispatch(getRoleBasedModulePermissions(resp.Modules));
                dispatch(getRoleBasedModulePermissions(resp.Menu));
                // Store the response in sessionStorage
                // sessionStorage.setItem("modulePermissions", JSON.stringify(resp.Modules));
                sessionStorage.setItem("modulePermissions", JSON.stringify(resp.Menu));
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

// Module Permissions

// SideMenu
export const loadSidemenus = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Modules/GetModulesForMenu`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({})
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSidemenus(resp.Modules));
                // setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
// SideMenu

// SignIn Page
export const postSignInDatas = (
    postRequest,
    navigateToOtpPage,
    handleResponse,
    setIsDisabled
) => {
    return function (dispatch) {
        const SECRET_KEY = "000000";
        const encryptOTP = (otp) => {
            return CryptoJS.AES.encrypt(otp, SECRET_KEY).toString();
        };
        fetch(`${baseURL}/accountservices/api/account/PostSignIn`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    // Check the number of licenses before proceeding
                    const signInDetails = resp.SignInDetails[0]; // Assuming it's an array

                    if (signInDetails.DaysLeft <= 0) {
                        // Handle expired licenses error
                        handleResponse({
                            Success: '0',
                            Msg: 'Your licenses has expired. Kindly contact support for assistance.'
                        });
                        return; // Stop further execution
                    }

                    // Dispatch the action to update the store (you may already have this action)
                    dispatch(postSignInData());

                    // Encrypt OTP and update SignInDetails before storing
                    signInDetails.OTP = encryptOTP(signInDetails.OTP);

                    // Store the response data in sessionStorage
                    sessionStorage.setItem("SignInDetails", JSON.stringify(resp.SignInDetails));
                    sessionStorage.setItem("AssignedModules", JSON.stringify(resp.AssignedModules));

                    // Store SuperAdminID in sessionStorage
                    // sessionStorage.setItem("PreviousSuperAdminID", resp.SignInDetails[0]?.SuperAdminID ?? "null");
                    // sessionStorage.setItem("Success", resp.Success);
                    // setIsDisabled(false)

                    navigateToOtpPage();
                    handleResponse(resp);
                    // Clear modulePermissions and fetch fresh permissions
                    sessionStorage.removeItem("modulePermissions");
                    // Fetch role-based module permissions
                    dispatch(loadRoleBasedModulePermissionsData());
                    // ✅ Store in Redux
                    dispatch(setSignInDetails(signInDetails));

                } else {
                    console.error("Sign-in failed:", resp.Msg);
                    handleResponse(resp);
                    setIsDisabled(false);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const postResendOtpDatas = (
    postRequest,
    setSuccessMessage,
    setError
) => {
    return function (dispatch) {
        const SECRET_KEY = "000000";
        const encryptOTP = (otp) => {
            return CryptoJS.AES.encrypt(otp, SECRET_KEY).toString();
        };
        fetch(`${baseURL}/accountservices/api/account/PostResendOTPEmail`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    // Dispatch the action to update the store (you may already have this action)
                    dispatch(postResendOtpData());
                    const updatedSignInDetails = {
                        ...resp.SignInDetails[0],
                        OTP: encryptOTP(resp.SignInDetails[0].OTP), // Encrypt OTP before storing
                    };

                    sessionStorage.setItem("SignInDetails", JSON.stringify([updatedSignInDetails]));
                    // sessionStorage.setItem("SignInDetails", JSON.stringify(resp.SignInDetails));
                    setSuccessMessage("Otp sent successfully");
                } else {
                    console.error("Resend-OTP failed:", resp.Msg);
                    setError("Resend-OTP failed");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
// SignIn Page

// Verify Company
export const postResendVerifyEmail = (
    postRequest,
    customerManagementData
) => {
    return function (dispatch) {
        fetch(`${baseURL}/accountservices/api/account/PostResendVerificationEmail`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    // Dispatch the action to update the store (you may already have this action)
                    dispatch(postResendVerifyCompanyEmail());
                    customerManagementData();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    })
                } else {
                    console.error("Resend Email failed:", resp.Msg);
                    Swal.fire({
                        title: 'Failed',
                        text: resp.Msg,
                        icon: 'failed',
                    })
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
// Verify Company

// Forgot Password 
export const postForgotPassword = (
    postRequest,
    setSuccessMessage,
    setErrorMessage,
) => {
    return function (dispatch) {
        fetch(`${baseURL}/accountservices/api/account/PostResetPasswordLink`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    // Dispatch the action to update the store (you may already have this action)
                    dispatch(postForgotPasswordEmail());
                    setSuccessMessage(resp.Msg);

                } else {
                    console.error("Send Reset-Password link failed:", resp.Msg);
                    setErrorMessage(resp.Msg);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
// Forgot Password 

// Reset Password
export const postResetPasswordDatas = (
    postRequest,
    setSuccessMessage,
    setErrorMessage,
    setResetStatus,
) => {
    return function (dispatch) {
        fetch(`${baseURL}/accountservices/api/account/PostResetPassword`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                // if (resp.Success === 1) {
                //     // Dispatch the action to update the store (you may already have this action)
                //     dispatch(postResetPasswordData());
                //     setSuccessMessage(resp.Msg);
                //     // navigateToSignInPage()
                // } else {
                //     console.error("Reset-Password failed:", resp.Msg);
                //     setErrorMessage(resp.Msg);
                // }
                // Check the response based on Success value and update resetStatus accordingly
                if (resp.Success === 2) {
                    // This means valid reset password link, the user can reset the password
                    setResetStatus(2);  // Show the reset password form
                    setSuccessMessage(resp.Msg);  // Show any success message if necessary
                } else if (resp.Success === 1) {
                    // Password reset was successful
                    setResetStatus(1);  // Show the success message
                    setSuccessMessage(resp.Msg);
                    dispatch(postResetPasswordData());  // Dispatch any action needed after successful reset
                } else {
                    // Reset password failed
                    setResetStatus(0);  // Show the error message
                    setErrorMessage(resp.Msg);  // Set error message from the response
                }
            })
            .catch((err) => {
                console.error("Error:", err);
                setResetStatus(0);  // Set reset status to 0 (failure) if API call fails
                setErrorMessage("An error occurred while resetting the password.");
            });
    }
};
// Reset Password

// Switch To Client
export const postSwitchToClientDatas = (
    postRequest,
    cancelModal,
    navigate
) => {
    return function (dispatch) {
        fetch(`${baseURL}/accountservices/api/account/PostSwitchToClient`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    if (resp) {
                        sessionStorage.setItem("SignInDetails", JSON.stringify(resp.SignInDetails || []));
                        sessionStorage.setItem("AssignedModules", JSON.stringify(resp.AssignedModules || []));
                        sessionStorage.setItem("PreviousCompanyID", resp.SignInDetails[0]?.CompanyID);
                        // Clear modulePermissions and reload them
                        sessionStorage.removeItem("modulePermissions");
                    }
                    dispatch(postSwitchToClientData());
                    cancelModal();
                    // Swal.fire({
                    //     title: 'Success',
                    //     text: resp.Msg,
                    //     icon: 'success',
                    // });
                    // window.location = '/#/dashboard';
                    // dispatch(loadRoleBasedModulePermissionsData());
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    }).then(() => {
                        // Reload the page after the user clicks "OK"
                        // window.location.href = '/#/dashboard';
                        const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails")) || [];
                        const dashboardLink = signInDetails?.[0]?.DashboardPublicLink;
                        const dashboardId = signInDetails?.[0]?.DashboardLibraryID;
                        const dashboardCategoryId = signInDetails?.[0]?.DashboardCategoryID;
                        const linkType = signInDetails?.[0]?.LinkType;

                        if (dashboardId && dashboardCategoryId !== 1) {
                            // App internal Power BI dashboard
                            navigate(`/powerbi-dashboard/${dashboardId}`, {
                                state: { viewType: linkType?.toLowerCase() },
                                // signInDetails: signInDetails,
                            });
                        } else if (dashboardCategoryId === 1 && dashboardLink) {
                            // External dashboard
                            window.location.href = dashboardLink;
                        } else {
                            // Fallback
                            window.location.href = '/';
                        }
                        // window.location.reload();
                        // Optionally reload permissions after the page reloads
                        dispatch(loadRoleBasedModulePermissionsData());
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
};
// Switch To Client

// Switch To SuperAdmin
export const postSwitchToSuperAdminDatas = (
    postRequest,
    cancelModal,
    navigate
) => {
    return function (dispatch) {
        fetch(`${baseURL}/accountservices/api/account/PostSwitchToSuperAdmin`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    if (resp) {
                        sessionStorage.setItem("SignInDetails", JSON.stringify(resp.SignInDetails || []));
                        sessionStorage.setItem("AssignedModules", JSON.stringify(resp.AssignedModules || []));
                        sessionStorage.removeItem("PreviousCompanyID", resp.SignInDetails[0]?.CompanyID);
                        // Clear modulePermissions and reload them
                        sessionStorage.removeItem("modulePermissions");
                        sessionStorage.removeItem("PreviousSuperAdminID");
                        sessionStorage.removeItem("PreviousSuperAdminName");
                    }
                    dispatch(postSwitchToSuperAdminData());
                    // dispatch(loadRoleBasedModulePermissionsData());
                    cancelModal();
                    // Swal.fire({
                    //     title: 'Success',
                    //     text: resp.Msg,
                    //     icon: 'success',
                    // });
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    }).then(() => {
                        // Reload the page after the user clicks "OK"
                        // window.location.href = '/#/dashboard';
                        const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails")) || [];
                        const dashboardLink = signInDetails?.[0]?.DashboardPublicLink;
                        const dashboardId = signInDetails?.[0]?.DashboardLibraryID;
                        const dashboardCategoryId = signInDetails?.[0]?.DashboardCategoryID;
                        const linkType = signInDetails?.[0]?.LinkType;

                        if (dashboardId && dashboardCategoryId !== 1) {
                            // App internal Power BI dashboard
                            navigate(`/powerbi-dashboard/${dashboardId}`, {
                                state: { viewType: linkType?.toLowerCase() },
                                // signInDetails: signInDetails,
                            });
                        } else if (dashboardCategoryId === 1 && dashboardLink) {
                            // External dashboard
                            window.location.href = dashboardLink;
                        } else {
                            // Fallback
                            window.location.href = '/';
                        }
                        // window.location.reload();
                        // Optionally reload permissions after the page reloads
                        dispatch(loadRoleBasedModulePermissionsData());
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
};
// Switch To SuperAdmin

// Profile Settings Set Password
export const postUpdateProfileSettingsDatas = (
    postRequest,
    imgChange,
    setImgChange,
    profileData,
) => {
    return function (dispatch) {
        fetch(`${baseURL}/accountservices/api/account/PostUserProfileUpdate`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postUpdateProfileSettingsDta());
                    profileData();
                    // cancelModal();
                    if (imgChange) {
                        setImgChange(false)
                    }
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
};
export const postProfileSettingsSetPasswordDatas = (
    postRequest,
    cancelModal,
) => {
    return function (dispatch) {
        fetch(`${baseURL}/accountservices/api/account/PostChangePassword`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postProfileSettingsSetPassword());
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
};
export const loadSignInTokenData = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0]?.SuperAdminID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0]?.SignInType === "User") {
            CustomerID = signInDetails[0]?.UserID; // Use UserID for User type
        }

        fetch(`${baseURL}/accountservices/api/account/SingleActiveSession`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                "SigninType": signInDetails[0]?.SignInType,
                "DeviceType": "Web",
                "SigninID": CustomerID
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                // Store response in session storage
                sessionStorage.setItem("signInToken", JSON.stringify(resp.Msg));
                dispatch(getSignInToken(resp.Msg));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadProfileDetailsData = (setSessionExpired, setErrorMessage, signInDetails, signInToken) => {
    return function (dispatch) {
        // const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;
        let SignInType = null;

        let headerToken = HeaderAuthentication.postExcomatixAuth
        console.log(signInToken, 'signInToken')
        if (signInToken) {
            headerToken = {
                "Content-Type": "application/json",
                "X-Api-Key": "f238b70537400820398f84fa1e1d12344314914eb7803d96b2ad497efed288d5",
                "Authorization": `Bearer ${signInToken}`
            };;
        }

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0]?.SuperAdminID; // Assuming SuperAdminID is available in SignInDetails
            SignInType = signInDetails[0]?.SignInType; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
            SignInType = signInDetails[0].SignInType; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0]?.UserID; // Use UserID for User type
            SignInType = signInDetails[0]?.SignInType; // Use UserID for User type
        }
        fetch(`${baseURL}/accountservices/api/account/GetProfileDetails`, {
            method: "POST",
            mode: "cors",
            headers: headerToken,
            body: JSON.stringify({
                "SigninType": SignInType,
                "SigninID": CustomerID
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                // dispatch(getProfileDetailsData(resp.Users));
                if (resp.Success === 4) {
                    setErrorMessage(resp.Msg || "Your session has expired. Please log in again.");
                    setSessionExpired(true);
                    setTimeout(() => {
                        sessionStorage.clear();
                    }, [500]) // Clear session storage
                } else {
                    dispatch(getProfileDetailsData(resp.Users));
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadTimeZoneDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/companyservices/api/company/PostCountryCode`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({}),
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.CountryCodes) {
                    dispatch(
                        getTimeZoneDropdownData(
                            resp.CountryCodes.map((data) => {
                                return { value: data.TimeZone, label: data.TimeZone };
                            })
                        )
                    );
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadProfileChangePasswordOtp = (oldPassword, setOldPasswordError, setShowOtpInput) => {
    return function (dispatch) {
        let SigninID = null;
        let SigninType = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            SigninID = signInDetails[0]?.SuperAdminID; // Assuming SuperAdminID is available in SignInDetails
            SigninType = signInDetails[0]?.SignInType; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            SigninID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
            SigninType = signInDetails[0].SignInType; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            SigninID = signInDetails[0]?.UserID; // Use UserID for User type
            SigninType = signInDetails[0]?.SignInType; // Use UserID for User type
        }
        fetch(`${baseURL}/accountservices/api/account/PostChangePasswordOTP`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                "EmailID": storedEmail,
                "UserName": storedUserName,
                "SigninID": SigninID,
                "SigninType": SigninType,
                "OldPassword": oldPassword
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                // dispatch(getProfilePasswordChangeOtp(resp.Msg));
                if (resp.Success === 1) {
                    dispatch(getProfilePasswordChangeOtp(resp.Msg));
                    setOldPasswordError("");          // clear old error
                    setShowOtpInput(true);    // show OTP input only on success
                } else {
                    setOldPasswordError(resp.Msg);    // set backend error
                    setShowOtpInput(false);   // ensure OTP input is hidden
                }
            })
            .catch((err) => { console.log(err) });
    };
};
// Profile Settings Set Password

// Customer Management
export const postCustomerManagementDatas = (
    postRequest,
    companyId,
    cancelModal,
    customerManagementData,
    imgChange,
    setImgChange,
    customFields
) => {
    return function (dispatch) {
        const url = companyId ?
            `${baseURL}/companyservices/api/company/PostUpdateCompany`
            :
            `${baseURL}/companyservices/api/company/PostAddCompany`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postCustomerManagementData());
                    // if (customFields.length !== 0) {
                    //     // Filter customFields to send only the required fields
                    //     const filteredCustomFields = customFields.map(field => {
                    //         // Check if CustomField_Value is defined, otherwise fall back to an empty string
                    //         const fieldValue = field.CustomField_Value || "";

                    //         return {
                    //             CustomFieldID: field.CustomFieldsID, // or use field.CustomField_IDFK if needed
                    //             Value: fieldValue, // The value of the custom field
                    //         };
                    //     });
                    //     console.log(filteredCustomFields, 'filteredCustomFields')
                    //     let postCustomData = {
                    //         method: "POST",
                    //         mode: "cors",
                    //         headers: HeaderAuthentication.postExcomatixAuth,
                    //         body: JSON.stringify({
                    //             CompanyID: companyId,
                    //             ModuleID: 2,
                    //             CustomFieldValuesList: filteredCustomFields,
                    //             AddedByID: ADDED_BY_ID,
                    //         }),
                    //     };
                    //     dispatch(postCustomFieldValuesOfCompany(postCustomData, cancelModal));
                    // }
                    // ✅ Only proceed if there are any updated custom fields
                    // Extract ReferenceID safely
                    let extractedReferenceID = companyId;
                    if (!companyId && resp.Msg.includes("Reference ID:")) {
                        extractedReferenceID = parseInt(
                            resp.Msg.split("Reference ID: ")[1]?.trim(),
                            10
                        );
                    }
                    const changedFields = customFields.filter(field =>
                        field.CustomField_Value && field.CustomField_Value.trim() !== ""
                    );
                    // if (customFields.length !== 0) {
                    if (changedFields.length > 0) {
                        // Extract CompanyID (assuming all custom fields have the same CompanyID)
                        const companyID = customFields[0]?.CompanyID || null;
                        // Filter customFields to send only the required fields
                        const filteredCustomFields = customFields.map(field => {
                            // Check if CustomField_Value is defined, otherwise fall back to an empty string
                            const fieldValue = field.CustomField_Value || "";
                            return {
                                CustomFieldID: field.CustomFieldsID, // or use field.CustomField_IDFK if needed
                                Value: fieldValue, // The value of the custom field
                            };
                        });
                        console.log(customFields, 'customFields')
                        let postCustomData = {
                            method: "POST",
                            mode: "cors",
                            headers: HeaderAuthentication.postExcomatixAuth,
                            body: JSON.stringify({
                                CompanyID: companyID,
                                ModuleID: 2,
                                CustomFieldValuesList: filteredCustomFields,
                                AddedByID: ADDED_BY_ID,
                                ReferenceID: extractedReferenceID
                            }),
                        };
                        dispatch(postCustomFieldValuesOfCompany(postCustomData, cancelModal));
                    }
                    customerManagementData();
                    cancelModal();
                    if (imgChange) {
                        setImgChange(false)
                    }
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err)
            });
    }
};

export const postCustomFieldValuesOfCompany = (
    postRequest,
    companyId,
    cancelModal,
    customerManagementData
) => {
    return function (dispatch) {
        // const url = companyId ?
        //     `${baseURL}/excomatixservices/api/CustomFieldValue/PostUpdateCustomFieldValue`
        //     :
        //     `${baseURL}/excomatixservices/api/CustomFieldValue/PostAddCustomFieldValue`
        fetch(`${baseURL}/excomatixservices/api/CustomFieldValue/PostAddOrUpdateCustomFieldValues`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postCustomFieldValuesForCompany());
                    // customerManagementData()
                    // cancelModal();
                    // Swal.fire({
                    //     title: 'Success',
                    //     text: resp.Msg,
                    //     icon: 'success',
                    // });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
};

export const loadAssignedModulesDropdownData = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }
        fetch(`${baseURL}/excomatixservices/api/modules/GetModules`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                "CompanyID": CustomerID,
                "ModulesID": "",
                "StatusID": 1,
                "Modules_Name": ""
            }),
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Modules) {
                    dispatch(
                        getAssignedModulesDropdownData(
                            resp.Modules.map((data) => {
                                return { value: data.ModuleID, label: data.Module, statusID: data.StatusID };
                            })
                        )
                    );
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadCountryCodeDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/companyservices/api/company/PostCountryCode`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({}),
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.CountryCodes) {
                    dispatch(
                        getCountryCodeDropdownData(
                            resp.CountryCodes.map((data) => {
                                return { value: data.CountryCodeID, label: data.CountryCode };
                            })
                        )
                    );
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadCompanyData = (
    setLoading,
    pageSize,
    currentPage,
    SearchText,
    searchParams,
    whereClause
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;
        let CompanyCode = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = null; // Assuming SuperAdminID is available in SignInDetails
            CompanyCode = null; // Send CompanyCode as null for SuperAdmin
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
            CompanyCode = signInDetails[0].CompanyCode; // Use CompanyCode for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].UserID; // Use UserID for User type
            CompanyCode = signInDetails[0].CompanyCode; // Use CompanyCode for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "Company_StatusIDFK": 0,
            "Company_Code": CompanyCode,
            "Company_Name": "",
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.CompanyID = SearchText; // Assuming you want to search by Company Name
        }

        if (searchParams) {
            requestBody.ValueFilterType = "B";
            requestBody.ValueFilterWhereClause = searchParams;
        }

        if (whereClause) {
            requestBody.ValueFilterType = "B";
            requestBody.ValueFilterWhereClause = whereClause;
        }

        fetch(`${baseURL}/companyservices/api/company/GetCompanies`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCompanyData(resp.Customers));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const downloadCompanyDatas = (
    setLoading,
    // pageSize,
    // currentPage,
    SearchText,
    searchParams,
    whereClause
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;
        let CompanyCode = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = null; // Assuming SuperAdminID is available in SignInDetails
            CompanyCode = null; // Send CompanyCode as null for SuperAdmin
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
            CompanyCode = signInDetails[0].CompanyCode; // Use CompanyCode for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].UserID; // Use UserID for User type
            CompanyCode = signInDetails[0].CompanyCode; // Use CompanyCode for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "Company_StatusIDFK": 0,
            "Company_Code": CompanyCode,
            "Company_Name": "",
            // "PageSize": null,
            // "PageIndex": null
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.CompanyID = SearchText; // Assuming you want to search by Company Name
        }

        if (searchParams) {
            requestBody.ValueFilterType = "B";
            requestBody.ValueFilterWhereClause = searchParams;
        }

        if (whereClause) {
            requestBody.ValueFilterType = "B";
            requestBody.ValueFilterWhereClause = whereClause;
        }

        fetch(`${baseURL}/companyservices/api/company/GetCompanies`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(downloadCompanyData(resp.Customers));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleCompanyData = (
    companyCode,
    comId,
    setDataLoading
) => {
    return function (dispatch) {
        const payload = { Company_Code: companyCode };
        if (comId) {
            payload.CompanyID = comId;
        }
        setDataLoading(true);
        fetch(`${baseURL}/companyservices/api/company/postCompanyDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            // body: JSON.stringify({
            //     "Company_Code": companyCode,
            // })
            body: JSON.stringify(payload)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (companyCode !== null) {
                    dispatch(getSingleCompanyData(resp));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleCompanyData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const loadCompanyDropdownData = (totalDataCount) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

        let CustomerID = null;
        let CompanyCode = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
            CompanyCode = signInDetails[0].CompanyCode; // Send CompanyCode as null for SuperAdmin
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
            CompanyCode = signInDetails[0].CompanyCode; // Use CompanyCode for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            // CustomerID = signInDetails[0].UserID; // Use UserID for User type
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
            CompanyCode = signInDetails[0].CompanyCode; // Use CompanyCode for User type
        }
        fetch(`${baseURL}/companyservices/api/company/GetCompanies`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                "CompanyID": CustomerID,
                "Company_StatusIDFK": 5,
                "Company_Code": CompanyCode,
                "Company_Name": "",
                "PageSize": 1000000,
                "PageIndex": 1
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Customers) {
                    dispatch(
                        getCompanyDropdownData(
                            resp.Customers.map((data) => {
                                return { value: data.CompanyID, label: data.CompanyName, statusID: 5, ContactPerson: data.ContactPerson, EmailID: data.EmailID, ZipCode: data.ZipCode, Address: data.Address, Mobile: data.Mobile };
                            })
                        )
                    );
                }
                // if (resp.RecordCount) {
                //     dispatch(getToataldataCount(resp.RecordCount));
                //     console.log(resp.RecordCount, 'RecordCount'); // Log the RecordCount
                // }
            })
            .catch((err) => { console.log(err) });
    };
};

export const loadGeneratedCompanyCode = () => {
    return function (dispatch) {
        // fetch(`${baseURL}/excomatixservices/api/SystemNumbering/GetModuleNextGeneratedCode?ModuleName=Customer Management`, HeaderAuthentication.getRequestOptions)
        fetch(`${baseURL}/excomatixservices/api/SystemNumbering/GetModuleNextGeneratedCode?ModuleID=2`, HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getGeneratedCompanyCode(resp))
            })
    }
}

export const loadCustomFieldsForCompany = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/CustomField/GetCustomFieldDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ CustomFields_ModuleIDFK: 2 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomFieldsForCompany(resp.CustomFields));
                // setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadCustomerClassificationDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/CustomerClassification/GetCustomerClassificationDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "StatusID": 8 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.CustomerClassifications) {
                    dispatch(
                        getCustomerClassificationDropdownData(
                            resp.CustomerClassifications.map((data) => {
                                return { value: data.CustomerClassificationID, label: data.CustomerClassificationName };
                            })
                        )
                    );
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadCustomerDashboardCardData = (licenseExpiryDays, setLoading) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        const storedEmail = signInDetails ? signInDetails[0]?.EmailID : null;
        const data = {
            EmailID: storedEmail
        };

        // If licenseExpiryDays is provided, add it to the body object
        if (licenseExpiryDays) {
            data.LicenseExpiryDays = licenseExpiryDays;
        }
        fetch(`${baseURL}/companyservices/api/Company/GetCompaniesCountSummary`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomerDashboardCardsData(resp.Companies));
                setLoading(false)
            })
            .catch((err) => { console.log(err) });
    }
}
export const loadCustomerDetailsChartData = (year) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        const storedEmail = signInDetails ? signInDetails[0]?.EmailID : null;
        fetch(`${baseURL}/companyservices/api/Company/GetCompaniesCountStatsOfYear`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "Year": year })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomerDetailsChartData(resp.Companies));
            })
            .catch((err) => { console.log(err) });
    }
}
export const loadCustomerDashboardRelationshipTypeChartData = (companyName, year) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        const storedEmail = signInDetails ? signInDetails[0]?.EmailID : null;
        fetch(`${baseURL}/companyservices/api/Company/GetRelationshipTypeCountStats`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "CompanyID": companyName, "Year": year })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomerDashboardRelationshipTypeChartData(resp.RelationShipTypes));
            })
            .catch((err) => { console.log(err) });
    }
}
export const loadCustomerDashboardLicenceSplitUpChartData = (companyName) => {
    return function (dispatch) {
        fetch(`${baseURL}/companyservices/api/Company/GetCompanyBranchwiseLicenseSplitup`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "CompanyID": companyName })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomerDashboardLicenceSplitUpChartData(resp.BranchLicenses));
            })
            .catch((err) => { console.log(err) });
    }
}
export const loadCustomerDashboardStatusChartData = (companyName, year) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        const storedEmail = signInDetails[0].EmailID || null;
        fetch(`${baseURL}/companyservices/api/Company/GetCompaniesStatusCountStats`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "CompanyID": companyName, "Year": year })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomerDashboardStatusChartData(resp.Companies));
            })
            .catch((err) => { console.log(err) });
    }
}
export const loadCustomerDashboardAssignedModulesData = (companyName) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        const storedEmail = signInDetails[0].EmailID || null;
        fetch(`${baseURL}/companyservices/api/Company/GetCompanyAssignedModules`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "CompanyID": companyName })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomerDashboardAssignedModulesData(resp.CompanyModules));
            })
            .catch((err) => { console.log(err) });
    }
}
export const loadCustomerDashboardNoofLicencesChartData = (companyName, year) => {
    return function (dispatch) {
        fetch(`${baseURL}/companyservices/api/Company/GetCompanyNoOfLicensesStats`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "CompanyID": companyName, "Year": year })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomerDashboardNoOfLicencesChartData(resp.CompanyNoOfLicenses));
            })
            .catch((err) => { console.log(err) });
    }
}
export const loadCustomerModuleFieldNameData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 2 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getCustomerModuleFieldNameData(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const loadCustomFieldsForCustomers = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null; // Should be set correctly now

        // Assign CustomerID based on SignInType if selectedCompanyID is not provided
        if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "User") {
            CustomerID = signInDetails?.[0]?.CompanyID;
        }
        fetch(`${baseURL}/excomatixservices/api/CustomField/GetCustomFieldDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ CustomFields_ModuleIDFK: 2, CustomFields_CompanyIDFK: CustomerID, CustomFields_StatusIDFK: 26 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomFieldsForCustomers(resp.CustomFields));
                // setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadCustomerCustomFieldData = (
    setLoading,
    // customFields,
    comId
) => {
    return function (dispatch) {
        // const companyID = customFields[0]?.CompanyID || null;
        let companyID = null; // Should be set correctly now

        // Assign CustomerID based on SignInType if selectedCompanyID is not provided
        if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
            companyID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
            companyID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "User") {
            companyID = signInDetails?.[0]?.CompanyID;
        }
        fetch(`${baseURL}/excomatixservices/api/CustomFieldValue/GetCustomFieldValueDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                CompanyID: companyID,
                ModuleID: 2,
                ReferenceID: comId
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomerCustomFieldData(resp.CustomFieldsValues));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
// Customer Management

// User Management
export const loadUserManagementData = (
    setLoading,
    SearchText,
    searchParams,
    whereClause
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;
        let UserID = null; // Declare UserID to handle the "User" case

        // Check the SignInType and assign appropriate IDs
        if (signInDetails[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0]?.SignInType === "User") {
            CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for User type
            UserID = signInDetails[0]?.UserID; // Use UserID for User type
        }

        // Only make the API call if CustomerID exists
        if (CustomerID) {
            const requestPayload = {
                CustomerID: CustomerID,
            };

            // Add UserID to the payload if it exists
            if (UserID) {
                requestPayload.UserID = UserID;
            }

            // If SearchText is provided, add it to the requestBody
            if (SearchText) {
                requestPayload.UserID = SearchText; // Assuming you want to search by Company Name
            }

            if (searchParams) {
                requestPayload.ValueFilterType = "B";
                requestPayload.ValueFilterWhereClause = searchParams;
            }

            if (whereClause) {
                requestPayload.ValueFilterType = "B";
                requestPayload.ValueFilterWhereClause = whereClause;
            }

            fetch(`${baseURL}/userservices/api/User/GetUserDetails`, {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(requestPayload)
            })
                .then((resp) => resp.json())
                .then((resp) => {
                    dispatch(getUserManagementData(resp.Users));
                    setLoading(false);
                })

                .catch((err) => { console.log(err) });
        }
    };
};
export const loadSingleUserManagementData = (userId, setDataLoading) => {
    setDataLoading(true);
    return function (dispatch) {
        fetch(`${baseURL}/userservices/api/User/GetUserDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                "UserID": userId
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (userId !== null) {
                    dispatch(getSingleUserManagementData(resp.Users));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleUserManagementData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadRolesDropdownData = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].UserID; // Use UserID for User type
        }
        const requestBody = {
            "CompanyID": CustomerID,
            "StatusID": 24
        }
        fetch(`${baseURL}/excomatixservices/api/roles/PostRoleDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Roles) {
                    dispatch(
                        getRoleDropdown(
                            resp.Roles.map((data) => {
                                return { value: data.RoleID, label: data.RoleName, StatusID: 24 };
                            })
                        )
                    );
                } else {
                    dispatch(getRoleDropdown([]));
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadReportingToDropdownData = (CompanyID) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        // Initialize the request body
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs
        if (signInDetails[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0]?.CompanyID;; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0]?.SignInType === "User") {
            // CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for User type
            CustomerID = signInDetails[0]?.CompanyID; // Use UserID for User type
        }
        fetch(`${baseURL}/userservices/api/User/GetUserDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ CustomerID: CustomerID || CompanyID, StatusID: 16 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Users) {
                    dispatch(
                        getReportingToDropdown(
                            resp.Users.map((data) => {
                                return { value: data.UserID, label: `${data.FirstName} ${data.LastName}`, StatusID: 16, EmailID: data.EmailID, ZipCode: data.ZipCode, Phone: data.Phone, WorkAddress: data.WorkAddress };
                            })
                        )
                    );
                } else {
                    dispatch(getReportingToDropdown([]));
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadUserDropdownData = (CompanyID) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        // Initialize the request body
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs
        if (signInDetails[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0]?.CompanyID;; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0]?.SignInType === "User") {
            // CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for User type
            CustomerID = signInDetails[0]?.CompanyID; // Use UserID for User type
        }
        fetch(`${baseURL}/userservices/api/User/GetUserDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ CustomerID: CustomerID || CompanyID, StatusID: 16 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Users) {
                    dispatch(
                        getUserDropdown(
                            resp.Users.map((data) => {
                                // Collect all roles by joining them into a comma-separated string
                                const roles = data.UserRoles.map(role => role.RoleName).join(', ') || 'No Roles';
                                return {
                                    value: data.UserID,
                                    label: `${data.FirstName} ${data.LastName}`,
                                    department: data.DepartmentName,
                                    role: roles,  // Include all roles as a comma-separated string 
                                    CountryCodeID: data.CountryCodeID,
                                    CountryCode: data.CountryCode,
                                }
                            })
                        )
                    );
                } else {
                    dispatch(getUserDropdown([]));
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadUserReportingDesignationDropdownData = (CompanyID, ReportingToID) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        // Initialize the request body
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs
        if (signInDetails[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0]?.CompanyID;; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0]?.SignInType === "User") {
            // CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for User type
            CustomerID = signInDetails[0]?.CompanyID; // Use UserID for User type
        }
        fetch(`${baseURL}/userservices/api/User/GetUserDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ CustomerID: CustomerID || CompanyID, StatusID: 16, DesignationID: ReportingToID })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Users) {
                    dispatch(
                        getUserReportingDesignationDropdown(
                            resp.Users.map((data) => {
                                // Collect all roles by joining them into a comma-separated string
                                const roles = data.UserRoles.map(role => role.RoleName).join(', ') || 'No Roles';
                                return {
                                    value: data.UserID,
                                    label: `${data.FirstName} ${data.LastName}`,
                                    department: data.DepartmentName,
                                    role: roles,  // Include all roles as a comma-separated string 
                                    CountryCodeID: data.CountryCodeID,
                                    CountryCode: data.CountryCode,
                                }
                            })
                        )
                    );
                } else {
                    dispatch(getUserReportingDesignationDropdown([]));
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const postUserManagementDatas = (
    postRequest,
    cancelModal,
    userManagenemtData,
    userID,
    imgChange,
    setImgChange,
    customFields,
) => {
    return function (dispatch) {
        const url = userID ?
            `${baseURL}/userservices/api/User/PostUpdateUser`
            :
            `${baseURL}/userservices/api/User/PostAddUser`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postUserManagementData());
                    cancelModal();

                    // console.log(customFields, 'customFields')
                    // ✅ Only proceed if there are any updated custom fields
                    // Extract ReferenceID safely
                    let extractedReferenceID = userID;
                    if (!userID && resp.Msg.includes("Reference ID:")) {
                        extractedReferenceID = parseInt(
                            resp.Msg.split("Reference ID: ")[1]?.trim(),
                            10
                        );
                    }

                    const changedFields = customFields.filter(field =>
                        field.CustomField_Value && field.CustomField_Value.trim() !== ""
                    );

                    // if (customFields.length !== 0) {
                    if (changedFields.length > 0) {
                        // Extract CompanyID (assuming all custom fields have the same CompanyID)
                        const companyID = customFields[0]?.CompanyID || null;
                        // Filter customFields to send only the required fields
                        const filteredCustomFields = customFields.map(field => {
                            // Check if CustomField_Value is defined, otherwise fall back to an empty string
                            const fieldValue = field.CustomField_Value || "";
                            return {
                                CustomFieldID: field.CustomFieldsID, // or use field.CustomField_IDFK if needed
                                Value: fieldValue, // The value of the custom field
                            };
                        });
                        console.log(customFields, 'customFields')
                        let postCustomData = {
                            method: "POST",
                            mode: "cors",
                            headers: HeaderAuthentication.postExcomatixAuth,
                            body: JSON.stringify({
                                CompanyID: companyID,
                                ModuleID: 3,
                                CustomFieldValuesList: filteredCustomFields,
                                AddedByID: ADDED_BY_ID,
                                // ReferenceID: userID
                                ReferenceID: extractedReferenceID
                            }),
                        };
                        dispatch(postCustomFieldValuesOfCompany(postCustomData, cancelModal));
                    }
                    userManagenemtData()
                    if (imgChange) {
                        setImgChange(false)
                    }
                    let message = resp.Msg || "";
                    // Remove "Reference ID: ..." only from Swal message
                    let swalMessage = message.split("Reference ID:")[0].trim();

                    Swal.fire({
                        title: 'Success',
                        text: swalMessage,
                        icon: 'success',
                    });

                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => { console.log(err) });
    }
};

export const postUserManagementSlocDatas = (
    postRequest,
    cancelModal,
    userManagenemtData,
    // userID
) => {
    return function (dispatch) {
        // const url = userID ?
        //     `${baseURL}/userservices/api/User/PostUpdateUser`
        //     :
        //     `${baseURL}/userservices/api/User/PostAddUser`
        fetch(`${baseURL}/userservices/api/User/PostAddUserSloc`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postUserManagementSlocData());
                    cancelModal();
                    userManagenemtData();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => { console.log(err) });
    }
};
export const postUserManagementPlantDatas = (
    postRequest,
    cancelModal,
    userManagenemtData,
    // userID
) => {
    return function (dispatch) {
        // const url = userID ?
        //     `${baseURL}/userservices/api/User/PostUpdateUser`
        //     :
        //     `${baseURL}/userservices/api/User/PostAddUser`
        fetch(`${baseURL}/userservices/api/User/PostAddUserPlant`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postUserManagementPlantData());
                    // cancelModal();
                    userManagenemtData();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => { console.log(err) });
    }
};
export const loadSlocDropdownData = (branchIds) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Convert branchIds array to comma-separated string
        const branchIDsString = Array.isArray(branchIds) ? branchIds.join(",") : 0;

        // Construct request body dynamically
        const requestBody = {
            // "Company_Code": Company_Code,
            'CompanyID': CustomerID,
            'BranchIDs': branchIDsString
        };

        fetch(`${baseURL}/companyservices/api/company/GetCompanySlocDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Slocs) {
                    dispatch(
                        getSlocDropdown(
                            resp.Slocs.map((data) => {
                                return { value: data.SlockID, label: `${data.ReportingTo} - ${data.StorageLocationCode} - ${data.StorageLocationName}`, statusID: 5, ReportingToCode: data.ReportingToCode };
                            })
                        )
                    );
                }
                else {
                    dispatch(getSlocDropdown([]));
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const loadBranchDropdownData = (CompanyID) => {
    return function (dispatch) {
        const companyID = CompanyID || Company_ID;  // Ensure session Company_ID is used
        // Construct request body dynamically
        const requestBody = {
            "Company_Code": Company_Code,
            "CompanyID": companyID,
        };

        fetch(`${baseURL}/companyservices/api/company/postCompanyDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Branch) {
                    dispatch(
                        getBranchDropdown(
                            resp.Branch.map((data) => {
                                return { value: data.BranchID, label: `${data.BranchCode} - ${data.BranchName}`, statusID: 5, BranchCode: data.BranchCode };
                            })
                        )
                    );
                } else {
                    dispatch(getBranchDropdown([]));
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadBusinessUnitDropdownData = (CompanyID) => {
    return function (dispatch) {
        const companyID = CompanyID || Company_ID; // Ensure session Company_ID is used
        fetch(`${baseURL}/companyservices/api/company/postCompanyDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                "Company_Code": Company_Code,
                // "CompanyID": Company_ID || CompanyID,
                "CompanyID": companyID,
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Branch) {
                    dispatch(
                        getBusinessUnitDropdown(
                            resp.BusinessUnits.map((data) => {
                                return { value: data.BusinessUnitID, label: data.UnitName, statusID: 5 };
                            })
                        )
                    );
                } else {
                    dispatch(getBusinessUnitDropdown([]));
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadCustomFieldsForUser = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null; // Should be set correctly now

        // Assign CustomerID based on SignInType if selectedCompanyID is not provided
        if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "User") {
            CustomerID = signInDetails?.[0]?.CompanyID;
        }
        fetch(`${baseURL}/excomatixservices/api/CustomField/GetCustomFieldDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ CustomFields_ModuleIDFK: 3, CustomFields_CompanyIDFK: CustomerID, CustomFields_StatusIDFK: 26 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomFieldsForUser(resp.CustomFields));
                // setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadLicenceDashboardCardData = (licenseExpiryDays, setLoading) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        const storedEmail = signInDetails[0].EmailID || null;
        const data = {
            EmailID: storedEmail
        };

        // If licenseExpiryDays is provided, add it to the body object
        if (licenseExpiryDays) {
            data.LicenseExpiryDays = licenseExpiryDays;
        }
        fetch(`${baseURL}/userservices/api/User/GetUsersCountSummary`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLicenceDashboardCardData(resp.Users));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadUserModuleFieldNameData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 3 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getUsersModuleFieldNameData(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const loadUserCustomFieldData = (
    setLoading,
    // customFields,
    userID
) => {
    return function (dispatch) {
        // const companyID = customFields[0]?.CompanyID || null;
        let companyID = null; // Should be set correctly now

        // Assign CustomerID based on SignInType if selectedCompanyID is not provided
        if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
            companyID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
            companyID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "User") {
            companyID = signInDetails?.[0]?.CompanyID;
        }
        fetch(`${baseURL}/excomatixservices/api/CustomFieldValue/GetCustomFieldValueDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                CompanyID: companyID,
                ModuleID: 3,
                ReferenceID: userID
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getUsersCustomFieldData(resp.CustomFieldsValues));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadLicenceDashboardLicenseStatusChartData = (companyName, year) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        const storedEmail = signInDetails[0].EmailID || null;
        fetch(`${baseURL}/userservices/api/User/GetLicenseStatusCountStats`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "CompanyID": companyName, "Year": year })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLicenceDashboardLicenceStatusChartDataData(resp.Licenses));
            })
            .catch((err) => { console.log(err) });
    }
}
export const loadLicenceDashboardBarchartLicenseDetailsData = (companyName, year) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        const storedEmail = signInDetails[0].EmailID || null;
        fetch(`${baseURL}/userservices/api/User/GetCompanyYearwiseLicenseCountStat`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "CompanyID": companyName, "Year": year })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLicenceDashboardBarchartLicenceDetailsData(resp.BranchLicenses));
            })
            .catch((err) => { console.log(err) });
    }
}
export const loadLicenceDashboardBarchartLicenseSplitUpData = (companyName) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        const storedEmail = signInDetails[0].EmailID || null;
        fetch(`${baseURL}/userservices/api/User/GetCompanyBranchwiseLicenseSplitup`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "CompanyID": companyName })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLicenceDashboardBarchartLicenceSplitUpData(resp.BranchLicenses));
            })
            .catch((err) => { console.log(err) });
    }
}
export const loadUserSlocsDropdownData = (CompanyID, ReportingToID) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

        let CustomerID = null;
        let UserID = null;

        if (signInDetails[0]?.SignInType === "User") {
            CustomerID = signInDetails[0]?.CompanyID;
            UserID = signInDetails[0]?.UserID;
        }

        fetch(`${baseURL}/userservices/api/User/GetUserDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ CustomerID: CustomerID, UserID: UserID, StatusID: 16 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Users && Array.isArray(resp.Users)) {
                    const allSlocs = resp.Users.flatMap(user =>
                        (user.UserSloc || []).map(sloc => ({
                            value: sloc.BranchID,
                            label: sloc.BranchName
                        }))
                    );

                    dispatch(getUserSlocsDropdownData(allSlocs));
                } else {
                    dispatch(getUserSlocsDropdownData([]));
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
export const postUserManagementBulkDatas = (
    postRequest,
    cancelModal,
    userManagenemtData,
    setBulkUploadErrorMessage,
    setBulkUploadErrorFilePath
) => {
    return function (dispatch) {
        fetch(`${baseURL}/userservices/api/User/PostBulkAddUser`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postUserManagementBulkData());
                    cancelModal();
                    userManagenemtData();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    setBulkUploadErrorMessage(errorMessage);
                    // ✅ Save the error file path
                    if (resp.FilePath) {
                        setBulkUploadErrorFilePath(resp.FilePath);
                    }
                }
            })
            .catch((err) => { console.log(err) });
    }
};
export const loadUserManagementBulkUploadTemplates = (
    postRequest,
    setIsDownloading,
    setIsDownloadComplete,
    fileName
) => {
    return function (dispatch) {
        setIsDownloading(true);
        setIsDownloadComplete(false);

        fetch(`${baseURL}/excomatixservices/api/BulkUpload/GetBulkUploadSample`, postRequest)
            .then((resp) => {
                if (!resp.ok) throw new Error("Failed to download template");
                return resp.blob(); // get the file blob
            })
            .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName; // Customize filename
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);

                dispatch(getUserManagementBulkUploadTemplate());
                setIsDownloadComplete(true);
                setTimeout(() => setIsDownloadComplete(false), 3000);
            })
            .catch((err) => {
                console.error("Download error:", err);
            })
            .finally(() => {
                setIsDownloading(false);
            });
    };
};
// User Management

// Complaint/Escalation 
export const loadComplaintEscalationData = (
    TicketType,
    StatusID,
    SearchText,
    searchParams,
    whereClause,
    setLoading
) => {
    return function (dispatch) {
        let data = {}
        if (TicketType) {
            data.TicketType = TicketType
        }
        if (StatusID) {
            data.StatusID = StatusID
        }
        if (SearchText) {
            data.ComplaintID = parseInt(SearchText)
        }

        if (searchParams) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = searchParams;
        }

        if (whereClause) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = whereClause;
        }

        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

        let CustomerID = null;
        let ReportedByUserID = null; // Declare UserID to handle the "User" case
        let AssignedToUserID = null;
        let RoleIDs = null;

        // Check the SignInType and assign appropriate IDs
        if (signInDetails[0]?.SignInType === "SuperAdmin") {
            // CustomerID = signInDetails[0]?.CompanyID; // Assuming SuperAdminID is available in SignInDetails
            CustomerID = null; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0]?.SignInType === "User") {
            // CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for User type
            ReportedByUserID = signInDetails[0]?.UserID; // Use UserID for User type
            AssignedToUserID = signInDetails[0]?.UserID;
            RoleIDs = signInDetails[0]?.RoleIDs;
        }

        // Add CustomerID and UserID to the data object
        if (CustomerID) {
            data.CompanyID = CustomerID; // Add CustomerID to data
        }
        if (ReportedByUserID) {
            data.ReportedByUserID = ReportedByUserID; // Add UserID to data if it exists
        }
        if (AssignedToUserID) {
            data.AssignedToUserID = AssignedToUserID; // Add UserID to data if it exists
        }
        if (RoleIDs) {
            data.RoleIDs = RoleIDs; // Add UserID to data if it exists
        }

        fetch(`${baseURL}/complaintservices/api/Complaint/GetComplaintDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getComplainEscalationData(resp.Complaints));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadIssueTypeDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/IssueType/GetIssueTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                "statusID": 12
            }),
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.IssueTypes) {
                    dispatch(
                        getIssueTypeDropdownData(
                            resp.IssueTypes.map((data) => {
                                return { value: data.IssueTypeID, label: data.IssueTypeName };
                            })
                        )
                    );
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const loadSingleComplaintEscalationData = (
    complaintId,
) => {
    return function (dispatch) {
        fetch(`${baseURL}/complaintservices/api/Complaint/GetComplaintDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                "ComplaintID": complaintId
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                console.log(resp, 'resp')
                dispatch(getSingleComplainEscalationData(resp.Complaints));
            })
            .catch((err) => { console.log(err) });
    };
};

export const postComplaintEscalationDatas = (
    postRequest,
    cancelModal,
    handleCloseModal,
    complaintId,
    customFields
) => {
    return function (dispatch) {
        const url = complaintId ?

            `${baseURL}/complaintservices/api/Complaint/PostUpdateComplaint`
            :
            `${baseURL}/complaintservices/api/Complaint/PostAddComplaint`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postComplaintEscalationData());
                    handleCloseModal()
                    // ✅ Only proceed if there are any updated custom fields
                    let extractedReferenceID = complaintId;
                    if (!complaintId && resp.Msg.includes("Reference ID:")) {
                        extractedReferenceID = parseInt(
                            resp.Msg.split("Reference ID: ")[1]?.trim(),
                            10
                        );
                    }
                    const changedFields = customFields.filter(field =>
                        field.CustomField_Value && field.CustomField_Value.trim() !== ""
                    );
                    // if (customFields.length !== 0) {
                    if (changedFields.length > 0) {
                        // Extract CompanyID (assuming all custom fields have the same CompanyID)
                        const companyID = customFields[0]?.CompanyID || null;
                        // Filter customFields to send only the required fields
                        const filteredCustomFields = customFields.map(field => {
                            // Check if CustomField_Value is defined, otherwise fall back to an empty string
                            const fieldValue = field.CustomField_Value || "";
                            return {
                                CustomFieldID: field.CustomFieldsID, // or use field.CustomField_IDFK if needed
                                Value: fieldValue, // The value of the custom field
                            };
                        });
                        console.log(customFields, 'customFields')
                        let postCustomData = {
                            method: "POST",
                            mode: "cors",
                            headers: HeaderAuthentication.postExcomatixAuth,
                            body: JSON.stringify({
                                CompanyID: companyID,
                                ModuleID: 5,
                                CustomFieldValuesList: filteredCustomFields,
                                AddedByID: ADDED_BY_ID,
                                ReferenceID: extractedReferenceID
                            }),
                        };
                        dispatch(postCustomFieldValuesOfCompany(postCustomData, cancelModal));
                    }
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const postAssignComplaintEscalationDatas = (
    postRequest,
    cancelModal,
    getComplaintData
) => {
    return function (dispatch) {
        fetch(`${baseURL}/complaintservices/api/Complaint/PostAssignComplaint`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postAssignComplaintEscalationData());
                    getComplaintData();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const postComplaintEscalationStatusChangeDatas = (
    postRequest,
    cancelModal,
    getComplaintData
) => {
    return function (dispatch) {
        fetch(`${baseURL}/complaintservices/api/Complaint/PostChangeComplaintStatus`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postComplaintEscalationChangeStatusData());
                    getComplaintData();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const postComplaintEscalationERTDatas = (
    postRequest,
    cancelModal,
    getComplaintData
) => {
    return function (dispatch) {
        fetch(`${baseURL}/complaintservices/api/Complaint/PostChangeComplaintTATInDays`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postComplaintEscalationERTData());
                    getComplaintData();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const loadComplaintEscalationDashboardCardData = (setLoading) => {
    return function (dispatch) {
        fetch(`${baseURL}/complaintservices/api/Complaint/GetComplaintsSummaryStats`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getComplaintEscalationsDashboardCardData(resp.Complaints));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadComplaintEscalationBarChartTicketData = (companyName, year) => {
    return function (dispatch) {
        fetch(`${baseURL}/complaintservices/api/Complaint/GetComplaintStatsOfYear`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "CompanyID": companyName, "Year": year })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getComplaintEscalationsBarChartTicketData(resp.Complaints));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadComplaintEscalationPriorityStatusData = (companyName, year) => {
    return function (dispatch) {
        fetch(`${baseURL}/complaintservices/api/Complaint/GetComplaintsPriorityStats`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "CompanyID": companyName, "Year": year })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getComplaintEscalationsPriorityStatusData(resp.Complaints));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadComplaintEscalationStatusData = (companyName, year, ticketType) => {
    return function (dispatch) {
        fetch(`${baseURL}/complaintservices/api/Complaint/GetComplaintsStatusStatsOfYear`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "CompanyID": companyName, "Year": year, "TicketType": ticketType })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getComplaintEscalationsStatusData(resp.Complaints));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadComplaintEscalationBranchStatusData = (companyName, year) => {
    return function (dispatch) {
        fetch(`${baseURL}/complaintservices/api/Complaint/GetComplaintsBranchStatusStats`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "CompanyID": companyName, "Year": year, })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getComplaintEscalationsBranchStatusData(resp.Complaints));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadComplaintEscalationIssueTypeData = (companyName, year) => {
    return function (dispatch) {
        fetch(`${baseURL}/complaintservices/api/Complaint/GetComplaintsIssuesStats`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail, "CompanyID": companyName, "Year": year, })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getComplaintEscalationsIssueTypeData(resp.Complaints));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadComplaintEscalationModuleFieldNameData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 5 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getComplaintEscalationModuleFieldNameData(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const loadComplaintEscalationStatusDropdownData = (complaintId) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        fetch(`${baseURL}/complaintservices/api/Complaint/GetComplaintStatusOptions`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                ComplaintID: complaintId,
                RoleIDs: signInDetails[0]?.RoleIDs
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Complaints) {
                    dispatch(
                        getComplaintEscalationStatusDropdownData(
                            resp.Complaints.map((data) => {
                                return {
                                    value: data.StatusID,
                                    label: data.Status
                                };
                            })
                        )
                    );
                } else {
                    dispatch(getComplaintEscalationStatusDropdownData([]));
                }
            })
    }
}
export const loadComplaintEscalationHistoryData = (
    complaintId
) => {
    return function (dispatch) {
        fetch(`${baseURL}/complaintservices/api/Complaint/GetComplaintDetailsByID?ComplaintID=${complaintId}`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify()
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getComplaintEscalationHistoryData(resp.ComplaintDetails));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadTechnicalDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/userservices/api/User/GetRoleBasedUsers`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ RoleIDs: 16 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Users) {
                    dispatch(
                        getTechnicalData(
                            resp.Users.map((data) => {
                                return {
                                    value: data.UserID,
                                    label: data.UserName
                                };
                            })
                        )
                    );
                }
            })
    }
}
export const loadQADropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/userservices/api/User/GetRoleBasedUsers`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ RoleIDs: 17 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Users) {
                    dispatch(
                        getQAData(
                            resp.Users.map((data) => {
                                return {
                                    value: data.UserID,
                                    label: data.UserName
                                };
                            })
                        )
                    );
                }
            })
    }
}
export const loadComplaintsCustomFieldData = (
    setLoading,
    // customFields,
    complaintId
) => {
    return function (dispatch) {
        // const companyID = customFields[0]?.CompanyID || null;
        let companyID = null; // Should be set correctly now

        // Assign CustomerID based on SignInType if selectedCompanyID is not provided
        if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
            companyID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
            companyID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "User") {
            companyID = signInDetails?.[0]?.CompanyID;
        }
        fetch(`${baseURL}/excomatixservices/api/CustomFieldValue/GetCustomFieldValueDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                CompanyID: companyID,
                ModuleID: 5,
                ReferenceID: complaintId
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getComplaintCustomFieldData(resp.CustomFieldsValues));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
// Complaint/Escalation 

// Service Level Agreement
export const loadAssignedToSlaData = (
    setLoading,
    SearchText,
    searchParams,
    whereClause,
    type
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

        // Initialize the request body
        let CustomerID = null;
        let AssignedToID = null; // Declare UserID to handle the "User" case
        let Type = null;

        // Check the SignInType and assign appropriate IDs
        if (signInDetails[0]?.SignInType === "SuperAdmin") {
            CustomerID = null; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0]?.SignInType === "User") {
            // CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for User type
            AssignedToID = signInDetails[0]?.UserID; // Use UserID for User type
            Type = type;
        }
        // let requestBody = {};
        // if (CustomerID) {
        const requestBody = {
            CustomerID: CustomerID,
        };
        // Add UserID to the payload if it exists
        if (AssignedToID) {
            requestBody.AssignedToID = AssignedToID;
        }
        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SLAID = SearchText; // Assuming you want to search by Company Name
        }
        if (searchParams) {
            requestBody.ValueFilterType = "B";
            requestBody.ValueFilterWhereClause = searchParams;
        }

        if (whereClause) {
            requestBody.ValueFilterType = "B";
            requestBody.ValueFilterWhereClause = whereClause;
        }
        if (Type) {
            requestBody.Type = Type; // ✅ attach only for User
        }
        setLoading(true);
        fetch(`${baseURL}/excomatixservices/api/ServiceLevelAgreement/GetServiceLevelAgreementDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getAssignedToServiceLevelAgreementData(resp.ServiceLevelAgreement));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
        // }
    };
};
export const loadSingleAssignedToSlaData = (slaId) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ServiceLevelAgreement/GetServiceLevelAgreementDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                SLAID: slaId
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleAssignedToServiceLevelAgreementData(resp.ServiceLevelAgreement));
            })
            .catch((err) => { console.log(err) });
    };
};

export const postAssignedToSlaDatas = (
    postRequest,
    cancelModal,
    assignedToSlaDatas,
    slaId,
    imgChange,
    setImgChange
) => {
    return function (dispatch) {
        const url = slaId ?
            `${baseURL}/excomatixservices/api/ServiceLevelAgreement/PostUpdateServiceLevelAgreement`
            :
            `${baseURL}/excomatixservices/api/ServiceLevelAgreement/PostAddServiceLevelAgreement`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postAssignedToServiceLevelAgreementData());
                    assignedToSlaDatas()
                    cancelModal();
                    if (imgChange) {
                        setImgChange(false)
                    }
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
};
export const loadAssignedToSlaTypeDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ServiceLevelAgreement/GetSlaTypes`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({})
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.SLAType) {
                    dispatch(
                        getAssignedToServiceLevelAgreementDropdownData(
                            resp.SLAType.map((data) => {
                                return { value: data.SLATypeID, label: data.SLATypeName };
                            })
                        )
                    );
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSlaCategoryDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/SLACategories/GetSLACategoriesDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ StatusID: 14 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp['SLA Categories']) {
                    dispatch(
                        getServiceLevelAgreementCategoryDropdownData(
                            resp['SLA Categories'].map((data) => {
                                return { value: data.SLACategoriesID, label: data.SLACategoriesName };
                            })
                        )
                    );
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const loadSLADashboardCardData = (setLoading) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ServiceLevelAgreement/GetSLASummaryStats`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "EmailID": storedEmail })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getServiceLevelAgreementDashboardCardData(resp.SLAs));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSLADashboardSlaTypeStatusChartData = (companyName, assignedToId, slaTypeId, year) => {
    // Prepare the request body
    const requestBody = {
        "EmailID": storedEmail,
        "CompanyID": companyName,
        "Year": year
    };

    // Conditionally add the AssignedToUserID if assignedToId is provided
    if (assignedToId) {
        requestBody.AssignedToUserID = assignedToId;
    }

    // Conditionally add the SLATypeID if slaTypeId is provided
    if (slaTypeId) {
        requestBody.SLATypeID = slaTypeId;
    }

    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ServiceLevelAgreement/GetSLATypesStatusStatsOfYear`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getServiceLevelAgreementDashboardSlaTypeStatusData(resp.SLAs));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSLADashboardSlaTypesChartData = (companyName, assignedToId, slaTypeId, year) => {
    // Prepare the request body
    const requestBody = {
        "EmailID": storedEmail,
        "CompanyID": companyName,
        "Year": year
    };

    // Conditionally add the AssignedToUserID if assignedToId is provided
    if (assignedToId) {
        requestBody.AssignedToUserID = assignedToId;
    }

    // Conditionally add the SLATypeID if slaTypeId is provided
    if (slaTypeId) {
        requestBody.SLATypeID = slaTypeId;
    }

    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ServiceLevelAgreement/GetSLAAchievedStatsOfYear`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getServiceLevelAgreementDashboardSlaTypesData(resp.SLAs));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSLADashboardAssignedScoreData = (companyName, assignedToId, year) => {
    // Prepare the request body
    const requestBody = {
        "EmailID": storedEmail,
        "CompanyID": companyName,
        "Year": year
    };

    // Conditionally add the AssignedToUserID if assignedToId is provided
    if (assignedToId) {
        requestBody.AssignedToUserID = assignedToId;
    }

    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ServiceLevelAgreement/GetSLAAssignedScore`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getServiceLevelAgreementAssignedScoreData(resp.SLAs));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSLADashboardTotalSlaChartData = (companyName, assignedToId, year) => {
    // Prepare the request body
    const requestBody = {
        "EmailID": storedEmail,
        "CompanyID": companyName,
        "Year": year
    };

    // Conditionally add the AssignedToUserID if assignedToId is provided
    if (assignedToId) {
        requestBody.AssignedToUserID = assignedToId;
    }

    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ServiceLevelAgreement/GetSLAStatusStatsOfYear`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getServiceLevelAgreementTotalSlaChartData(resp.SLA));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSLADashboardChecklistStatusChartData = (companyName, assignedToId, slaTypeId, year) => {
    // Prepare the request body
    const requestBody = {
        "EmailID": storedEmail,
        "CompanyID": companyName,
        "Year": year
    };

    // Conditionally add the AssignedToUserID if assignedToId is provided
    if (assignedToId) {
        requestBody.AssignedToUserID = assignedToId;
    }

    // Conditionally add the SLATypeID if slaTypeId is provided
    if (slaTypeId) {
        requestBody.SLATypeID = slaTypeId;
    }

    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ServiceLevelAgreement/GetSLAChecklistStatusStatsOfYear`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getServiceLevelAgreementDashboardChecklistStatusChartData(resp.SLAs));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadAssignToSlaModuleFieldNameData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 6 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getAssignToSlaModuleFieldDropdownData(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const loadUpdateSlaData = (
    setLoading,
    // SearchText,
    // searchParams,
    // whereClause
    slaId
) => {
    return function (dispatch) {
        // let requestBody = {};
        // // If SearchText is provided, add it to the requestBody
        // if (SearchText) {
        //     requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        // }
        // if (searchParams) {
        //     requestBody.ValueFilterType = "B";
        //     requestBody.ValueFilterWhereClause = searchParams;
        // }
        // if (whereClause) {
        //     requestBody.ValueFilterType = "B";
        //     requestBody.ValueFilterWhereClause = whereClause;
        // }
        fetch(`${baseURL}/excomatixservices/api/ServiceLevelAgreement/GetSLAUpdates`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ SLAID: slaId })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getUpdateSlaData(resp.SLAUpdates));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const postUpdateSlaDatas = (
    postRequest,
    cancelModal,
    updatedSlaDatas,
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ServiceLevelAgreement/PostAddSLAUpdate`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postUpdateSla());
                    updatedSlaDatas()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
};
export const loadCustomFieldsForComplaints = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null; // Should be set correctly now

        // Assign CustomerID based on SignInType if selectedCompanyID is not provided
        if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "User") {
            CustomerID = signInDetails?.[0]?.CompanyID;
        }
        fetch(`${baseURL}/excomatixservices/api/CustomField/GetCustomFieldDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ CustomFields_ModuleIDFK: 5, CustomFields_CompanyIDFK: CustomerID, CustomFields_StatusIDFK: 26 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getComplaintsCustomFields(resp.CustomFields));
                // setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
// Service Level Agreement

// Workqueues
export const loadWorkquesData = (
    setLoading,
    SearchText,
    ModuleID,
    searchParams,
    whereClause
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let data = {}
        if (SearchText) {
            data.WorkQueueID = SearchText
        }
        if (ModuleID) {
            data.ModuleID = ModuleID
        }
        if (searchParams) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = searchParams;
        }
        if (whereClause) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = whereClause;
        }

        let AssignedToID = null;
        let AssignedToType = null;

        if (signInDetails && signInDetails.length > 0 && signInDetails[0]?.SignInType === "ClientAdmin") {
            AssignedToID = signInDetails[0]?.CompanyID; // Use CompanyID for ClientAdmin
            AssignedToType = signInDetails[0]?.SignInType; // Use CompanyID for ClientAdmin
        }

        // ✅ Add SigninType and SigninID to the payload
        data.AssignedToType = AssignedToType;
        data.AssignedToID = AssignedToID;

        fetch(`${baseURL}/excomatixservices/api/WorkQueue/GetWorkQueueExecutedList`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getWorkqueuesData(resp.WorkQueueExeccutedList));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadViewAssignedWorkquesData = (
    setLoading,
    SearchText,
    ModuleID,
    searchParams,
    whereClause
) => {
    return function (dispatch) {
        let data = {}
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let AssignedToID = null; // Should be set correctly now
        let AssignedToType = null; // Should be set correctly now

        // Assign CustomerID based on SignInType if selectedCompanyID is not provided
        if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
            AssignedToID = signInDetails?.[0]?.SuperAdminID;
            AssignedToType = signInDetails[0].SignInType;
        } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
            AssignedToID = signInDetails?.[0]?.CompanyID;
            AssignedToType = signInDetails[0].SignInType;
        } else if (signInDetails?.[0]?.SignInType === "User") {
            AssignedToID = signInDetails?.[0]?.UserID;
            AssignedToType = signInDetails[0].SignInType;
        }

        // ✅ Include AssignedToID in the request body
        data.AssignedToID = AssignedToID;
        data.AssignedToType = AssignedToType;

        if (SearchText) {
            data.WorkQueueID = SearchText
        }
        if (ModuleID) {
            data.ModuleID = ModuleID
        }
        if (searchParams) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = searchParams;
        }
        if (whereClause) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = whereClause;
        }

        fetch(`${baseURL}/excomatixservices/api/WorkQueue/GetWorkQueueExecutedList`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getViewAssignedWorkqueueData(resp.WorkQueueExeccutedList));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleWorkquesData = (
    // setLoading,
    WorkQueueId
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/WorkQueue/GetWorkQueueExecutedData`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "WorkQueueID": WorkQueueId })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleWorkqueuesData(resp.Data));
                // setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};

export const updateWorkqueuesPriorityStatus = (
    postRequest,
    cancelModal,
    workqueuesDatas,
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/WorkQueue/PostUpdateWorkQueuePriority`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(updateWorkqueuesPriorityStatusData());
                    // workqueuesDatas()
                    dispatch(loadWorkquesData())
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const postSetAssignToDatas = (
    postRequest,
    cancelModal,
    workqueuesDatas,
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/WorkQueue/PostAssignWorkQueue`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postSetAssignToData());
                    workqueuesDatas();
                    dispatch(loadWorkquesData());
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const loadUserDropdownDataBasedDepartment = (departmentId) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        // Initialize the request body
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs
        if (signInDetails[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0]?.CompanyID;; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0]?.SignInType === "User") {
            // CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for User type
            CustomerID = signInDetails[0]?.CompanyID; // Use UserID for User type
        }
        fetch(`${baseURL}/userservices/api/User/GetUserDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ DepartmentID: departmentId, StatusID: 16, CustomerID: CustomerID })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Users) {
                    dispatch(
                        getUserdropdownBasedOnDepartment(
                            resp.Users.map((data) => {
                                return { value: data.UserID, label: `${data.FirstName} ${data.LastName}`, StatusID: 16 };
                            })
                        )
                    );
                }
                else {
                    dispatch(getUserdropdownBasedOnDepartment([]));
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadWorkqueueModuleFieldNameData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 7 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getWorkqueueModuleFieldNameData(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
// Workqueues

// Leave and Holiday
export const loadLeaveBalanceData = (
    setLoading,
    fromDate,
    toDate,
    SearchText
    // UserID
) => {
    return function (dispatch) {
        // const requestBody = UserID ? { UserID } : {};
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let requestBody = { StartDate: fromDate, EndDate: toDate }; // Include StartDate and EndDate
        if (SearchText) {
            requestBody.LeaveBalanceID = SearchText; // Assuming you want to search by Company Name
        }

        if (signInDetails[0]?.SignInType === "User") {
            requestBody.UserID = signInDetails[0]?.UserID; // Add UserID only for Users
        }
        fetch(`${baseURL}/excomatixservices/api/LeaveBalance/GetLeaveBalanceDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLeaveBalanceData(resp.LeaveBalance));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleLeaveBalanceData = (
    // setLoading,
    LeaveBalanceUserID,
    startDate,
    endDate
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/LeaveBalance/GetLeaveBalanceDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ UserID: LeaveBalanceUserID, StartDate: startDate, EndDate: endDate })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleLeaveBalanceData(resp.LeaveBalance));
                // setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadLeaveData = (
    setLoading,
    pageSize,
    currentPage,
    SearchText,
    StartDate,
    EndDate,
    // LeaveBalanceUserID,
    // startDate,
    // endDate
) => {
    return function (dispatch) {
        const requestBody = {
            "PageSize": pageSize,
            "PageIndex": currentPage
        }
        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.LeaveID = SearchText; // Assuming you want to search by Company Name
        }
        if (StartDate) {
            requestBody.StartDate = StartDate; // Assuming you want to search by Company Name
        }
        if (EndDate) {
            requestBody.EndDate = EndDate; // Assuming you want to search by Company Name
        }
        fetch(`${baseURL}/excomatixservices/api/Leave/GetLeavesDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLeaveData(resp.Leaves));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadLeavesCountData = (
    setLoading,
    pageSize,
    currentPage,
    SearchText,
    StartDate,
    EndDate
) => {
    return function (dispatch) {
        const requestBody = {
            "PageSize": pageSize,
            "PageIndex": currentPage
        }
        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }
        if (StartDate) {
            requestBody.StartDate = StartDate; // Assuming you want to search by Company Name
        }
        if (EndDate) {
            requestBody.EndDate = EndDate; // Assuming you want to search by Company Name
        }
        fetch(`${baseURL}/excomatixservices/api/Leave/GetLeavesDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLeavesCount(resp));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadLeavesBalanceCount = (
    setLoading,
    UserID,
    StartDate,
    EndDate
) => {
    return function (dispatch) {
        const requestBody = {
            "UserID": UserID, // Adding UserID to the request body
        };

        if (StartDate) {
            requestBody.StartDate = StartDate; // Assuming you want to search by Start Date
        }
        if (EndDate) {
            requestBody.EndDate = EndDate; // Assuming you want to search by End Date
        }

        fetch(`${baseURL}/excomatixservices/api/LeaveBalance/GetLeaveBalanceCount`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLeaveBalanceCount(resp.LeaveBalanceCount));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadLeavesDuration = (
    // setLoading,
    leaveTypeId,
    StartDate,
    EndDate,
    settLeaveDurationApi
) => {
    return function (dispatch) {
        const requestBody = {
            "LeaveTypeID": leaveTypeId,
            "StartDate": StartDate,
            "EndDate": EndDate,
        };

        // if (StartDate) {
        //     requestBody.StartDate = StartDate; // Assuming you want to search by Start Date
        // }
        // if (EndDate) {
        //     requestBody.EndDate = EndDate; // Assuming you want to search by End Date
        // }

        fetch(`${baseURL}/excomatixservices/api/Leave/GetLeavesDurationDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLeaveDuration(resp));
                settLeaveDurationApi(resp.LeaveDuration);
                // setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleLeaveData = (
    setLoading,
    pageSize,
    currentPage,
    SearchText,
    StartDate,
    EndDate,
    LeaveID,
    UserID,
    ReportingToID
    // LeaveBalanceUserID,
    // startDate,
    // endDate
) => {
    return function (dispatch) {
        const requestBody = {
            "PageSize": pageSize,
            "PageIndex": currentPage
        }
        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }
        if (StartDate) {
            requestBody.StartDate = StartDate; // Assuming you want to search by Company Name
        }
        if (EndDate) {
            requestBody.EndDate = EndDate; // Assuming you want to search by Company Name
        }
        if (LeaveID) {
            requestBody.LeaveID = LeaveID; // Include LeaveID if provided
        }
        if (UserID) {
            requestBody.UserID = UserID; // Include LeaveID if provided
        }
        if (ReportingToID) {
            requestBody.ReportingToID = ReportingToID; // Include LeaveID if provided
        }
        fetch(`${baseURL}/excomatixservices/api/Leave/GetLeavesDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleLeaveData(resp.Leaves));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadPendingLeaveData = (
    setLoading,
    pageSize,
    currentPage,
    SearchText,
    StartDate,
    EndDate,
    // LeaveBalanceUserID,
    // startDate,
    // endDate
) => {
    return function (dispatch) {
        const requestBody = {
            "PageSize": pageSize,
            "PageIndex": currentPage,
            "StatusID": 58,
        }
        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.LeaveID = SearchText; // Assuming you want to search by Company Name
        }
        if (StartDate) {
            requestBody.StartDate = StartDate; // Assuming you want to search by Company Name
        }
        if (EndDate) {
            requestBody.EndDate = EndDate; // Assuming you want to search by Company Name
        }
        fetch(`${baseURL}/excomatixservices/api/Leave/GetLeavesDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getPendingLeaveData(resp.Leaves));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadApprovedLeaveData = (
    setLoading,
    pageSize,
    currentPage,
    SearchText,
    StartDate,
    EndDate,
    // LeaveBalanceUserID,
    // startDate,
    // endDate
) => {
    return function (dispatch) {
        const requestBody = {
            "PageSize": pageSize,
            "PageIndex": currentPage,
            "StatusID": 59,
        }
        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.LeaveID = SearchText; // Assuming you want to search by Company Name
        }
        if (StartDate) {
            requestBody.StartDate = StartDate; // Assuming you want to search by Company Name
        }
        if (EndDate) {
            requestBody.EndDate = EndDate; // Assuming you want to search by Company Name
        }
        fetch(`${baseURL}/excomatixservices/api/Leave/GetLeavesDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getApprovedLeaveData(resp.Leaves));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadRejectedLeaveData = (
    setLoading,
    pageSize,
    currentPage,
    SearchText,
    StartDate,
    EndDate,
    // LeaveBalanceUserID,
    // startDate,
    // endDate
) => {
    return function (dispatch) {
        const requestBody = {
            "PageSize": pageSize,
            "PageIndex": currentPage,
            "StatusID": 60,
        }
        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.LeaveID = SearchText; // Assuming you want to search by Company Name
        }
        if (StartDate) {
            requestBody.StartDate = StartDate; // Assuming you want to search by Company Name
        }
        if (EndDate) {
            requestBody.EndDate = EndDate; // Assuming you want to search by Company Name
        }
        fetch(`${baseURL}/excomatixservices/api/Leave/GetLeavesDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getRejectedLeaveData(resp.Leaves));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const postLeaveBalanceDatas = (
    postRequest,
    cancelModal,
    LeaveBalanceUserID,
    getLeaveBalanceData,
    setError
) => {
    return function (dispatch) {
        const url = LeaveBalanceUserID ?

            `${baseURL}/excomatixservices/api/LeaveBalance/PostUpdateLeaveBalance`
            :
            `${baseURL}/excomatixservices/api/LeaveBalance/PostAddLeaveBalance`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postLeaveBalanceData());
                    getLeaveBalanceData();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    // Swal.fire({
                    //     title: 'Failed',
                    //     text: errorMessage,
                    //     icon: 'error',
                    // });
                    setError(errorMessage);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const postApplyLeaveDatas = (
    postRequest,
    cancelModal,
    // LeaveBalanceUserID,
    leavesData,
    fetchSingleLeaveData,
    setError
) => {
    return function (dispatch) {
        // const url = LeaveBalanceUserID ?

        //     `${baseURL}/excomatixservices/api/LeaveBalance/PostUpdateLeaveBalance`
        //     :
        //     `${baseURL}/excomatixservices/api/LeaveBalance/PostAddLeaveBalance`
        fetch(`${baseURL}/excomatixservices/api/Leave/PostAddLeaves`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postApplyLeaveData());
                    leavesData();
                    fetchSingleLeaveData();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    // Swal.fire({
                    //     title: 'Failed',
                    //     text: errorMessage,
                    //     icon: 'error',
                    // });
                    setError(errorMessage);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const postUpdateLeaveDatas = (
    postRequest,
    cancelModal,
    leavesData,
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Leave/PostUpdateLeaveStatus`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postUpdateLeaveData());
                    leavesData();
                    dispatch(loadSingleLeaveData());
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
// Leave and Holiday

// System Logging
export const loadModuleNameDropdownDataForSystemLogging = () => {
    return function (dispatch) {
        fetch(`${baseURL}/Excomatixservices/api/Modules/GetModulesForSysLog`, HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Modules) {
                    dispatch(
                        getModuleNameForSystemLogging(
                            resp.Modules.map((data) => {
                                return { value: data.Module, label: data.Module };
                            })
                        )
                    );
                }
            })
            .catch((err) => { console.log(err) });
    };
};

// Exception Log
export const loadExceptionLoggingData = (
    fromDate, toDate, SearchText,
    setLoading,
) => {
    return function (dispatch) {
        const requestBody = {
            StartDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : "", // Format using moment
            EndDate: toDate ? moment(toDate).format('YYYY-MM-DD') : "" // Format using moment
        };
        if (SearchText) {
            requestBody.ExceptionID = SearchText; // Assuming you want to search by Company Name
        }
        fetch(`${baseURL}/excomatixservices/api/SystemLogging/GetExceptionLogDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getExceptionLoggingData(resp.ExceptionLog));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleExceptionLoggingData = (
    ExceptionID
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/SystemLogging/GetExceptionLogDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ExceptionID": ExceptionID })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleExceptionLoggingData(resp.ExceptionLog));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadAuditTrialData = (
    fromDate, toDate, SearchText, ModuleName, pageSize,
    currentPage,
    setLoading,
) => {
    return function (dispatch) {
        const requestBody = {
            StartDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : "", // Format using moment
            EndDate: toDate ? moment(toDate).format('YYYY-MM-DD') : "", // Format using moment
            "PageSize": pageSize,
            "PageIndex": currentPage
        };
        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.ActivityLogID = SearchText; // Assuming you want to search by Company Name
        }
        if (ModuleName) {
            requestBody.ModuleName = ModuleName; // Assuming you want to search by Company Name
        }
        fetch(`${baseURL}/excomatixservices/api/SystemLogging/GetAuditTrailDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getAuditTrialData(resp.AuditTrail));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const downloadAuditTrialDatas = (
    fromDate, toDate, SearchText, ModuleName, setLoading, setIsDownloading
) => {
    return function (dispatch) {
        const requestBody = {
            StartDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : "", // Format using moment
            EndDate: toDate ? moment(toDate).format('YYYY-MM-DD') : "", // Format using moment
        };
        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }
        if (ModuleName) {
            requestBody.ModuleName = ModuleName; // Assuming you want to search by Company Name
        }
        fetch(`${baseURL}/excomatixservices/api/SystemLogging/GetAuditTrailDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(downloadAuditTrialData(resp.AuditTrail));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
                setIsDownloading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
// Exception Log
// System Logging

// Settings Department
export const postDepartmentDatas = (
    postRequest,
    cancelModal,
    deptData,
    deptID
) => {
    return function (dispatch) {
        const url = deptID ?
            `${baseURL}/excomatixservices/api/department/PostUpdateDepartment`
            :
            `${baseURL}/excomatixservices/api/department/PostAddDepartment`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postDepartmentData());
                    deptData()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
            });
    }
};

export const loadDepartmentData = (setLoading, statusID, whereClause, pageSize, currentPage) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

        // Initialize CustomerID as null
        let CustomerID = null;

        // Assign CustomerID based on SignInType
        if (signInDetails[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // SuperAdmin has no specific CompanyID
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // Assign CompanyID for ClientAdmin
        } else if (signInDetails[0]?.SignInType === "User") {
            CustomerID = signInDetails[0]?.CompanyID; // Assign CompanyID for User
        }

        // Construct request body
        const requestBody = {
            "CompanyID": CustomerID
        };

        // let data = {}
        if (statusID) {
            requestBody.statusID = statusID
        }
        if (whereClause) {
            requestBody.ValueFilterType = "B";
            requestBody.ValueFilterWhereClause = whereClause;
        }
        fetch(`${baseURL}/excomatixservices/api/department/PostDepartmentDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            // body: JSON.stringify({
            //     "DeptID": 0,
            //     "StatusID": 0,
            //     "DepartmentName": "",
            //     "PageSize": pageSize,
            //     "PageIndex": currentPage
            // })
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getDepartmentData(resp.Departments));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};

export const loadSingleDepartmentData = (deptID, setDataLoading) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/department/PostDepartmentDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                "DeptID": deptID
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (deptID !== null) {
                    dispatch(getSingleDepartmentData(resp.Departments));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleDepartmentData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => {
                console.log(err)
                dispatch(getSingleDepartmentData([]))
            });
    };
};
export const loadDepartmentModuleFieldNameData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 19 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getDepartmentModuleFieldNameData(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const postDepartmentBulkDatas = (
    postRequest,
    cancelModal,
    deptData,
    setBulkUploadErrorMessage,
    setBulkUploadErrorFilePath
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Department/PostBulkAddDepartment`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postDepartmentBulkUploadData());
                    cancelModal();
                    deptData();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    setBulkUploadErrorMessage(errorMessage);
                    // ✅ Save the error file path
                    if (resp.FilePath) {
                        setBulkUploadErrorFilePath(resp.FilePath);
                    }
                }
            })
            .catch((err) => { console.log(err) });
    }
};
// Settings Department

// Settings Customer Classification
export const loadCustomerClassificationData = (setLoading, statusID, whereClause) => {
    return function (dispatch) {
        let data = {}
        if (statusID) {
            data.statusID = statusID
        }
        if (whereClause) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = whereClause;
        }
        fetch(`${baseURL}/excomatixservices/api/CustomerClassification/GetCustomerClassificationDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomerClassificationData(resp.CustomerClassifications))
                setLoading(false)
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleCustomerClassificationData = (setDataLoading, clsID) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/CustomerClassification/GetCustomerClassificationDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                "CustomerClassificationID": clsID
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (clsID !== null) {
                    dispatch(getSingleCustomerClassificationData(resp.CustomerClassifications));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleCustomerClassificationData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const postCustomerClassificationDatas = (
    postRequest,
    cancelModal,
    clsID,
    getData
) => {
    return function (dispatch) {
        if (clsID) {
            fetch(`${baseURL}/excomatixservices/api/CustomerClassification/PostUpdateCustomerClassification`, postRequest)
                .then((resp) => resp.json())
                .then((resp) => {
                    if (resp.Success === 1) {
                        dispatch(postCustomerClassificationData());
                        getData();
                        cancelModal();
                        Swal.fire({
                            title: 'Success',
                            text: resp.Msg,
                            icon: 'success',
                        });
                    } else {
                        // toast.error(resp.Error);
                        const errorMessage = resp.Msg; // Extract error message
                        Swal.fire({
                            title: 'Failed',
                            text: errorMessage,
                            icon: 'error',
                        });
                    }
                })
                .catch((err) => {
                    toast.error(`${err}`);
                });
        } else {
            fetch(`${baseURL}/excomatixservices/api/CustomerClassification/PostAddCustomerClassification`, postRequest)
                .then((resp) => resp.json())
                .then((resp) => {
                    if (resp.Success === 1) {
                        dispatch(postCustomerClassificationData());
                        getData();
                        cancelModal();
                        Swal.fire({
                            title: 'Success',
                            text: resp.Msg,
                            icon: 'success',
                        });
                    } else {
                        // toast.error(resp.Error);
                        const errorMessage = resp.Msg; // Extract error message
                        Swal.fire({
                            title: 'Failed',
                            text: errorMessage,
                            icon: 'error',
                        });
                    }
                })
                .catch((err) => {
                    toast.error(`${err}`);
                });
        }
    }
};
export const loadCustomerClassificationModuleFieldNameData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 21 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getCustomerClassificationModuleFieldNameData(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const postCustomerClassificationBulkDatas = (
    postRequest,
    cancelModal,
    deptData,
    setBulkUploadErrorMessage,
    setBulkUploadErrorFilePath
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/CustomerClassification/PostBulkAddCustomerClassification`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postCustomerClassificationBulkData());
                    cancelModal();
                    deptData();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    setBulkUploadErrorMessage(errorMessage);
                    // ✅ Save the error file path
                    if (resp.FilePath) {
                        setBulkUploadErrorFilePath(resp.FilePath);
                    }
                }
            })
            .catch((err) => { console.log(err) });
    }
};
// Settings Customer Classification

// Settings Designation
export const loadDesignationData = (setLoading, statusID, whereClause) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

        // Initialize CustomerID as null
        let CustomerID = null;

        // Assign CustomerID based on SignInType
        if (signInDetails[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // SuperAdmin has no specific CompanyID
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // Assign CompanyID for ClientAdmin
        } else if (signInDetails[0]?.SignInType === "User") {
            CustomerID = signInDetails[0]?.CompanyID; // Assign CompanyID for User
        }

        // Construct request body
        const requestBody = {
            "CompanyID": CustomerID
        };
        if (statusID) {
            requestBody.statusID = statusID
        }
        if (whereClause) {
            requestBody.ValueFilterType = "B";
            requestBody.ValueFilterWhereClause = whereClause;
        }
        fetch(`${baseURL}/excomatixservices/api/Designation/GetDesignationDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getDesignationData(resp.Designation))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};

export const loadSingleDesignationData = (setLoading, desgID) => {
    return function (dispatch) {
        setLoading(true);
        fetch(`${baseURL}/excomatixservices/api/Designation/GetDesignationDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "DesignationID": desgID })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (desgID !== null) {
                    dispatch(getSingleDesignationData(resp.Designation));
                    setLoading(false);
                } else {
                    dispatch(getSingleDesignationData([]));
                    setLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const postDesignationDatas = (
    postRequest,
    cancelModal,
    getDesgData,
    desgID
) => {
    return function (dispatch) {
        const url = desgID ?
            `${baseURL}/excomatixservices/api/Designation/PostUpdateDesignation`
            :
            `${baseURL}/excomatixservices/api/Designation/PostAddDesignation`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postDesignationData());
                    getDesgData()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
            });
    }
};

export const loadDepartmentDropdownData = (companyID = null) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

        // const requestBody = { statusID: 3 };
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }
        // if (companyID) {
        //     requestBody.CompanyID = companyID || CustomerID;
        // }
        const requestBody = {
            statusID: 3,
            CompanyID: companyID || CustomerID, // Ensure CompanyID is included
        };
        fetch(`${baseURL}/excomatixservices/api/department/PostDepartmentDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody),
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Departments) {
                    dispatch(
                        getDepartmentDropdownData(
                            resp.Departments.map((data) => {
                                return { value: data.DeptID, label: data.DepartmentName };
                            })
                        )
                    );
                }
                else {
                    dispatch(getDepartmentDropdownData([]));
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const loadReportingDesignationDropdownData = (DeptID) => {
    // Create the request payload
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    let CustomerID = null;

    // Check the SignInType and assign appropriate IDs and CompanyCode
    if (signInDetails[0].SignInType === "SuperAdmin") {
        CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
    } else if (signInDetails[0].SignInType === "ClientAdmin") {
        CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
    } else if (signInDetails[0].SignInType === "User") {
        CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
    }
    const requestBody = {
        StatusID: 10, // Always include statusID
        CompanyID: CustomerID
    };

    // Conditionally add depId if it exists
    if (DeptID) {
        requestBody.DepartmentID = DeptID;
    }

    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Designation/GetDesignationDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody),
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Designation) {
                    dispatch(
                        getReportingDesignationDropdownData(
                            resp.Designation.map((data) => {
                                return { value: data.DesignationID, label: data.DesignationName, ReportingDesignationID: data.ReportingDesignationID };
                            })
                        )
                    );
                } else {
                    dispatch(getReportingDesignationDropdownData([]));
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadDesignationModuleFieldNameData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 20 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getDesignationModuleFieldNameData(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const postDesignationBulkDatas = (
    postRequest,
    cancelModal,
    deptData,
    setBulkUploadErrorMessage,
    setBulkUploadErrorFilePath
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Designation/PostBulkAddDesignation`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postDesignationBulkData());
                    cancelModal();
                    deptData();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    setBulkUploadErrorMessage(errorMessage);
                    // ✅ Save the error file path
                    if (resp.FilePath) {
                        setBulkUploadErrorFilePath(resp.FilePath);
                    }
                }
            })
            .catch((err) => { console.log(err) });
    }
};
// Settings Designation

// Settings Issue Types
export const loadIssueTypesData = (setLoading, statusID, whereClause) => {
    let data = {}
    if (statusID) {
        data.statusID = statusID
    }
    if (whereClause) {
        data.ValueFilterType = "B";
        data.ValueFilterWhereClause = whereClause;
    }
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/IssueType/GetIssueTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getIssueTypesData(resp.IssueTypes));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};

export const loadSingleIssueTypesData = (setDataLoading, issueId) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/IssueType/GetIssueTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                IssueTypeID: issueId
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (issueId !== null) {
                    dispatch(getSingleIssueTypesData(resp.IssueTypes));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleIssueTypesData([]));
                    setDataLoading(false)
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const postIssueTypesDatas = (
    postRequest,
    cancelModal,
    issueTypes,
    issueTypeId
) => {
    return function (dispatch) {
        const url = issueTypeId ?
            `${baseURL}/excomatixservices/api/IssueType/PostUpdateIssueType`
            :
            `${baseURL}/excomatixservices/api/IssueType/PostAddIssueType`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postIssueTypesData());
                    issueTypes()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
            });
    }
};
export const loadIssueTypeModuleFieldNameData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 22 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getIssueTypeModuleFieldNameData(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const postIssueTypeBulkDatas = (
    postRequest,
    cancelModal,
    deptData,
    setBulkUploadErrorMessage,
    setBulkUploadErrorFilePath
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/IssueType/PostBulkAddIssueType`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postIssueTypeBulkData());
                    cancelModal();
                    deptData();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    setBulkUploadErrorMessage(errorMessage);
                    // ✅ Save the error file path
                    if (resp.FilePath) {
                        setBulkUploadErrorFilePath(resp.FilePath);
                    }
                }
            })
            .catch((err) => { console.log(err) });
    }
};
// Settings Issue Types

// Settings SLA
export const loadSettingsSlaData = (setLoading, statusID, whereClause) => {
    return function (dispatch) {
        let data = {}
        if (statusID) {
            data.statusID = statusID
        }
        if (whereClause) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = whereClause;
        }
        fetch(`${baseURL}/excomatixservices/api/SLACategories/GetSLACategoriesDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSettingsSlaData(resp['SLA Categories']));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleSettingsSlaData = (setDataLoading, settSlaId) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/SLACategories/GetSLACategoriesDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "SLACategoriesID": settSlaId, })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (settSlaId !== null) {
                    dispatch(getSingleSettingsSlaData(resp['SLA Categories']));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleSettingsSlaData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const postSettingsSlaCategoriesData = (
    postRequest,
    cancelModal,
    getSettingsSlaData,
    settSlaId
) => {
    return function (dispatch) {
        const url = settSlaId ?
            `${baseURL}/excomatixservices/api/SLACategories/PostUpdateSLACategories`
            :
            `${baseURL}/excomatixservices/api/SLACategories/PostAddSLACategories`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postSettingsSlaData());
                    getSettingsSlaData()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
            });
    }
};
export const loadSlaCategoriesModuleFieldNameData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 27 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getSlaCategoriesModuleFieldNameData(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const postSlaCategoriesBulkDatas = (
    postRequest,
    cancelModal,
    getSettingsSlaData,
    setBulkUploadErrorMessage,
    setBulkUploadErrorFilePath
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/SLACategories/PostBulkAddSLACategories`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postSlaCategoriesBulkUploadData());
                    cancelModal();
                    getSettingsSlaData();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    setBulkUploadErrorMessage(errorMessage);
                    // ✅ Save the error file path
                    if (resp.FilePath) {
                        setBulkUploadErrorFilePath(resp.FilePath);
                    }
                }
            })
            .catch((err) => { console.log(err) });
    }
};
// Settings SLA

// Settings  Module
export const loadModuleData = (setLoading) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/modules/GetModules`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({})
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getModuleData(resp.Modules));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleModuleData = (moduleId) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/modules/GetModules`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModulesID": moduleId })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleModuleData(resp.Modules));
            })
            .catch((err) => { console.log(err) });
    };
};

export const postModulesDatas = (
    postRequest,
    cancelModal,
    modulesData,
    moduleId
) => {
    return function (dispatch) {
        const url = moduleId ?
            `${baseURL}/excomatixservices/api/Modules/PostUpdateModule`
            :
            `${baseURL}/excomatixservices/api/Modules/PostAddModule`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postModuleData());
                    modulesData()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
            });
    }
};

// Settings Module

// Settings Sub Module
export const loadSubModuleData = (setLoading) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/SubModules/GetAllSubModules`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({})
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSubModuleData(resp['Sub Modules']));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleSubModuleData = (subModuleId) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/SubModules/GetAllSubModules`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "SubModulesID": subModuleId })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleSubModuleData(resp['Sub Modules']));
            })
            .catch((err) => { console.log(err) });
    };
};

export const postSubModulesDatas = (
    postRequest,
    cancelModal,
    subModuleDatas,
    subModuleId
) => {
    return function (dispatch) {
        const url = subModuleId ?
            `${baseURL}/excomatixservices/api/SubModules/PostUpdateSubModules`
            :
            `${baseURL}/excomatixservices/api/SubModules/PostAddSubModules`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postSubModuleData());
                    subModuleDatas()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    console.log("Error Message:", errorMessage); // Optional: Log to console
                    toast.error(errorMessage);
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
            });
    }
};

export const loadSubModulesDropdownData = (moduleID) => {
    const requestBody = {
        "StatusID": 18,
    };
    if (moduleID) {
        requestBody.ModulesID = moduleID
    }

    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/SubModules/GetAllSubModules`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            // body: JSON.stringify({
            //     "StatusID": 18
            // }),
            body: JSON.stringify(requestBody),
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp["Sub Modules"]) {
                    dispatch(
                        getSubModuleDropdown(
                            resp["Sub Modules"].map((data) => {
                                return { value: data.SubModulesID, label: data.SubModulesName, statusID: 18 };
                            })
                        )
                    );
                } else {
                    dispatch(getSubModuleDropdown([]));
                }
            })
            .catch((err) => { console.log(err) });
    };
};

// Settings Sub Module

// Settings System Numbering
export const loadSystemNumberingData = (setLoading, whereClause) => {
    return function (dispatch) {
        let data = {}
        if (whereClause) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = whereClause;
        }
        fetch(`${baseURL}/excomatixservices/api/SystemNumbering/GetSystemNumberingDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSystemNumberingData(resp.SystemNumberings));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleSystemNumberingData = (setDataLoading, systemNumberingId) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/SystemNumbering/GetSystemNumberingDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(
                {
                    "SystemNumbering_IDPK": systemNumberingId
                }
            )
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (systemNumberingId !== null) {
                    dispatch(getSingleSystemNumberingData(resp.SystemNumberings));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleSystemNumberingData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const postSystemNumberingDatas = (
    postRequest,
    cancelModal,
    systemNumbering,
    systemNumberingId
    // subModuleId
) => {
    return function (dispatch) {
        const url = systemNumberingId ?
            `${baseURL}/excomatixservices/api/SystemNumbering/PostUpdateSystemNumbering`
            :
            `${baseURL}/excomatixservices/api/SystemNumbering/PostAddSystemNumbering`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postSystemNumberingData());
                    systemNumbering()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    console.log("Error Message:", errorMessage); // Optional: Log to console
                    // toast.error(errorMessage);
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err)
            });
    }
};
export const loadSystemNumberingModuleFieldNameData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 26 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getSystemNumberingModuleFieldNameData(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const postSystemNumberingBulkDatas = (
    postRequest,
    cancelModal,
    systemNumbering,
    setBulkUploadErrorMessage,
    setBulkUploadErrorFilePath
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/SystemNumbering/PostBulkAddSystemNumbering`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postSystemNumberingBulkData());
                    cancelModal();
                    systemNumbering();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    setBulkUploadErrorMessage(errorMessage);
                    // ✅ Save the error file path
                    if (resp.FilePath) {
                        setBulkUploadErrorFilePath(resp.FilePath);
                    }
                }
            })
            .catch((err) => { console.log(err) });
    }
};
// Settings System Numbering

// Settings Work Queues Rules
export const postSettingsWorkQueuesDatas = (
    postRequest,
    cancelModal,
    getSettingsWorkQueuesRulesData,
    workqueueId
) => {
    return function (dispatch) {
        const url = workqueueId ?
            `${baseURL}/excomatixservices/api/WorkQueue/PostUpdateWorkQueue`
            :
            `${baseURL}/excomatixservices/api/WorkQueue/PostAddWorkQueue`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postSettingsWorkQueueData());
                    getSettingsWorkQueuesRulesData()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err)
            });
    }
};
export const postSettingsRunWorkQueuesDatas = (
    postRequest,
    cancelModal,
    getSettingsWorkQueuesRulesData,
    // workqueueId
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/WorkQueue/PostRunWorkQueue`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postSettingsRunWorkQueueData());
                    getSettingsWorkQueuesRulesData()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err)
            });
    }
};

export const loadSettingsWorkQueuesRulesData = (setLoading, statusID, whereClause) => {
    return function (dispatch) {
        let data = {}
        if (statusID) {
            data.statusID = statusID
        }
        if (whereClause) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = whereClause;
        }
        fetch(`${baseURL}/excomatixservices/api/WorkQueue/GetWorkQueueDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSystemWorkQueuesRulesData(resp.WorkQueue));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsSingleWorkQueuesRulesData = (setDataLoading, workqueueId) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/WorkQueue/GetWorkQueueDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "WorkQueueID": workqueueId })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (workqueueId !== null) {
                    dispatch(getSettingsSingleWorkQueuesRulesData(resp.WorkQueue));
                    setDataLoading(false);
                } else {
                    dispatch(getSettingsSingleWorkQueuesRulesData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const loadSettingsWorkQueuesRulesFieldNameData = (moduleId) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/WorkQueue/GetModuleFieldDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "CompanyID": Company_ID, "ModuleID": moduleId, "StatusID": '34,26' })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModuleField) {
                    dispatch(
                        getSettingsWorkQueuesRulesFieldNameData(
                            resp.ModuleField.map((data) => {
                                return { value: data.ModuleID, label: data.ModuleFieldAliasName, IsCustom: data.IsCustom, ModuleFieldID: data.ModuleFieldID, StatusID: data.StatusID };
                            })
                        )
                    );
                }
            })
    }
}
export const loadSettingsWorkQueuesRulesModuleFieldNameDataforValueFilter = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 25 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getSettingsWorkQueuesRulesModuleFieldNameDataForValueFilter(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
// Settings Work Queues Rules

//  Settings Role
export const loadSettingsRolesData = (setLoading, roleID = null, statusID = null, whereClause) => {
    return function (dispatch) {

        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

        // Initialize CustomerID as null
        let CustomerID = null;

        // Assign CustomerID based on SignInType
        if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID; // SuperAdmin has no specific CompanyID
        } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID; // Assign CompanyID for ClientAdmin
        } else if (signInDetails?.[0]?.SignInType === "User") {
            CustomerID = signInDetails?.[0]?.CompanyID; // Assign CompanyID for User
        }

        let data = { "CompanyID": CustomerID }
        if (roleID) {
            data.roleID = roleID
        }
        if (statusID) {
            data.statusID = statusID
        }
        if (whereClause) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = whereClause;
        }
        fetch(`${baseURL}/excomatixservices/api/roles/PostRoleDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                // const simplifiedRoles = resp.Roles.map(item => ({
                //     RoleID: item.RoleID,
                //     RoleName: item.RoleName,
                //     Description: item.Description,
                //     Status: item.Status
                // }));
                dispatch(getRolesDatas(resp.Roles));
                // dispatch(getRolesDatas(simplifiedRoles));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleSettingsRolesData = (roleId, setDataLoading) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/roles/PostRoleDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ RoleID: roleId })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (roleId !== null) {
                    dispatch(getSingleRolesDatas(resp.Roles));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleRolesDatas(resp.Roles));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsRolesModulesSubmodulesData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Roles/GetModuleSubModuleDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({})
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getRolesModulesSubmodulesDatas(resp.Modules));
            })
            .catch((err) => { console.log(err) });
    };
};

export const postRolesDatas = (
    postRequest,
    cancelModal,
    getRoles,
    roleId
) => {
    return function (dispatch) {
        const url = roleId ?
            `${baseURL}/excomatixservices/api/roles/PostupdateRole`
            :
            `${baseURL}/excomatixservices/api/roles/PostAddRole`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postRolesData());
                    getRoles()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
            });
    }
};
export const loadRolesModuleFieldNameData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 18 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getRolesModuleFieldNameData(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const loadSettingsRolesAdvanceFilterData = (setLoading, advancedExpression, pageSize, currentPage, pageName) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

        // Initialize CustomerID as null
        let CompanyID = null;

        // Assign CustomerID based on SignInType
        if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
            CompanyID = signInDetails?.[0]?.CompanyID; // SuperAdmin has no specific CompanyID
        } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
            CompanyID = signInDetails?.[0]?.CompanyID; // Assign CompanyID for ClientAdmin
        } else if (signInDetails?.[0]?.SignInType === "User") {
            CompanyID = signInDetails?.[0]?.CompanyID; // Assign CompanyID for User
        }

        fetch(`${baseURL}/excomatixservices/api/Filter/GetAdvanceFilterData`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(
                {
                    "SQLQuery": advancedExpression,
                    "CompanyID": CompanyID,
                    "PageSize": pageSize,
                    "PageIndex": currentPage,
                    "PageName": pageName
                }
            )
        })
            .then((resp) => resp.json())
            .then((resp) => {
                // const rolesData = resp?.FilterData?.Data || [];
                // const simplifiedRoles = rolesData.map(item => ({
                //     RoleID: item.Roles_IDPK,
                //     RoleName: item.Roles_Name,
                //     Description: item.Roles_Description,
                //     Status: item.Status
                // }));
                dispatch(getRolesAdvanceFilterDatas(resp?.FilterData?.Data));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const postRolesBulkDatas = (
    postRequest,
    cancelModal,
    deptData,
    setBulkUploadErrorMessage,
    setBulkUploadErrorFilePath
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Roles/PostBulkAddRoles`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postRolesBulkData());
                    cancelModal();
                    deptData();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    setBulkUploadErrorMessage(errorMessage);
                    // ✅ Save the error file path
                    if (resp.FilePath) {
                        setBulkUploadErrorFilePath(resp.FilePath);
                    }
                }
            })
            .catch((err) => { console.log(err) });
    }
};
//  Settings Role

// Settings Custom Fields
export const loadCustomFieldsData = (setLoading, statusID, whereClause, selectedCompanyID, modulId, subModuleId) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = selectedCompanyID || null; // Should be set correctly now

        // Assign CustomerID based on SignInType if selectedCompanyID is not provided
        if (!selectedCompanyID && signInDetails?.[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID;
        } else if (!selectedCompanyID && signInDetails?.[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID;
        } else if (!selectedCompanyID && signInDetails?.[0]?.SignInType === "User") {
            CustomerID = signInDetails?.[0]?.CompanyID;
        }

        let data = { CustomFields_CompanyIDFK: CustomerID }
        if (statusID) {
            data.CustomFields_StatusIDFK = statusID
        }
        if (whereClause) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = whereClause;
        }
        if (modulId) {
            data.CustomFields_ModuleIDFK = modulId;
        }
        if (subModuleId) {
            data.CustomFields_SubModulesIDFK = subModuleId;
        }
        fetch(`${baseURL}/excomatixservices/api/CustomField/GetCustomFieldDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomFieldsData(resp.CustomFields));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleCustomFieldsData = (setDataLoading, customFieldsId) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/CustomField/GetCustomFieldDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ CustomFields_IDPK: customFieldsId })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (customFieldsId !== null) {
                    dispatch(getSingleCustomFieldsData(resp.CustomFields));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleCustomFieldsData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const postCustomFieldsDatas = (
    postRequest,
    cancelModal,
    getCustomField,
    customFieldsId
) => {
    return function (dispatch) {

        const url = customFieldsId ?
            `${baseURL}/excomatixservices/api/CustomField/PostUpdateCustomField`
            :
            `${baseURL}/excomatixservices/api/CustomField/PostAddCustomField`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postCustomFieldsData());
                    getCustomField()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg;
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => { console.log(err) });
    }
};
export const loadCustomFieldsModuleFieldNameData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 33 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getCustomFieldsModuleFieldNameData(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const postCustomFieldsBulkDatas = (
    postRequest,
    cancelModal,
    deptData,
    setBulkUploadErrorMessage,
    setBulkUploadErrorFilePath
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/CustomField/PostBulkAddCustomField`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postCustomFieldsBulkData());
                    cancelModal();
                    deptData();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    setBulkUploadErrorMessage(errorMessage);
                    // ✅ Save the error file path
                    if (resp.FilePath) {
                        setBulkUploadErrorFilePath(resp.FilePath);
                    }
                }
            })
            .catch((err) => { console.log(err) });
    }
};
// Settings Custom Fields

// Settings Leave Policy
export const postLeavePolicyDatas = (
    postRequest,
    cancelModal,
    leavePolicyData,
    leavePolicyId
) => {
    return function (dispatch) {

        const url = leavePolicyId ?
            `${baseURL}/excomatixservices/api/LeavePolicy/PostUpdateLeavePolicy`
            :
            `${baseURL}/excomatixservices/api//LeavePolicy/PostAddLeavePolicy`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postLeavePolicyData());
                    leavePolicyData()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg;
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
            });
    }
};
export const loadSettingsLeavePolicyData = (setLoading, countryCodeID, policyID, statusID, whereClause) => {
    const requestBody = countryCodeID ? { countryCodeID } : {};
    if (policyID) {
        requestBody.ValueFilterType = "B";
        requestBody.ValueFilterWhereClause = `LeavePolicy_IDPK = ${policyID}`;
        // requestBody.LeavePolicy_IDPK = policyID
    }
    if (statusID) {
        requestBody.statusID = statusID
    }
    if (whereClause) {
        requestBody.ValueFilterType = "B";
        requestBody.ValueFilterWhereClause = whereClause;
    }
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/LeavePolicy/PostLeavePolicyDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSettingsLeavePolicyData(resp['Leave Policies']));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsSingleLeavePolicyData = (setDataLoading, leavePolicyId) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/LeavePolicy/PostLeavePolicyDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                "LeavePolicyID": leavePolicyId
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (leavePolicyId !== null) {
                    dispatch(getSettingsSingleLeavePolicyData(resp['Leave Policies']));
                    setDataLoading(false);
                } else {
                    dispatch(getSettingsSingleLeavePolicyData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadLeaveTypeDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/LeavePolicy/PostLeavePolicyDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({}),
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp['Leave Policies']) {
                    dispatch(
                        getLeaveTypeDropdownData(
                            resp['Leave Policies'].map((data) => {
                                return { value: data.PolicyID, label: data.LeaveTypeName, Country: data.Country, StatusID: data.StatusID, AllowAttachment: data.AllowAttachment, AttachmentReqDays: data.AttachmentReqDays, AllowPrevDaysLeave: data.AllowPrevDaysLeave };
                            })
                        )
                    );
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsLeavePolicyModuleFieldNameDropdown = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 23 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getSettingsLeavePolicyModuleFieldNameDropdown(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const postLeavePolicyBulkDatas = (
    postRequest,
    cancelModal,
    leavePolicyData,
    setBulkUploadErrorMessage,
    setBulkUploadErrorFilePath
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/LeavePolicy/PostBulkAddLeavePolicy`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postLeavePolicyBulkData());
                    cancelModal();
                    leavePolicyData();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    setBulkUploadErrorMessage(errorMessage);
                    // ✅ Save the error file path
                    if (resp.FilePath) {
                        setBulkUploadErrorFilePath(resp.FilePath);
                    }
                }
            })
            .catch((err) => { console.log(err) });
    }
};
// Settings Leave Policy

// Settings Holiday Policy
export const loadSettingsHolidayPolicyData = (setLoading, HolidayID, statusID, whereClause, year) => {
    return function (dispatch) {
        let requestBody = {};
        if (HolidayID) {
            requestBody.ValueFilterType = "B";
            requestBody.ValueFilterWhereClause = `h.Holidays_Name = '${HolidayID}'`;
            // requestBody.LeavePolicy_IDPK = policyID
        }
        if (statusID) {
            requestBody.HolidayStatusID = statusID
        }
        if (whereClause) {
            requestBody.ValueFilterType = "B";
            requestBody.ValueFilterWhereClause = whereClause;
        }
        if (year) {
            requestBody.Year = year;
        }
        if (signInDetails?.[0]?.SignInType === "User") {
            requestBody.HolidayCountryID = signInDetails?.[0]?.CountryCodeID
        }
        fetch(`${baseURL}/excomatixservices/api/Holiday/GetHolidayDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSettingsHolidayPolicyData(resp.Holidays));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsSingleHolidayPolicyData = (setDataLoading, holidayId) => {
    setDataLoading(true);
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Holiday/GetHolidayDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                "HolidayID": holidayId
            })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (holidayId !== null) {
                    dispatch(getSettingsSingleHolidayPolicyData(resp.Holidays));
                    setDataLoading(false);
                } else {
                    dispatch(getSettingsSingleHolidayPolicyData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const postHolidayPolicyDatas = (
    postRequest,
    cancelModal,
    holidayPolicyData,
    holidayId
) => {
    return function (dispatch) {
        const url = holidayId ?
            `${baseURL}/excomatixservices/api/Holiday/PostUpdateHoliday`
            :
            `${baseURL}/excomatixservices/api/Holiday/PostAddHoliday`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postHolidayPolicyData());
                    holidayPolicyData()
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg;
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const loadCountryNameDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/companyservices/api/company/PostCountryCode`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({}),
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.CountryCodes) {
                    dispatch(
                        getCountryNameDropdown(
                            resp.CountryCodes.map((data) => {
                                return {
                                    CountryCodeID: data.CountryCodeID,
                                    value: data.CountryName,
                                    label: data.CountryName
                                };
                            })
                        )
                    );
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadHolidayNameDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Holiday/GetHolidayDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({}),
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Holidays) {
                    dispatch(
                        getHolidayNameDropdownData(
                            resp.Holidays.map((data) => {
                                return { value: data.HolidayID, label: data.HolidayName };
                            })
                        )
                    );
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsHolidayPolicyModuleFieldNameDropdown = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 24 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getSettingsHolidayPolicyModuleFieldNameDropdown(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
export const postHolidayPolicyBulkDatas = (
    postRequest,
    cancelModal,
    holidayPolicyData,
    setBulkUploadErrorMessage,
    setBulkUploadErrorFilePath
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Holiday/PostBulkAddHoliday`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postHolidayPolicyBulkData());
                    cancelModal();
                    holidayPolicyData();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    setBulkUploadErrorMessage(errorMessage);
                    // ✅ Save the error file path
                    if (resp.FilePath) {
                        setBulkUploadErrorFilePath(resp.FilePath);
                    }
                }
            })
            .catch((err) => { console.log(err) });
    }
};
// Settings Holiday Policy

// Settings Financial Approval
export const loadSettingsFinancialApprovalData = (setLoading, statusID, whereClause) => {
    return function (dispatch) {
        let data = {}
        if (statusID) {
            data.statusID = statusID
        }
        if (whereClause) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = whereClause;
        }
        fetch(`${baseURL}/excomatixservices/api/FinancialApproval/GetFinancialApprovalDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getFinancialApprovalData(resp.FinancialApprovals));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsSingleFinancialApprovalData = (setDataLoading, finanacialApprovalId) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/FinancialApproval/GetFinancialApprovalDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ FinancialApprovalID: finanacialApprovalId })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (finanacialApprovalId !== null) {
                    dispatch(getSingleFinancialApprovalData(resp.FinancialApprovals));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleFinancialApprovalData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};

export const postFinancialApprovalDatas = (
    postRequest,
    cancelModal,
    financialApproval,
    finanacialApprovalId
) => {
    return function (dispatch) {
        const url = finanacialApprovalId ?
            `${baseURL}/excomatixservices/api/FinancialApproval/PostUpdateFinancialApproval`
            :
            `${baseURL}/excomatixservices/api/FinancialApproval/PostAddFinancialApproval`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postFinancialApprovalData());
                    financialApproval();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg;
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const loadApprovalLevelDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Level/GetLevelDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({}),
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Levels) {
                    dispatch(
                        getApprovalLevelDropdownData(
                            resp.Levels.map((data) => {
                                return { value: data.LevelID, label: data.LevelsName };
                            })
                        )
                    );
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsFinancialApprovalModuleFieldNameDropdown = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 31 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getSettingsFinancialApprovalModuleFieldNameDropdown(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
// Settings Financial Approval

// Settings Functional Approval
export const loadSettingsFunctionalApprovalData = (setLoading, statusID, whereClause) => {
    return function (dispatch) {
        let data = {}
        if (statusID) {
            data.statusID = statusID
        }
        if (whereClause) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = whereClause;
        }
        fetch(`${baseURL}/excomatixservices/api/FunctionalApproval/GetFunctionalApprovalDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getFunctionalApprovalData(resp.FunctionalApprovals));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const postFunctionalApprovalDatas = (
    postRequest,
    cancelModal,
    functionalApprovalDatas,
    functionalApprovalId
) => {
    return function (dispatch) {
        const url = functionalApprovalId ?
            `${baseURL}/excomatixservices/api/FunctionalApproval/PostUpdateFunctionalApproval`
            :
            `${baseURL}/excomatixservices/api/FunctionalApproval/PostAddFunctionalApproval`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postFunctionalApprovalData());
                    functionalApprovalDatas();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg;
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const loadSettingsSingleFunctionalApprovalData = (setDataLoading, functionalApprovalId) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/FunctionalApproval/GetFunctionalApprovalDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ FunctionalApprovalID: functionalApprovalId })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (functionalApprovalId !== null) {
                    dispatch(getSingleFunctionalApprovalData(resp.FunctionalApprovals));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleFunctionalApprovalData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsFunctionalApprovalModuleFieldNameDataforValueFilter = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 30 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getSettingsFunctionalApprovalModuleFieldNameDataForValueFilter(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
// Settings Functional Approval

// Settings Leave Approval
export const loadSettingsLeaveApprovalData = (setLoading, statusID, whereClause) => {
    return function (dispatch) {
        let data = {}
        if (statusID) {
            data.statusID = statusID
        }
        if (whereClause) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = whereClause;
        }
        fetch(`${baseURL}/excomatixservices/api/LeaveApproval/GetLeaveApprovalDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLeaveApprovalData(resp.LeaveApprovals));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsSingleLeaveApprovalData = (setDataLoading, LeaveApprovalID) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/LeaveApproval/GetLeaveApprovalDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ LeaveApprovalID: LeaveApprovalID })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (LeaveApprovalID !== 0) {
                    dispatch(getSingleLeaveApprovalData(resp.LeaveApprovals));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleLeaveApprovalData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const postLeaveApprovalDatas = (
    postRequest,
    cancelModal,
    leaveApproval,
    LeaveApprovalID
) => {
    return function (dispatch) {
        const url = LeaveApprovalID ?
            `${baseURL}/excomatixservices/api/LeaveApproval/PostUpdateLeaveApproval`
            :
            `${baseURL}/excomatixservices/api/LeaveApproval/PostAddLeaveApproval`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postLeaveApprovalData());
                    leaveApproval();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg;
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const loadSettingsLeaveApprovalModuleFieldNameDataforValueFilter = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 29 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getSettingsLeaveApprovalModuleFieldNameDataForValueFilter(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
// Settings Leave Approval

// Settings Escalation Approval
export const loadSettingsEscalationApprovalData = (setLoading, statusID, whereClause) => {
    return function (dispatch) {
        let data = {}
        if (statusID) {
            data.statusID = statusID
        }
        if (whereClause) {
            data.ValueFilterType = "B";
            data.ValueFilterWhereClause = whereClause
        }
        fetch(`${baseURL}/excomatixservices/api/EscalationApproval/GetEscalationApprovalDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getEscalationApprovalData(resp.EscalationApprovals));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const postEscalationApprovalDatas = (
    postRequest,
    cancelModal,
    escalationApprovalDatas,
    EscalationApprovalId
) => {
    return function (dispatch) {
        const url = EscalationApprovalId ?
            `${baseURL}/excomatixservices/api/EscalationApproval/PostUpdateEscalationApproval`
            :
            `${baseURL}/excomatixservices/api/EscalationApproval/PostAddEscalationApproval`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postEscalationApprovalData());
                    escalationApprovalDatas();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg;
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const loadSettingsSingleEscalationApprovalData = (setDataLoading, EscalationApprovalId) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/EscalationApproval/GetEscalationApprovalDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ EscalationApprovalID: EscalationApprovalId })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (EscalationApprovalId !== null) {
                    dispatch(getSingleEscalationApprovalData(resp.EscalationApprovals));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleEscalationApprovalData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsEscalationApprovalModuleFieldNameDataforValueFilter = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 32 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getSettingsEscalationApprovalModuleFieldNameDataForValueFilter(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
// Settings Escalation Approval

// Settings Complaints Approval
export const loadSettingsComplaintsApprovalData = (setLoading, statusID, whereClause) => {
    let data = {}
    if (statusID) {
        data.statusID = statusID
    }
    if (whereClause) {
        data.ValueFilterType = "B";
        data.ValueFilterWhereClause = whereClause;
    }
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ComplaintApproval/GetComplaintApprovalDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getComplaintsApprovalData(resp.ComplaintApprovals));
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsSingleComplaintsApprovalData = (setDataLoading, complaintsApprovalId) => {
    return function (dispatch) {
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/ComplaintApproval/GetComplaintApprovalDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ ComplaintApprovalID: complaintsApprovalId })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (complaintsApprovalId) {
                    dispatch(getSingleComplaintsApprovalData(resp.ComplaintApprovals));
                    setDataLoading(false);
                } else {
                    dispatch(getSingleComplaintsApprovalData([]));
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const postComplaintsApprovalDatas = (
    postRequest,
    cancelModal,
    complaintsApprovalDatas,
    EscalationApprovalId
) => {
    return function (dispatch) {
        const url = EscalationApprovalId ?
            `${baseURL}/excomatixservices/api/ComplaintApproval/PostUpdateComplaintApproval`
            :
            `${baseURL}/excomatixservices/api/ComplaintApproval/PostAddComplaintApproval`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postComplaintsApprovalData());
                    complaintsApprovalDatas();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg;
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const loadSettingsComplaintsApprovalModuleFieldNameDataforValueFilter = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModulePageFields/GetModulePageFields`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleID": 35 })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModulePageFields) {
                    dispatch(
                        getSettingsComplaintsApprovalModuleFieldNameDataForValueFilter(
                            resp.ModulePageFields.map((data) => {
                                return { value: data.FieldName, label: data.FieldAliasName, columnDataType: data.ColumnDataType };
                            })
                        )
                    );
                }
            })
    }
}
// Settings Complaints Approval

// Settings Organization Chart
export const loadOrganizationChart = (setLoading) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

        // Initialize CustomerID as null
        let CustomerID = null;

        // Assign CustomerID based on SignInType
        if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID; // SuperAdmin has no specific CompanyID
        } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID; // Assign CompanyID for ClientAdmin
        } else if (signInDetails?.[0]?.SignInType === "User") {
            CustomerID = signInDetails?.[0]?.CompanyID; // Assign CompanyID for User
        }

        // Construct request body
        const requestBody = {
            "CustomerID": CustomerID,
            "StatusID": 16
        };

        // fetch(`${baseURL}/excomatixservices/api/designation/organizationchart`, {
        fetch(`${baseURL}/userservices/api/User/organizationchart`, {
            method: "POST",  // Use POST method to send body data
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody) // Pass requestBody in the request
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getOraganizationChart(resp));
                setLoading(false);
            })
            .catch((error) => console.error("Error loading organization chart:", error));
    };
};

// Settings Organization Chart

// Settings Menubar Enable and Disable
export const loadModuleSubModules = (selectedCompanyID) => {
    return function (dispatch) {
        const signInDetails = selectedCompanyID || JSON.parse(sessionStorage.getItem('SignInDetails'));

        // Initialize CustomerID as null
        let CustomerID = selectedCompanyID || null;

        // Assign CustomerID based on SignInType
        if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID; // SuperAdmin has no specific CompanyID
        } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID; // Assign CompanyID for ClientAdmin
        } else if (signInDetails?.[0]?.SignInType === "User") {
            CustomerID = signInDetails?.[0]?.CompanyID; // Assign CompanyID for User
        }

        // Construct request body
        const requestBody = {
            "CompanyID": CustomerID
        };

        fetch(`${baseURL}/excomatixservices/api/Modules/GetModulesSubModulesForMenu`, {
            method: "POST",  // Use POST method to send body data
            mode: "cors",
            headers: {
                ...HeaderAuthentication.postExcomatixAuth,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(requestBody) // Pass requestBody in the request
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getModuleSubModules(resp.Modules));
            })
            .catch((error) => console.error("Error loading Modules Submodules:", error));
    };
};

export const postModuleSubModuleDatas = (
    postRequest,
    getSideMenue
    // cancelModal,
    // workqueuesDatas,
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Modules/UpdateModulesSubModulesForMenu`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postModuleSubModules());
                    getSideMenue();
                    // workqueuesDatas();
                    // cancelModal();
                    // Swal.fire({
                    //     title: 'Success',
                    //     text: resp.Msg,
                    //     icon: 'success',
                    // });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    // Swal.fire({
                    //     title: 'Failed',
                    //     text: errorMessage,
                    //     icon: 'error',
                    // });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};

export const postCustomFieldsLabelNameChange = (
    postRequest,
    // cancelModal,
    // workqueuesDatas,
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Modules/UpdateModuleSubModuleFieldForMenu`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postCustomFieldLabelChange());
                    // workqueuesDatas();
                    // cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const postModuleFieldNamesData = (
    postRequest,
    // cancelModal,
    // workqueuesDatas,
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModuleField/PostAddCompanyModuleField`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postModuleFieldNames());
                    // workqueuesDatas();
                    // cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};

// Settings Menubar Enable and Disable

// Settings Dynamic Dashboard
export const loadSettingsDynamicDashboard = (
    setLoading,
    pageSize,
    currentPage,
    statusID,
    clientID
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID || clientID,
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        if (statusID) {
            requestBody.StatusID = statusID;
        }

        fetch(`${baseURL}/excomatixservices/api/Dashboard/GetDashboardLibraryDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getDynamicDashboard(resp.DashboardLibrary));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsSingleDynamicDashboardData = (
    setDataLoading,
    dashboardId
) => {
    return function (dispatch) {

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "DashboardLibraryID": dashboardId,
        };
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/Dashboard/GetDashboardLibraryDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (dashboardId !== null) {
                    dispatch(getSingleDynamicDashboardData(resp.DashboardLibrary));
                    // dispatch(getToataldataCount(resp.RecordCount))
                    setDataLoading(false);
                } else {
                    dispatch(getSingleDynamicDashboardData([]));
                    // dispatch(getToataldataCount(resp.RecordCount))
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsDynamicDashboardCategoryDropdown = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Dashboard/GetDashboardCategoryDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({})
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.DashboardCategory) {
                    dispatch(
                        getDynamicDashboardCategoryDropdown(
                            resp.DashboardCategory.map((data) => {
                                return { value: data.DashboardCategoryID, label: data.DashboardCategoryName };
                            })
                        )
                    );
                }
            })
    }
}
export const postDynamicDashboardDatas = (
    postRequest,
    cancelModal,
    fetchDynamicDashboards,
    dashboardId,
    imgChange,
    setImgChange,
) => {
    return function (dispatch) {
        const url = dashboardId ?
            `${baseURL}/excomatixservices/api/Dashboard/PostUpdateDashboardLibrary`
            :
            `${baseURL}/excomatixservices/api/Dashboard/PostAddDashboardLibrary`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postDynamicDashboardData());
                    fetchDynamicDashboards();
                    if (imgChange) {
                        setImgChange(false)
                    }
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const postDefaultDashboardDatas = (
    postRequest,
    // cancelModal,
    fetchDynamicDashboards,
    // dashboardId,
    // imgChange,
    // setImgChange,
) => {
    return function (dispatch) {
        // const url = dashboardId ?
        //     `${baseURL}/excomatixservices/api/Dashboard/PostUpdateDashboardLibrary`
        //     :
        //     `${baseURL}/excomatixservices/api/Dashboard/PostAddDashboardLibrary`
        fetch(`${baseURL}/excomatixservices/api/Dashboard/PostUpdateCompanyDeafultDashboard`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postDefaultDashboardData());
                    fetchDynamicDashboards();
                    // if (imgChange) {
                    //     setImgChange(false)
                    // }
                    // cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};

export const loadModuleFieldNames = (selectedCompanyID, moduleId, suModuleId) => {
    return function (dispatch) {
        const signInDetails = selectedCompanyID || JSON.parse(sessionStorage.getItem('SignInDetails'));

        // Initialize CustomerID as null
        let CustomerID = selectedCompanyID || null;

        // Assign CustomerID based on SignInType
        if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID; // SuperAdmin has no specific CompanyID
        } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails?.[0]?.CompanyID; // Assign CompanyID for ClientAdmin
        } else if (signInDetails?.[0]?.SignInType === "User") {
            CustomerID = signInDetails?.[0]?.CompanyID; // Assign CompanyID for User
        }

        // Construct request body
        const requestBody = {
            "CompanyID": CustomerID,
            "ModuleID": moduleId,
            "SubModuleID": suModuleId,
        };

        fetch(`${baseURL}/excomatixservices/api/ModuleField/GetCompanyModuleFieldDetails`, {
            method: "POST",  // Use POST method to send body data
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody) // Pass requestBody in the request
        })
            .then((resp) => resp.json())
            .then((resp) => {
                // dispatch(getModuleFieldNames(resp.ModuleField));
                if (resp && resp.ModuleField && resp.ModuleField.length > 0) {
                    dispatch(getModuleFieldNames(resp.ModuleField));
                } else {
                    dispatch(getModuleFieldNames([])); // Dispatch empty if no data
                }
            })
            .catch((error) => console.error("Error loading Module Fields:", error));
    };
};
export const postDynamicDashboardBulkDatas = (
    postRequest,
    cancelModal,
    fetchDynamicDashboards,
    setBulkUploadErrorMessage,
    setBulkUploadErrorFilePath
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Dashboard/PostBulkAddDashboard`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postDynamicDashboardBulkData());
                    cancelModal();
                    fetchDynamicDashboards();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    setBulkUploadErrorMessage(errorMessage);
                    // ✅ Save the error file path
                    if (resp.FilePath) {
                        setBulkUploadErrorFilePath(resp.FilePath);
                    }
                }
            })
            .catch((err) => { console.log(err) });
    }
};
// Settings Dynamic Dashboard

// Settings Module Fields
export const loadSettingsModuleFieldData = (
    setLoading,
    pageSize,
    currentPage,
    moduleID = null
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].UserID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "PageSize": pageSize,
            "PageIndex": currentPage,
            ...(moduleID && { "ModuleID": moduleID }) // Add ModuleID only if it exists
        };

        fetch(`${baseURL}/excomatixservices/api/ModuleField/GetModuleFieldDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getModuleFieldData(resp.ModuleField));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSettingsSingleModuleFieldData = (
    moduleFieldID
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModuleField/GetModuleFieldDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ "ModuleFieldID": moduleFieldID })
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleModuleFieldData(resp.ModuleField));
                // dispatch(getToataldataCount(resp.RecordCount))
                // setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};

export const postModuleFieldDatas = (
    postRequest,
    cancelModal,
    moduleFieldData,
    moduleFieldID,
    // imgChange,
    // setImgChange,
) => {
    return function (dispatch) {
        const url = moduleFieldID ?
            `${baseURL}/excomatixservices/api/ModuleField/PostUpdateModuleField`
            :
            `${baseURL}/excomatixservices/api/ModuleField/PostAddModuleField`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postModuleFieldData());
                    moduleFieldData();
                    // if (imgChange) {
                    //     setImgChange(false)
                    // }
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const loadSettingsModuleFieldForeignKeyColumnDropdown = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/ModuleField/GetModuleFieldDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({})
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ModuleField) {
                    dispatch(
                        getModuleFieldForeignKeyColumnData(
                            resp.ModuleField.map((data) => {
                                return { value: data.ModuleFieldName, label: data.ModuleFieldName };
                            })
                        )
                    );
                }
            })
    }
}
export const loadModuleFieldModulesDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/modules/GetModules`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                "ModulesID": "",
                "StatusID": 62,
                "Modules_Name": ""
            }),
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Modules) {
                    dispatch(
                        getModuleFieldModulesDropdownData(
                            resp.Modules.map((data) => {
                                return { value: data.ModuleID, label: data.Module, statusID: data.StatusID };
                            })
                        )
                    );
                }
            })
            .catch((err) => { console.log(err) });
    };
};
// Settings Module Fields

// Module-2 7/5/2025
// Location Master
// Zone Master
export const loadZoneMasterDatas = (
    setLoading,
    pageSize,
    currentPage,
    SearchText
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }

        fetch(`${baseURL}/masterservices/api/zones/PostZoneDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getZoneMasterData(resp.Zones));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleZoneMasterDatas = (
    zoneId,
) => {
    return function (dispatch) {
        const requestBody = {
            "Zone_ID": zoneId,
        };

        fetch(`${baseURL}/masterservices/api/zones/PostZoneDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleZoneMasterData(resp.Zones));
            })
            .catch((err) => { console.log(err) });
    };
};
export const postZoneMasterDatas = (
    postRequest,
    cancelModal,
    zoneId,
    zoneMasterData
) => {
    return function (dispatch) {
        const url = zoneId ?
            `${baseURL}/masterservices/api/zones/UpdateZoneDetails`
            :
            `${baseURL}/masterservices/api/zones/PostAddZones`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postZoneMasterData());
                    zoneMasterData();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
};
export const loadZoneMasterClassDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/masterservices/api/zones/PostZoneClassNCategory`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({})
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ZoneClass) {
                    dispatch(
                        getZoneMasterClassDropdownData(
                            resp.ZoneClass.map((data) => {
                                return { value: data.ClassID, label: data.Class };
                            })
                        )
                    );
                }
            })
    }
}
export const loadZoneMasterCategoryDropdownData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/masterservices/api/zones/PostZoneClassNCategory`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({})
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ZoneCategoty) {
                    dispatch(
                        getZoneMasterCategoryDropdownData(
                            resp.ZoneCategoty.map((data) => {
                                return { value: data.CategoryID, label: data.Category };
                            })
                        )
                    );
                }
            })
    }
}
export const loadZoneMasterParentCodeDropdownData = (Sloc_ID = null) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            ...(Sloc_ID && { Sloc_ID })  // include Sloc_ID only if it has a value
        };

        fetch(`${baseURL}/masterservices/api/zones/PostZoneDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Zones) {
                    dispatch(
                        getZoneMasterParentCodeDropDownData(
                            resp.Zones.map((data) => {
                                return { value: data.Zone_ID, label: data.ZoneName };
                            })
                        )
                    );
                }
            })
    }
}
// Zone Master

// Storage Type Master
export const loadStorageTypeMasterDatas = (
    setLoading,
    pageSize,
    currentPage,
    SearchText
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }

        fetch(`${baseURL}/masterservices/api/StorageType/PostStorageTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getStorageTypeMasterData(resp.StorageTypes));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const postStorageTypeMasterDatas = (
    postRequest,
    cancelModal,
    storageTypeId,
    storageMasterData
) => {
    return function (dispatch) {
        const url = storageTypeId ?
            `${baseURL}/masterservices/api/StorageType/UpdateStorageType`
            :
            `${baseURL}/masterservices/api/StorageType/PostAddStorageType`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postStorageTypeMasterData());
                    storageMasterData();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
};
export const loadSingleStorageTypeMasterDatas = (
    storageTypeId,
) => {
    return function (dispatch) {
        const requestBody = {
            "StorageTypeID": storageTypeId,
        };

        fetch(`${baseURL}/masterservices/api/StorageType/PostStorageTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleStorgeTypeMasterData(resp.StorageTypes));
            })
            .catch((err) => { console.log(err) });
    };
};
// Storage Type Master
// Bin Master
export const loadBinMasterDatas = (
    setLoading,
    pageSize,
    currentPage,
    SearchText
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }

        fetch(`${baseURL}/masterservices/api/BinMaster/PostBinDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getBinMasterDatas(resp.Bin));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const downloadBinMasterDatas = (
    SearchText,
    setIsDownloading
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }

        fetch(`${baseURL}/masterservices/api/BinMaster/PostBinDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(downloadBinMaster(resp.Bin));
                setIsDownloading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleBinMasterDatas = (
    binId,
) => {
    return function (dispatch) {
        const requestBody = {
            "Bin_IDPK": binId,
        };

        fetch(`${baseURL}/masterservices/api/BinMaster/PostBinDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleBinMasterDatas(resp.Bin));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadUomDropdownData = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "StatusID": 87
        };

        fetch(`${baseURL}/masterservices/api/uom/PostUomDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.UOM) {
                    dispatch(
                        getUomDropdownData(
                            resp.UOM.map((data) => {
                                return { value: data.UOMID, label: data.UOMCode };
                            })
                        )
                    );
                }
            })
    }
}
export const loadWeigheUomDropdownData = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "StatusID": 87,
            "MeasureOfID": 1,
        };

        fetch(`${baseURL}/masterservices/api/uom/PostUomDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.UOM) {
                    dispatch(
                        getWeightUomDropdownData(
                            resp.UOM.map((data) => {
                                return { value: data.UOMID, label: data.UOMCode };
                            })
                        )
                    );
                }
            })
    }
}
export const loadStorageTypeDropdownData = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "StatusID": 79
        };

        fetch(`${baseURL}/masterservices/api/StorageType/PostStorageTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.StorageTypes) {
                    dispatch(
                        getStorageTypeDropdownData(
                            resp.StorageTypes.map((data) => {
                                return { value: data.StorageTypeID, label: data.StorageTypeCode };
                            })
                        )
                    );
                }
            })
    }
}
export const loadBinLevelDropdownData = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
        };

        fetch(`${baseURL}/masterservices/api/BinMaster/PostBinLevels`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.BinLevels) {
                    dispatch(
                        getBinLevelDropdownData(
                            resp.BinLevels.map((data) => {
                                return { value: data.BinLevelID, label: `${data.BinLevelCode}-${data.BinLevel}` };
                            })
                        )
                    );
                }
            })
    }
}
export const postBinMasterDatas = (
    postRequest,
    cancelModal,
    binId,
    binMasterData
) => {
    return function (dispatch) {
        const url = binId ?
            `${baseURL}/masterservices/api/BinMaster/PostUpdateBinMaster`
            :
            `${baseURL}/masterservices/api/BinMaster/PostAddBin`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postBinMasterData());
                    binMasterData();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
};
// Bin Master
// Location Master

// Standards Master
// MRP Type
export const loadMrpTypeDatas = (
    setLoading,
    pageSize,
    currentPage,
    SearchText
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }

        fetch(`${baseURL}/masterservices/api/MRPtype/PostMRPTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getMrpTypeData(resp.MRPTypes));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const postMrpTypeDatas = (
    postRequest,
    cancelModal,
    mrpTypeId,
    mrpTypeDatas
) => {
    return function (dispatch) {
        const url = mrpTypeId ?
            `${baseURL}/masterservices/api/MRPtype/UpdateMRPType`
            :
            `${baseURL}/masterservices/api/MRPtype/PostAddMRPType`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postMrpTypeData());
                    mrpTypeDatas();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
};
export const loadSingleMrpTypeDatas = (
    mrpTypeId,
) => {
    return function (dispatch) {
        const requestBody = {
            "MRPTypeID": mrpTypeId,
        };

        fetch(`${baseURL}/masterservices/api/MRPtype/PostMRPTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleMrpTypeData(resp.MRPTypes));
            })
            .catch((err) => { console.log(err) });
    };
};
// MRP Type
// Unit of Measure
export const loadUnitOfMeasureDatas = (
    setLoading,
    pageSize,
    currentPage,
    SearchText
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }

        fetch(`${baseURL}/masterservices/api/uom/PostUomDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getUnitOfMeasuredata(resp.UOM));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const postUnitOfMeasureDatas = (
    postRequest,
    cancelModal,
    uomId,
    uomData
) => {
    return function (dispatch) {
        const url = uomId ?
            `${baseURL}/masterservices/api/uom/PostUpdateUOM`
            :
            `${baseURL}/masterservices/api/uom/PostAdduom`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postUomData());
                    uomData();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
};
export const loadSingleUomDatas = (
    uomId,
) => {
    return function (dispatch) {
        const requestBody = {
            "UOMID": uomId,
        };

        fetch(`${baseURL}/masterservices/api/uom/PostUomDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleUomData(resp.UOM));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadUomClassDropdownData = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
        };

        fetch(`${baseURL}/masterservices/api/uom/PostUOMMeasureOfNClass`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Class) {
                    dispatch(
                        getUomClassDropdownData(
                            resp.Class.map((data) => {
                                return { value: data.UOMClassID, label: data.UOMClass };
                            })
                        )
                    );
                }
            })
    }
}
export const loadUomMeasureOfDropdownData = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
        };

        fetch(`${baseURL}/masterservices/api/uom/PostUOMMeasureOfNClass`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.MeasureOf) {
                    dispatch(
                        getUomMeasureOfDropdownData(
                            resp.MeasureOf.map((data) => {
                                return { value: data.MeasureOfID, label: data.MeasureOfName };
                            })
                        )
                    );
                }
            })
    }
}
// Unit of Measure
// Material Group
export const loadMaterialGroupDatas = (
    setLoading,
    pageSize,
    currentPage,
    SearchText
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }

        fetch(`${baseURL}/masterservices/api/MaterialGroup/PostMaterialGroupDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getMaterialGroupdata(resp.MaterialGroup));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadMaterialGroupClassificationDropdownData = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
        };

        fetch(`${baseURL}/masterservices/api/MaterialGroup/PostMGClassification`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Classification) {
                    dispatch(
                        getMaterialGroupClassificationDropdownData(
                            resp.Classification.map((data) => {
                                return { value: data.ClassificationID, label: data.ClassificationName };
                            })
                        )
                    );
                }
            })
    }
}
export const postMaterialGroupDatas = (
    postRequest,
    cancelModal,
    uomId,
    materialGroupDatas
) => {
    return function (dispatch) {
        const url = uomId ?
            `${baseURL}/masterservices/api/MaterialGroup/PostUpdateMaterialGroup`
            :
            `${baseURL}/masterservices/api/MaterialGroup/PostAddMaterialGroup`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postMaterialGroupData());
                    materialGroupDatas();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
};
export const loadSingleMaterialGroupDatas = (
    materialGroupID,
) => {
    return function (dispatch) {
        const requestBody = {
            "MaterialGroupID": materialGroupID,
        };

        fetch(`${baseURL}/masterservices/api/MaterialGroup/PostMaterialGroupDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleMaterialGroupData(resp.MaterialGroup));
            })
            .catch((err) => { console.log(err) });
    };
};
// Material Group
// Material Type
export const loadMaterialTypeDatas = (
    setLoading,
    pageSize,
    currentPage,
    SearchText
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }

        fetch(`${baseURL}/masterservices/api/Materialtype/PostMaterialTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getMaterialTypedata(resp.MaterialTypes));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};

export const postMaterialTypeDatas = (
    postRequest,
    cancelModal,
    materialTypeID,
    materialGroupDatas
) => {
    return function (dispatch) {
        const url = materialTypeID ?
            `${baseURL}/masterservices/api/Materialtype/UpdateMaterialType`
            :
            `${baseURL}/masterservices/api/Materialtype/PostAddMaterialType`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postMaterialTypeData());
                    materialGroupDatas();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
};
export const loadSingleMaterialTypeDatas = (
    materialTypeID,
) => {
    return function (dispatch) {
        const requestBody = {
            "MaterialTypeID": materialTypeID,
        };

        fetch(`${baseURL}/masterservices/api/Materialtype/PostMaterialTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleMaterialTypeData(resp.MaterialTypes));
            })
            .catch((err) => { console.log(err) });
    };
};
// Material Type
// Stock Condition
export const loadStockConditionDatas = (
    setLoading,
    pageSize,
    currentPage,
    SearchText
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }

        fetch(`${baseURL}/masterservices/api/StockCondition/PostStockConditionDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getStockConditionData(resp.StockConditions));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleStockConditionDatas = (
    stockConditionID,
) => {
    return function (dispatch) {
        const requestBody = {
            "StockConditionID": stockConditionID,
        };

        fetch(`${baseURL}/masterservices/api/StockCondition/PostStockConditionDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleStockConditionData(resp.StockConditions));
            })
            .catch((err) => { console.log(err) });
    };
};
export const postStockConditionDatas = (
    postRequest,
    cancelModal,
    stockConditionID,
    stockConditionDatas
) => {
    return function (dispatch) {
        const url = stockConditionID ?
            `${baseURL}/masterservices/api/StockCondition/UpdateStockCondition`
            :
            `${baseURL}/masterservices/api/StockCondition/PostAddStockCondition`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postStockConditionData());
                    stockConditionDatas();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
};
// Stock Condition
// Lot Size
export const loadLotSizeDatas = (
    setLoading,
    pageSize,
    currentPage,
    SearchText
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }

        fetch(`${baseURL}/masterservices/api/LotSize/GetLotSizeProcedures`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLotSizeData(resp.LotSizeProcedures));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleLotSizeDatas = (
    lotSizeID,
) => {
    return function (dispatch) {
        const requestBody = {
            "LotSizeProcedureID": lotSizeID,
        };

        fetch(`${baseURL}/masterservices/api/LotSize/GetLotSizeProcedures`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleLotSizeData(resp.LotSizeProcedures));
            })
            .catch((err) => { console.log(err) });
    };
};
export const postLotSizeDatas = (
    postRequest,
    cancelModal,
    lotSizeID,
    lotSizeDatas
) => {
    return function (dispatch) {
        const url = lotSizeID ?
            `${baseURL}/masterservices/api/LotSize/PostUpdateLotSizeProcedure`
            :
            `${baseURL}/masterservices/api/LotSize/PostAddLotSize`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postLotSizeData());
                    lotSizeDatas();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
};
// Lot Size
// Standards Master

// Logistics Master
// Container Type
export const loadLogisticsContainerTypeDatas = (
    setLoading,
    pageSize,
    currentPage,
    SearchText
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }

        fetch(`${baseURL}/masterservices/api/ContainerType/PostContainerTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLogisticsContainerTypeDatas(resp.ContainerType));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const downloadLogisticsContainerTypeDatas = (
    SearchText,
    setIsDownloading
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }

        fetch(`${baseURL}/masterservices/api/ContainerType/PostContainerTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(downloadLogisticsContainerTypeData(resp.ContainerType));
                setIsDownloading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleLogisticContainerTypeDatas = (
    containerTypeID,
) => {
    return function (dispatch) {
        const requestBody = {
            "ContainerTypeID": containerTypeID,
        };

        fetch(`${baseURL}/masterservices/api/ContainerType/PostContainerTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleLogisticContainerTypeData(resp.ContainerType));
            })
            .catch((err) => { console.log(err) });
    };
};
export const postLogisticsContainerTypeDatas = (
    postRequest,
    cancelModal,
    containerTypeID,
    containerTypeData
) => {
    return function (dispatch) {
        const url = containerTypeID ?
            `${baseURL}/masterservices/api/ContainerType/PostUpdateContainerType`
            :
            `${baseURL}/masterservices/api/ContainerType/PostAddContainerType`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postLogisticsContainerTypeData());
                    containerTypeData();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
};
export const loadContainerTypeRtmsCategoryDropdownData = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
        };

        fetch(`${baseURL}/masterservices/api/ContainerType/PostRTMSProductCategory`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.RTMSCategory) {
                    dispatch(
                        getContainerTypeRtmsCategoryDropdownData(
                            resp.RTMSCategory.map((data) => {
                                return { value: data.RTMSCategoryID, label: data.RTMSCategoryName };
                            })
                        )
                    );
                }
            })
    }
}
export const loadContainerTypeProductCategoryDropdownData = () => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
        };

        fetch(`${baseURL}/masterservices/api/ContainerType/PostRTMSProductCategory`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.ProductCategory) {
                    dispatch(
                        getContainerTypeProductCategoryDropdownData(
                            resp.ProductCategory.map((data) => {
                                return { value: data.ProductCategoryID, label: data.ProductCategoryName };
                            })
                        )
                    );
                }
            })
    }
}
// Container Type
// Logistics Master

// Vendor Master
export const loadVendorMasterDatas = (
    setLoading,
    pageSize,
    currentPage,
    SearchText
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        // If SearchText is provided, add it to the requestBody
        if (SearchText) {
            requestBody.SearchText = SearchText; // Assuming you want to search by Company Name
        }

        fetch(`${baseURL}/masterservices/api/vendor/PostVendorDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getVendorMasterData(resp.Vendor));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSingleVendorMasterDatas = (
    vendorId,
) => {
    return function (dispatch) {
        const requestBody = {
            "VendorID": vendorId,
        };

        fetch(`${baseURL}/masterservices/api/vendor/PostVendorDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleVendorMasterData(resp.Vendor));
            })
            .catch((err) => { console.log(err) });
    };
};
export const postVendorMasterDatas = (
    postRequest,
    cancelModal,
    vendorId,
    vendorMasterDatas
) => {
    return function (dispatch) {
        const url = vendorId ?
            `${baseURL}/masterservices/api/vendor/PostUpdateVendor`
            :
            `${baseURL}/masterservices/api/vendor/PostAddVendor`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postVendorMasterData());
                    vendorMasterDatas();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
};
// Vendor Master

// Custom Dashboard
export const loadCustomDashboardsOptions = (ModuleID) => {
    return function (dispatch) {
        let data = {}
        if (ModuleID) {
            data.ModuleID = ModuleID
        }
        fetch(`${baseURL}/excomatixservices/api/Dashboard/GetGraphLibrary`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.GraphLibrary) {
                    dispatch(
                        getCustomDashboardOptions(
                            resp.GraphLibrary.map((data) => {
                                return { value: data.GraphLibraryID, label: data.GraphLibraryName };
                            })
                        )
                    );
                }
            })
    }
}

export const postCustomDashboardData = (
    postRequest,
    cancelModal,
    customDashboardId,
    loadAllGraphsForModal
) => {
    return function (dispatch) {
        const url = customDashboardId ?
            `${baseURL}/excomatixservices/api/dashboard/PostUpdateCustomDashboard` :
            `${baseURL}/excomatixservices/api/dashboard/PostAddCustomDashboard`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(addCustomDashboardData());
                    dispatch(loadCustomviews(customDashboardId));
                    loadAllGraphsForModal();
                    cancelModal(); // ✅ Update sessionStorage here, after successful POST
                    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails')) || [{}];
                    const updatedSignInDetails = {
                        ...signInDetails[0],
                        CustomViewID: resp.Data?.CustomDashboardID || customDashboardId, // use server-provided ID if available
                        CustomViewLink: postRequest.body ? JSON.parse(postRequest.body).CustomViewLink : '',
                    };
                    sessionStorage.setItem("SignInDetails", JSON.stringify([updatedSignInDetails]));
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
};

export const loadCustomDashboards = (ModuleID) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CompanyID = null;
        let SignInType = null;
        let SignInID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CompanyID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
            SignInType = signInDetails[0].SignInType; // Assuming SuperAdminID is available in SignInDetails
            SignInID = signInDetails[0].SuperAdminID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CompanyID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
            SignInType = signInDetails[0].SignInType; // Assuming SuperAdminID is available in SignInDetails
            SignInID = signInDetails[0].CompanyID;
        } else if (signInDetails[0].SignInType === "User") {
            CompanyID = signInDetails[0].CompanyID; // Use UserID for User type
            SignInType = signInDetails[0].SignInType; // Assuming SuperAdminID is available in SignInDetails
            SignInID = signInDetails[0].UserID;
        }
        let data = {
            "CompanyID": CompanyID,
            "SignInType": SignInType,
            "SignInID": SignInID
        }
        if (ModuleID) {
            data.ModuleID = ModuleID
        }
        fetch(`${baseURL}/excomatixservices/api/dashboard/GetPublicDasboards`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomDashboards(resp.GraphLibrary))
            })
    }
}
export const loadCustomviews = (CustomDashboardID, SignInType, SignInID, ModuleID) => {
    return function (dispatch) {
        let data = {}
        if (CustomDashboardID) {
            data.CustomDashboardID = CustomDashboardID;
        }
        else if (SignInType && SignInID && ModuleID) {
            data.SignInType = SignInType;
            data.SignInID = SignInID;
            data.ModuleID = ModuleID;
        }
        fetch(`${baseURL}/excomatixservices/api/dashboard/GetCustomView`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getCustomViews(resp.GraphLibrary))
            })
    }
}
// Custom Dashboard

// Notifications
export const loadNotificationsData = (notificationId) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let NotifyToType = null;
        let NotifyToID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            NotifyToType = signInDetails[0].SignInType; // Assuming SuperAdminID is available in SignInDetails
            NotifyToID = signInDetails[0].SuperAdminID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            NotifyToType = signInDetails[0].SignInType; // Assuming SuperAdminID is available in SignInDetails
            NotifyToID = signInDetails[0].CompanyID;
        } else if (signInDetails[0].SignInType === "User") {
            NotifyToType = signInDetails[0].SignInType; // Assuming SuperAdminID is available in SignInDetails
            NotifyToID = signInDetails[0].UserID;
        }
        let data = {
            "NotifyToType": NotifyToType,
            "NotifyToID": NotifyToID
        }
        if (notificationId) {
            data.NotificationUserID = notificationId
        }
        fetch(`${baseURL}/excomatixservices/api/Notification/GetNotificationDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getNotifications(resp.Notification))
            })
    }
}
export const loadSingleNotificationsData = (notificationId, fetchNotificationData) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let NotifyToType = null;
        let NotifyToID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            NotifyToType = signInDetails[0].SignInType; // Assuming SuperAdminID is available in SignInDetails
            NotifyToID = signInDetails[0].SuperAdminID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            NotifyToType = signInDetails[0].SignInType; // Assuming SuperAdminID is available in SignInDetails
            NotifyToID = signInDetails[0].CompanyID;
        } else if (signInDetails[0].SignInType === "User") {
            NotifyToType = signInDetails[0].SignInType; // Assuming SuperAdminID is available in SignInDetails
            NotifyToID = signInDetails[0].UserID;
        }
        let data = {
            "NotifyToType": NotifyToType,
            "NotifyToID": NotifyToID
        }
        if (notificationId) {
            data.NotificationUserID = notificationId
        }
        fetch(`${baseURL}/excomatixservices/api/Notification/GetNotificationDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSingleNotifications(resp.Notification));
                fetchNotificationData();
            })
    }
}
// Notifications

// Leave Management Dashboard
export const loadLeaveStatusChartData = (userName, monthId, year, type) => {
    return function (dispatch) {
        const requestBody = {
            "EmailID": storedEmail,
            "UserID": userName,
            "MonthID": monthId,
            "Year": year
        };

        // Conditionally add the AssignedToUserID if assignedToId is provided
        if (userName) {
            requestBody.UserID = userName;
        }

        // Conditionally add the SLATypeID if slaTypeId is provided
        if (monthId) {
            requestBody.MonthID = monthId;
        }

        if (year) {
            requestBody.Year = year;
        }
        fetch(`${baseURL}/excomatixservices/api/Leave/GetLeavesGroupByStatusDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLeaveStatusChartData(resp.Month));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadLeaveDashboardCardData = (setLoading) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let data = {};

        if (signInDetails[0].SignInType === "User") {
            data = {
                UserID: signInDetails[0].UserID,
                UserType: signInDetails[0].SignInType
            };
        }
        // For SuperAdmin & ClientAdmin, `data` stays empty

        fetch(`${baseURL}/excomatixservices/api/Leave/GetLeavesDashboardCardDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLeaveDashboardCardData(resp.Header));
                setLoading(false);
            });
    };
};

export const loadLeaveDashboardLeaveTypeChartData = (monthId, year, leaveId) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        // Default null
        let userID = null;

        // If logged in as User, assign UserID
        if (signInDetails?.[0]?.SignInType === "User") {
            userID = signInDetails[0].UserID;
        }
        const requestBody = {
            // "EmailID": storedEmail,
            "MonthID": monthId,
            "Year": year,
            "LeaveTypeID": leaveId,
            "UserID": userID
        };

        // Conditionally add the SLATypeID if slaTypeId is provided
        if (monthId) {
            requestBody.MonthID = monthId;
        }

        if (year) {
            requestBody.Year = year;
        }

        if (leaveId) {
            requestBody.LeaveTypeID = leaveId;
        }

        fetch(`${baseURL}/excomatixservices/api/Leave/GetLeavesGroupByLeaveTypeDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLeaveDashboardLeaveTypeChartData(resp.Month));
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadLeaveOverAllStatusChartData = (userName, monthId, year, type) => {
    return function (dispatch) {
        const requestBody = {
            "EmailID": storedEmail,
            "UserID": userName,
            "MonthID": monthId,
            "Year": year
        };

        // Conditionally add the AssignedToUserID if assignedToId is provided
        if (userName) {
            requestBody.UserID = userName;
        }

        // Conditionally add the SLATypeID if slaTypeId is provided
        if (monthId) {
            requestBody.MonthID = monthId;
        }

        if (year) {
            requestBody.Year = year;
        }
        fetch(`${baseURL}/excomatixservices/api/Leave/GetLeavesGroupByStatusDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getLeaveOverAllStatusChartData(resp.Month));
            })
            .catch((err) => { console.log(err) });
    };
};
// Leave Management Dashboard

// Dashboard Category
export const loadSettingsDashboardCategory = (
    setLoading,
    pageSize,
    currentPage,
    statusID,
    DashboardCategoryID
) => {
    return function (dispatch) {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].CompanyID; // Use UserID for User type
        }

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "CompanyID": CustomerID,
            "PageSize": pageSize,
            "PageIndex": currentPage
        };

        if (statusID) {
            requestBody.StatusID = statusID;
        }

        if (DashboardCategoryID) {
            requestBody.DashboardCategoryID = DashboardCategoryID
        }

        fetch(`${baseURL}/excomatixservices/api/Dashboard/GetDashboardCategoryDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getDashboardCategoryData(resp.DashboardCategory));
                dispatch(getToataldataCount(resp.RecordCount))
                setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const postDashboardCategoryDatas = (
    postRequest,
    cancelModal,
    fetchDashboardCategory,
    dashboardCategoryId,
) => {
    return function (dispatch) {
        const url = dashboardCategoryId ?
            `${baseURL}/excomatixservices/api/Dashboard/PostUpdateDashboardCategory`
            :
            `${baseURL}/excomatixservices/api/Dashboard/PostAddDashboardCategory`
        fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postDashboardCategoryData());
                    fetchDashboardCategory();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
export const loadSettingsSingleDashboardCategoryData = (
    setDataLoading,
    dashboardCategoryId
) => {
    return function (dispatch) {

        // Prepare the body for the request, including SearchText if provided
        const requestBody = {
            "DashboardCategoryID": dashboardCategoryId,
        };
        setDataLoading(true);
        fetch(`${baseURL}/excomatixservices/api/Dashboard/GetDashboardCategoryDetails`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody)
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (dashboardCategoryId !== null) {
                    dispatch(getSingleDashboardCategoryData(resp.DashboardCategory));
                    // dispatch(getToataldataCount(resp.RecordCount))
                    setDataLoading(false);
                } else {
                    dispatch(getSingleDashboardCategoryData(resp.DashboardCategory));
                    // dispatch(getToataldataCount(resp.RecordCount))
                    setDataLoading(false);
                }
            })
            .catch((err) => { console.log(err) });
    };
};
export const postDashboardCategoryBulkDatas = (
    postRequest,
    cancelModal,
    fetchDynamicDashboards,
    setBulkUploadErrorMessage,
    setBulkUploadErrorFilePath
) => {
    return function (dispatch) {
        fetch(`${baseURL}/excomatixservices/api/Roles/PostBulkAddDashboardCategory`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Success === 1) {
                    dispatch(postDashboardCategoryBulkData());
                    cancelModal();
                    fetchDynamicDashboards();
                    Swal.fire({
                        title: 'Success',
                        text: resp.Msg,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.Msg; // Extract error message
                    setBulkUploadErrorMessage(errorMessage);
                    // ✅ Save the error file path
                    if (resp.FilePath) {
                        setBulkUploadErrorFilePath(resp.FilePath);
                    }
                }
            })
            .catch((err) => { console.log(err) });
    }
};
// Dashboard Category

// Bulk Upload Template
export const loadBulkUploadTemplates = (
    postRequest,
    setIsDownloading,
    setIsDownloadComplete,
    fileName
) => {
    return function (dispatch) {
        setIsDownloading(true);
        setIsDownloadComplete(false);

        fetch(`${baseURL}/excomatixservices/api/Template/GetBulkUploadSample`, postRequest)
            .then((resp) => {
                if (!resp.ok) throw new Error("Failed to download template");
                return resp.blob(); // get the file blob
            })
            .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName; // Customize filename
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);

                dispatch(getBulkUploadTemplate());
                setIsDownloadComplete(true);
                setTimeout(() => setIsDownloadComplete(false), 3000);
            })
            .catch((err) => {
                console.error("Download error:", err);
            })
            .finally(() => {
                setIsDownloading(false);
            });
    };
};
// Bulk Upload Template